import React from 'react';

const ContactIcon = () => (
  <svg
    className="prefix__animated"
    id="prefix__freepik_stories-new-entries"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 700 700"
  >
    <g
      id="prefix__freepik--Floor--inject-40"
      className="prefix__animable"
      style={{
        transformOrigin: "249.998px 355.001px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedRight",
        animationDelay: "0s",
      }}
    >
      <path
        id="prefix__freepik--floor--inject-40"
        d="M77.67 454.51c-95.18-54.95-95.18-144 0-199s249.49-55 344.66 0 95.18 144 0 199-249.49 54.95-344.66 0z"
        style={{
          transformOrigin: "249.998px 355.001px",
        }}
        className="prefix__animable"
        fill="#fafafa"
      />
    </g>
    <g
      id="prefix__freepik--Shadows--inject-40"
      className="prefix__animable"
      style={{
        transformOrigin: "311.739px 378.74px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
        animationDelay: "0s",
      }}
    >
      <path
        id="prefix__freepik--Shadow--inject-40"
        d="M363.69 282.19c-11.24 6.49-11.24 17 0 23.5s29.46 6.49 40.7 0 11.24-17 0-23.5-29.46-6.48-40.7 0z"
        style={{
          transformOrigin: "384.04px 293.942px",
        }}
        className="prefix__animable"
        fill="#e0e0e0"
      />
      <path
        id="prefix__freepik--shadow--inject-40"
        d="M337 479.38l-116.65-67.24c-1.81-1-1.81-2.74 0-3.78l125.18-72.14a7.22 7.22 0 016.56 0l116.61 67.24c1.81 1 1.81 2.74 0 3.78l-125.19 72.14a7.2 7.2 0 01-6.51 0z"
        style={{
          transformOrigin: "344.525px 407.795px",
        }}
        className="prefix__animable"
        fill="#e6e6e6"
      />
      <path
        id="prefix__freepik--shadow--inject-40"
        d="M168.42 407.74c-20 11.55-20 30.28 0 41.84s52.45 11.55 72.46 0 20-30.29 0-41.84-52.45-11.55-72.46 0z"
        style={{
          transformOrigin: "204.652px 428.662px",
        }}
        className="prefix__animable"
        fill="#e6e6e6"
      />
    </g>
    <g
      id="prefix__freepik--Window--inject-40"
      className="prefix__animable"
      style={{
        transformOrigin: "423.805px 135.08px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--window--inject-40"
        className="prefix__animable"
        style={{
          transformOrigin: "423.805px 135.08px",
        }}
      >
        <g
          id="prefix__freepik--window--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "423.805px 135.08px",
          }}
        >
          <g
            id="prefix__freepik--Frame--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "423.805px 135.08px",
            }}
          >
            <path
              style={{
                transformOrigin: "423.8px 222.235px",
              }}
              id="prefix__elo9f41959bld"
              className="prefix__animable"
              fill="#fafafa"
              d="M463.32 243.73l-2.26 1.34-76.78-44.33 2.25-1.34 76.79 44.33z"
            />
            <path
              style={{
                transformOrigin: "423.795px 135.07px",
              }}
              id="prefix__elmeawnj8o54"
              className="prefix__animable"
              fill="#fff"
              d="M386.53 199.4l74.53 43.02V70.73l-74.53-43.01V199.4z"
            />
            <path
              d="M380 203.2l85.3 49.25V68.27L380 19zm4.26-176.8l76.78 44.33v174.34l-76.78-44.33z"
              style={{
                transformOrigin: "422.65px 135.725px",
              }}
              id="prefix__elkkcdb2xx7h"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <path
              style={{
                transformOrigin: "385.405px 113.57px",
              }}
              id="prefix__elvjgzc4675g"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M384.28 200.74l2.25-1.34V27.72l-2.25-1.32v174.34z"
            />
            <path
              style={{
                transformOrigin: "422.67px 162.495px",
              }}
              id="prefix__eln4bzetswtdl"
              className="prefix__animable"
              fill="#fafafa"
              d="M461.06 182.68v2.65L384.28 141l2.25-1.34 74.53 43.02z"
            />
            <path
              style={{
                transformOrigin: "422.67px 102.725px",
              }}
              id="prefix__eltj5kre9pt1"
              className="prefix__animable"
              fill="#fafafa"
              d="M461.06 122.92v2.64l-76.78-44.33 2.25-1.34 74.53 43.03z"
            />
            <path
              style={{
                transformOrigin: "423.815px 42.99px",
              }}
              id="prefix__el8vy84zbsa3"
              className="prefix__animable"
              fill="#fafafa"
              d="M380.02 19.02l2.29-1.31 85.3 49.25-2.29 1.31-85.3-49.25z"
            />
            <path
              style={{
                transformOrigin: "466.465px 159.705px",
              }}
              id="prefix__elig82efvzz1s"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M467.61 66.96l-2.29 1.31v184.18l2.29-1.31V66.96z"
            />
            <path
              style={{
                transformOrigin: "427.075px 137.62px",
              }}
              id="prefix__elwyuj47ra69g"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M428.22 51.77l-2.29-1.33V224.8l2.29-1.31V51.77z"
            />
          </g>
          <path
            style={{
              transformOrigin: "423.8px 136.4px",
            }}
            id="prefix__el4q8p3qof9y7"
            className="prefix__animable"
            fill="#f0f0f0"
            d="M421.67 48l4.26 2.44V224.8l-4.26-2.47V48z"
          />
          <path
            style={{
              transformOrigin: "422.67px 105.86px",
            }}
            id="prefix__elyhk2o39h8e"
            className="prefix__animable"
            fill="#f0f0f0"
            d="M380.02 78.78v4.91l85.3 49.25v-4.91l-85.3-49.25z"
          />
          <path
            style={{
              transformOrigin: "422.67px 165.61px",
            }}
            id="prefix__elva9kwj6y3z"
            className="prefix__animable"
            fill="#f0f0f0"
            d="M380.02 138.53v4.91l85.3 49.25v-4.91l-85.3-49.25z"
          />
          <path
            style={{
              transformOrigin: "443.495px 114.755px",
            }}
            id="prefix__elftl08xjlxm"
            className="prefix__animable"
            fill="#fafafa"
            d="M425.93 105.28l2.29-1.33 32.84 18.97v2.64l-35.13-20.28z"
          />
          <path
            style={{
              transformOrigin: "443.495px 174.505px",
            }}
            id="prefix__eljbjwc8t5t9f"
            className="prefix__animable"
            fill="#fafafa"
            d="M425.93 165.02l2.29-1.32 32.84 18.96v2.65l-35.13-20.29z"
          />
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--Pictures--inject-40"
      className="prefix__animable"
      style={{
        transformOrigin: "95.55px 78.375px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--pictures--inject-40"
        className="prefix__animable"
        style={{
          transformOrigin: "95.55px 78.375px",
        }}
      >
        <g
          id="prefix__freepik--Picture--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "129.275px 58.905px",
          }}
        >
          <g
            id="prefix__freepik--frame--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "129.275px 58.905px",
            }}
          >
            <path
              style={{
                transformOrigin: "129.285px 80.68px",
              }}
              id="prefix__elxs1c4gabztg"
              className="prefix__animable"
              fill="#fafafa"
              d="M107.59 92.02l2.02 1.2 41.37-23.88-2.01-1.2-41.38 23.88z"
            />
            <path
              style={{
                transformOrigin: "129.29px 58.895px",
              }}
              id="prefix__elzbhv30wwm1p"
              className="prefix__animable"
              fill="#fff"
              d="M148.97 68.14l-39.36 22.71V49.64l39.36-22.7v41.2z"
            />
            <path
              d="M154.79 19.17l-49 28.28v52.36l49-28.27zM151 69.34l-41.39 23.89V49.64L151 25.76z"
              style={{
                transformOrigin: "130.29px 59.49px",
              }}
              id="prefix__el1bkyyd8yoma"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <path
              style={{
                transformOrigin: "149.975px 47.55px",
              }}
              id="prefix__ell964jt2mn1a"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M150.98 69.34l-2.01-1.2v-41.2l2.01-1.18v43.58z"
            />
            <path
              style={{
                transformOrigin: "129.275px 32.725px",
              }}
              id="prefix__eluqeuj0ltgb9"
              className="prefix__animable"
              fill="#fafafa"
              d="M154.79 19.17L152.74 18l-48.98 28.27 2.05 1.18 48.98-28.28z"
            />
            <path
              style={{
                transformOrigin: "104.785px 73.04px",
              }}
              id="prefix__elmyf3zjxptpo"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M103.76 46.27l2.05 1.18v52.36l-2.05-1.17V46.27z"
            />
          </g>
          <g
            id="prefix__freepik--Land--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "129.29px 65.755px",
            }}
          >
            <path
              style={{
                transformOrigin: "129.29px 65.755px",
              }}
              id="prefix__elxjf38j5fb7e"
              className="prefix__animable"
              fill="#f0f0f0"
              d="M147.43 66.91l-36.28 20.94V77.38l9.07-20.95 5.65 5.24-2.03 8.78 12.53-26.79 11.06 12.77v10.48z"
            />
            <path
              d="M125.53 46.32a5.91 5.91 0 00-2.68 4.68c0 1.71 1.2 2.4 2.68 1.55a6 6 0 002.68-4.65c0-1.74-1.21-2.44-2.68-1.58z"
              style={{
                transformOrigin: "125.53px 49.4332px",
              }}
              id="prefix__el8tc7r4wptff"
              className="prefix__animable"
              fill="#f0f0f0"
            />
          </g>
        </g>
        <g
          id="prefix__freepik--picture--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "61.82px 97.845px",
          }}
        >
          <g
            id="prefix__freepik--frame--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "61.82px 97.845px",
            }}
          >
            <path
              style={{
                transformOrigin: "61.835px 119.625px",
              }}
              id="prefix__elwpwl0ruysqm"
              className="prefix__animable"
              fill="#fafafa"
              d="M40.14 130.96l2.02 1.21 41.37-23.89-2.02-1.2-41.37 23.88z"
            />
            <path
              style={{
                transformOrigin: "61.835px 97.835px",
              }}
              id="prefix__el83th5ak5ysg"
              className="prefix__animable"
              fill="#fff"
              d="M81.51 107.08l-39.35 22.71V88.58l39.35-22.7v41.2z"
            />
            <path
              d="M87.33 58.11l-49 28.28v52.36l49-28.27zm-3.8 50.17l-41.37 23.89V88.58L83.53 64.7z"
              style={{
                transformOrigin: "62.83px 98.43px",
              }}
              id="prefix__elqiogd88o5sh"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <path
              style={{
                transformOrigin: "82.52px 86.49px",
              }}
              id="prefix__elxyu85f6d1w9"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M83.53 108.28l-2.02-1.2v-41.2l2.02-1.18v43.58z"
            />
            <path
              style={{
                transformOrigin: "61.82px 71.665px",
              }}
              id="prefix__ely5o0sfa1jjo"
              className="prefix__animable"
              fill="#fafafa"
              d="M87.33 58.11l-2.05-1.17-48.97 28.28 2.04 1.17 48.98-28.28z"
            />
            <path
              style={{
                transformOrigin: "37.33px 111.985px",
              }}
              id="prefix__elkmw680o5qxa"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M36.31 85.22l2.04 1.17v52.36l-2.04-1.17V85.22z"
            />
          </g>
          <g
            id="prefix__freepik--land--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "61.835px 104.695px",
            }}
          >
            <path
              style={{
                transformOrigin: "61.835px 104.695px",
              }}
              id="prefix__elppyho0egm0o"
              className="prefix__animable"
              fill="#f0f0f0"
              d="M79.98 105.85l-36.29 20.94v-10.47l9.08-20.95 5.65 5.24-2.04 8.78L68.91 82.6l11.07 12.77v10.48z"
            />
            <path
              d="M58.07 85.26a5.91 5.91 0 00-2.68 4.65c0 1.71 1.2 2.4 2.68 1.55a5.93 5.93 0 002.69-4.65c0-1.71-1.2-2.41-2.69-1.55z"
              style={{
                transformOrigin: "58.075px 88.3578px",
              }}
              id="prefix__elvs51rzc641d"
              className="prefix__animable"
              fill="#f0f0f0"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--Screen--inject-40"
      className="prefix__animable prefix__animator-active"
      style={{
        transformOrigin: "164.685px 208.675px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn,1.5s Infinite linear floating",
        animationDelay: "0s,1s",
      }}
    >
      <g
        id="prefix__freepik--window--inject-40"
        className="prefix__animable"
        style={{
          transformOrigin: "164.685px 208.675px",
        }}
      >
        <path
          d="M292.77 32.92l-6.56-3.82-249.6 144.11V390.7c0 2.23.78 3.8 2 4.53l6.56 3.82c1.26.73 3 .63 5-.49l235.6-136a15.46 15.46 0 007-12.12z"
          style={{
            transformOrigin: "164.69px 214.308px",
          }}
          id="prefix__el4eg0nuqkrqm"
          className="prefix__animable"
          fill="#e6e6e6"
        />
        <path
          d="M47 398.71a5.55 5.55 0 002.72-.85l235.61-136a14.6 14.6 0 006.67-11.45V34.32L44 177.49v217c0 2.65 1.12 4.22 3 4.22z"
          style={{
            transformOrigin: "168px 216.515px",
          }}
          id="prefix__el66mp6kve26s"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M291.15 35.72v214.69a13.91 13.91 0 01-6.15 10.72l-235.6 136a4.77 4.77 0 01-2.32.74c-2 0-2.26-2.36-2.26-3.38V178L291.15 35.72m1.62-2.8L43.17 177v217.52c0 3.17 1.57 5 3.87 5a6.38 6.38 0 003.13-1l235.6-136a15.46 15.46 0 007-12.12V32.92z"
          style={{
            transformOrigin: "167.97px 216.22px",
          }}
          id="prefix__elf8tamxp8yue"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          style={{
            transformOrigin: "167.97px 121.91px",
          }}
          id="prefix__el1z3rlcq03amj"
          className="prefix__animable"
          fill="#22c4d6"
          d="M43.17 177.03v33.87l249.6-144.11V32.92L43.17 177.03z"
        />
        <path
          d="M284.22 18.34c-1.27-.78-3-.69-5 .44L43.6 154.82a15.46 15.46 0 00-7 12.12v6.27l6.57 3.79 249.6-144.08v-6.28c0-2.22-.78-3.77-2-4.51s-5.41-3.13-6.55-3.79z"
          style={{
            transformOrigin: "164.685px 97.4149px",
          }}
          id="prefix__el15s7rc87tls"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M43.17 170.75a15.46 15.46 0 017-12.12l235.6-136c3.86-2.23 7-.42 7 4v6.28L43.17 177z"
          style={{
            transformOrigin: "167.97px 99.3372px",
          }}
          id="prefix__eltt0zfw8631p"
          className="prefix__animable"
          fill="#37474f"
        />
        <path
          d="M290.81 22.17c-1.28-.79-3.05-.71-5 .43l-235.6 136a14.33 14.33 0 00-5 5.22l-6.57-3.8a14.22 14.22 0 015-5.23l235.6-136c2-1.13 3.75-1.21 5-.44s5.35 3.1 6.53 3.78a.15.15 0 00.04.04z"
          style={{
            transformOrigin: "164.725px 90.8321px",
          }}
          id="prefix__elptw8c75mvzj"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M268.33 37.51a5.41 5.41 0 00-2.44 4.24c0 1.55 1.09 2.19 2.44 1.41a5.42 5.42 0 002.45-4.24c0-1.55-1.1-2.19-2.45-1.41z"
          style={{
            transformOrigin: "268.335px 40.335px",
          }}
          id="prefix__el91n2mk8gkxt"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M276.88 32.59a5.39 5.39 0 00-2.44 4.23c0 1.56 1.09 2.19 2.44 1.41a5.4 5.4 0 002.45-4.23c0-1.56-1.1-2.19-2.45-1.41z"
          style={{
            transformOrigin: "276.885px 35.41px",
          }}
          id="prefix__ell8cfc9qbopj"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M285.43 27.66A5.41 5.41 0 00283 31.9c0 1.55 1.09 2.19 2.44 1.41a5.42 5.42 0 002.45-4.24c-.01-1.55-1.11-2.19-2.46-1.41z"
          style={{
            transformOrigin: "285.445px 30.485px",
          }}
          id="prefix__elarb5gmwxauj"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          style={{
            transformOrigin: "39.89px 192.055px",
          }}
          id="prefix__el3dedtako9pr"
          className="prefix__animable"
          fill="#22c4d6"
          d="M43.17 177.03l-6.56-3.82v33.9l6.56 3.79v-33.87z"
        />
        <g id="prefix__el99y2k5dptv">
          <path
            style={{
              transformOrigin: "39.89px 192.055px",
            }}
            className="prefix__animable"
            id="prefix__elp5s86zb951m"
            opacity={0.1}
            d="M43.17 177.03l-6.56-3.82v33.9l6.56 3.79v-33.87z"
          />
        </g>
        <g id="prefix__elpp45n5frpon">
          <path
            style={{
              transformOrigin: "39.89px 192.055px",
            }}
            className="prefix__animable"
            id="prefix__elqdnie9v992i"
            opacity={0.2}
            d="M43.17 177.03l-6.56-3.82v33.9l6.56 3.79v-33.87z"
          />
        </g>
        <path
          d="M67.19 180.22c0 5.95-3.62 12.86-8.08 15.44S51 195.5 51 189.55s3.62-12.87 8.09-15.45 8.1.16 8.1 6.12z"
          style={{
            transformOrigin: "59.095px 184.88px",
          }}
          id="prefix__el7xzx7o4kkl4"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M59.11 192.08a1.63 1.63 0 01-1.64-1.64v-11.12a1.64 1.64 0 113.27 0v11.12a1.63 1.63 0 01-1.63 1.64z"
          style={{
            transformOrigin: "59.105px 184.816px",
          }}
          id="prefix__elp4youvug4n"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M54.94 188.93a1.64 1.64 0 01-.82-3.06l8.34-4.81a1.64 1.64 0 111.64 2.83l-8.35 4.82a1.59 1.59 0 01-.81.22z"
          style={{
            transformOrigin: "59.1632px 184.852px",
          }}
          id="prefix__els6n6dw3fafh"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M83.4 178.92c-.19.12-.34.13-.44.06l-.22-.19-4.74-6.7v9.36a1.13 1.13 0 01-.13.51.93.93 0 01-.33.37l-1.37.79a.29.29 0 01-.33 0 .43.43 0 01-.13-.36v-14.65a1.07 1.07 0 01.13-.51.86.86 0 01.33-.37l1.19-.69c.19-.11.34-.12.44 0a1.66 1.66 0 01.22.19l4.77 6.69V164a1.13 1.13 0 01.13-.51.93.93 0 01.33-.37l1.38-.79a.27.27 0 01.32 0 .42.42 0 01.14.35v14.67a1.16 1.16 0 01-.14.51 1 1 0 01-.32.37z"
          style={{
            transformOrigin: "80.3993px 172.725px",
          }}
          id="prefix__eli9q7m6iue8"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M87.12 170.88a11.23 11.23 0 01.29-2.56 11.41 11.41 0 01.83-2.43 9.13 9.13 0 011.32-2.07 6.49 6.49 0 011.73-1.48 3.42 3.42 0 011.72-.53 2 2 0 011.32.49 2.94 2.94 0 01.85 1.35 6.36 6.36 0 01.29 2v1a1.07 1.07 0 01-.13.51.85.85 0 01-.32.37l-5.69 3.28a1.75 1.75 0 00.16.83.89.89 0 00.44.42 1 1 0 00.63 0 2.37 2.37 0 00.73-.28 4.29 4.29 0 00.88-.66 3.51 3.51 0 00.56-.7 5.1 5.1 0 01.31-.43 1.42 1.42 0 01.32-.25l1.37-.79a.3.3 0 01.33 0 .4.4 0 01.13.36 3.72 3.72 0 01-.27 1 7.1 7.1 0 01-.74 1.4 9.68 9.68 0 01-1.18 1.58 7.44 7.44 0 01-1.67 1.31 3.63 3.63 0 01-1.73.56 1.89 1.89 0 01-1.32-.5 3.21 3.21 0 01-.83-1.46 7.85 7.85 0 01-.33-2.32zm4.17-5.81a3.35 3.35 0 00-.85.68 4.34 4.34 0 00-.58.84 4.53 4.53 0 00-.37.89 4.8 4.8 0 00-.16.81l3.85-2.23a5.19 5.19 0 00-.13-.64 1 1 0 00-.31-.5.84.84 0 00-.56-.18 2.09 2.09 0 00-.89.33z"
          style={{
            transformOrigin: "91.2952px 168.485px",
          }}
          id="prefix__elfwyk5me6cl"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M105.72 161.27l1.54-7.37a2.89 2.89 0 01.14-.45.7.7 0 01.33-.37l1.3-.75a.29.29 0 01.32 0 .43.43 0 01.14.36 1 1 0 010 .17l-2.57 11.94a4.42 4.42 0 01-.15.48.85.85 0 01-.35.38l-1.29.74c-.16.09-.27.1-.33 0a1.15 1.15 0 01-.16-.29L103 161l-1.66 7a3 3 0 01-.16.48.74.74 0 01-.33.37l-1.29.75c-.16.09-.27.09-.34 0a.86.86 0 01-.16-.3l-2.57-9a.57.57 0 010-.14 1.14 1.14 0 01.13-.52.83.83 0 01.33-.36l1.29-.75c.16-.09.27-.09.33 0a1.51 1.51 0 01.15.28l1.53 5.61 1.63-7.44a2 2 0 01.16-.46.88.88 0 01.32-.36l1.29-.75a.27.27 0 01.32 0 .54.54 0 01.16.27z"
          style={{
            transformOrigin: "102.99px 160.975px",
          }}
          id="prefix__elxyrlycm2a7r"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M114.27 155.2a11.89 11.89 0 01.29-2.56 11.41 11.41 0 01.83-2.43 10.43 10.43 0 011.32-2.07 6.42 6.42 0 011.73-1.47 3.38 3.38 0 011.73-.54 2.1 2.1 0 011.32.49 3 3 0 01.84 1.35 6.35 6.35 0 01.3 2v1a1.08 1.08 0 01-.14.5.85.85 0 01-.32.37l-5.69 3.29a1.73 1.73 0 00.17.82.84.84 0 00.43.42 1.09 1.09 0 00.63.05 2.58 2.58 0 00.73-.29 3.9 3.9 0 001.45-1.36 3.4 3.4 0 01.3-.42 1.12 1.12 0 01.33-.26l1.36-.79a.3.3 0 01.33 0 .38.38 0 01.13.36 3.61 3.61 0 01-.26 1 8.18 8.18 0 01-.75 1.41 10.58 10.58 0 01-1.21 1.52 7.25 7.25 0 01-1.68 1.3 3.5 3.5 0 01-1.73.56 1.88 1.88 0 01-1.32-.5 3.16 3.16 0 01-.83-1.46 8.2 8.2 0 01-.29-2.29zm4.17-5.81a3.34 3.34 0 00-.84.68 4.39 4.39 0 00-.59.84 4 4 0 00-.36.89 4.91 4.91 0 00-.17.81l3.85-2.22a3.46 3.46 0 00-.13-.64 1 1 0 00-.3-.51.81.81 0 00-.57-.17 1.93 1.93 0 00-.89.32z"
          style={{
            transformOrigin: "118.45px 152.79px",
          }}
          id="prefix__el1777941c9it"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M132.79 149.8a1.13 1.13 0 01-.13.51 1 1 0 01-.33.37l-1.29.74a.27.27 0 01-.33 0 .42.42 0 01-.13-.35v-5.77a2.88 2.88 0 00-.48-1.9c-.32-.37-.8-.36-1.46 0a3.55 3.55 0 00-1.42 1.64 5.77 5.77 0 00-.52 2.48v5.77a1.16 1.16 0 01-.14.51 1 1 0 01-.32.37l-1.3.74a.27.27 0 01-.32 0 .43.43 0 01-.14-.36V144a1.09 1.09 0 01.14-.51.85.85 0 01.32-.37l1.3-.75a.27.27 0 01.32 0 .41.41 0 01.14.35v.52a8.73 8.73 0 011-1.57 5 5 0 011.41-1.21 3.38 3.38 0 011.74-.57 1.52 1.52 0 011.12.51 2.92 2.92 0 01.6 1.34 9.53 9.53 0 01.18 1.93z"
          style={{
            transformOrigin: "128.634px 147.426px",
          }}
          id="prefix__elrl2t238x15l"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M138 143.17a1.27 1.27 0 00.28 1c.19.17.54.11 1.05-.19l1-.6a.27.27 0 01.32 0 .41.41 0 01.13.35v1.5a1.07 1.07 0 01-.13.51.92.92 0 01-.32.37l-1.26.72q-1.6.93-2.46.39c-.58-.36-.86-1.25-.86-2.67v-4.88l-1.13.65a.29.29 0 01-.32 0 .43.43 0 01-.14-.36v-1.5a1.16 1.16 0 01.14-.51.88.88 0 01.32-.36l1.13-.65v-3.7a1.07 1.07 0 01.13-.51.81.81 0 01.33-.37l1.29-.75a.27.27 0 01.32 0 .41.41 0 01.14.35v3.7l2.2-1.27a.27.27 0 01.32 0 .41.41 0 01.13.35v1.5a1.13 1.13 0 01-.13.51 1 1 0 01-.32.37l-2.2 1.26z"
          style={{
            transformOrigin: "137.47px 139.488px",
          }}
          id="prefix__eloisraewbsce"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M146.58 133.37a3.66 3.66 0 00-1.47 1.45 4.83 4.83 0 00-.45 2.23V143a1.16 1.16 0 01-.14.51 1 1 0 01-.32.37l-1.3.74a.26.26 0 01-.32 0 .42.42 0 01-.14-.35v-10.62a1.09 1.09 0 01.14-.51.92.92 0 01.32-.37l1.3-.75a.27.27 0 01.32 0 .41.41 0 01.14.35v.52a8.31 8.31 0 01.94-1.38 5.12 5.12 0 011.32-1.06l.77-.44a.27.27 0 01.32 0 .43.43 0 01.14.36v1.49a1.09 1.09 0 01-.14.51.85.85 0 01-.32.37z"
          style={{
            transformOrigin: "145.295px 137.316px",
          }}
          id="prefix__el6mbltek68r"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M152.25 138.54l-3.37-8.45a.61.61 0 010-.15 1.16 1.16 0 01.14-.51 1 1 0 01.32-.37l1.28-.73a.34.34 0 01.36 0 .48.48 0 01.2.25l2.26 5.7 2.27-8.32a1.82 1.82 0 01.2-.48 1 1 0 01.36-.39l1.28-.73a.26.26 0 01.32 0 .42.42 0 01.14.35.88.88 0 010 .17l-4.78 17.56a2.4 2.4 0 01-.21.49 1 1 0 01-.36.38l-1.27.74a.3.3 0 01-.33 0 .43.43 0 01-.13-.36 1 1 0 010-.17z"
          style={{
            transformOrigin: "153.445px 134.202px",
          }}
          id="prefix__elby7p80mp8nv"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M51.8 230a1.14 1.14 0 01-.58-.15 1.65 1.65 0 01-.7-1.48v-11.21a3.6 3.6 0 011.54-2.9l43.15-24.91a1.32 1.32 0 011.35-.07 1.61 1.61 0 01.69 1.47v11.17a3.57 3.57 0 01-1.54 2.89l-43.15 24.92a1.5 1.5 0 01-.76.27zM96 190.12a.67.67 0 00-.26.09l-43.18 24.92a2.62 2.62 0 00-1 2v11.16c0 .34.1.55.2.61s.27 0 .34-.07L95.21 204a2.61 2.61 0 001-2v-11.25a.78.78 0 00-.19-.61z"
          style={{
            transformOrigin: "73.8858px 209.564px",
          }}
          id="prefix__el03tja3q8u46n"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M58 216.42a.11.11 0 01.11 0 .14.14 0 010 .13v.57a.31.31 0 010 .18.33.33 0 01-.11.14l-1.09.62v4.43a.49.49 0 010 .19.3.3 0 01-.12.13l-.49.28a.08.08 0 01-.11 0A.14.14 0 0156 223v-4.43l-1.09.63a.13.13 0 01-.12 0 .17.17 0 010-.13v-.57a.41.41 0 010-.18.26.26 0 01.12-.13z"
          style={{
            transformOrigin: "56.4515px 219.759px",
          }}
          id="prefix__el9orflwozt4e"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M59.22 215.61a.11.11 0 01.11 0 .16.16 0 01.05.13v.63a.41.41 0 01-.05.18.36.36 0 01-.11.13l-.53.3a.08.08 0 01-.11 0 .15.15 0 010-.12v-.63a.49.49 0 010-.19.36.36 0 01.11-.13zm.13 5.45a.45.45 0 01-.05.18.36.36 0 01-.11.13l-.47.26a.09.09 0 01-.11 0 .17.17 0 010-.13v-3.77a.41.41 0 010-.18.36.36 0 01.11-.13l.47-.27a.11.11 0 01.11 0 .17.17 0 01.05.13z"
          style={{
            transformOrigin: "58.974px 218.622px",
          }}
          id="prefix__eloloi7hpycv"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M61.25 218.66a.43.43 0 00.1.34c.06.06.19 0 .37-.06l.37-.22a.13.13 0 01.12 0v.66a.39.39 0 010 .18.38.38 0 01-.12.13l-.45.26c-.38.22-.67.27-.88.14s-.3-.44-.3-1v-1.69l-.4.23a.09.09 0 01-.12 0 .14.14 0 010-.12V217a.41.41 0 010-.18.38.38 0 01.12-.13l.4-.23v-1.32a.31.31 0 010-.18.36.36 0 01.11-.13l.46-.27a.13.13 0 01.12 0 .17.17 0 010 .13V216l.78-.46a.11.11 0 01.11 0 .14.14 0 010 .13v.53a.31.31 0 010 .18.29.29 0 01-.11.13l-.78.45z"
          style={{
            transformOrigin: "61.0735px 217.353px",
          }}
          id="prefix__el1tyy7mrxesc"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M63.63 218.58a.39.39 0 010 .18.38.38 0 01-.12.13l-.46.27a.09.09 0 01-.12 0v-5.43a.39.39 0 010-.18.38.38 0 01.12-.13l.46-.27a.13.13 0 01.12 0 .17.17 0 010 .13z"
          style={{
            transformOrigin: "63.2812px 216.159px",
          }}
          id="prefix__elxo43fvgjddd"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M64.31 216.31a4.13 4.13 0 01.11-.92 3.63 3.63 0 01.29-.86 3.72 3.72 0 01.47-.74 2.32 2.32 0 01.62-.52 1.13 1.13 0 01.61-.19.7.7 0 01.47.17 1 1 0 01.3.48 2.29 2.29 0 01.11.73v.36a.41.41 0 01-.05.18.33.33 0 01-.11.14l-2 1.16a.61.61 0 00.06.3.36.36 0 00.15.15.44.44 0 00.23 0 .77.77 0 00.26-.1 1.31 1.31 0 00.31-.23 1.36 1.36 0 00.2-.25 1.49 1.49 0 01.11-.15.4.4 0 01.12-.1l.48-.28a.13.13 0 01.12 0v.13a1.45 1.45 0 01-.1.34 2.41 2.41 0 01-.26.5 4.13 4.13 0 01-.43.55 3.41 3.41 0 01-.6.46 1.28 1.28 0 01-.62.2.67.67 0 01-.47-.18 1 1 0 01-.29-.52 2.81 2.81 0 01-.09-.81zm1.49-2.07a.89.89 0 00-.3.24 1.61 1.61 0 00-.21.3 1.37 1.37 0 00-.13.31 2.15 2.15 0 00-.06.29l1.37-.79a2.23 2.23 0 000-.23.54.54 0 00-.11-.18.32.32 0 00-.2-.06.64.64 0 00-.36.12z"
          style={{
            transformOrigin: "65.7992px 215.45px",
          }}
          id="prefix__els9uv2c0xv9m"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M51.8 250.49a1.14 1.14 0 01-.58-.15 1.65 1.65 0 01-.7-1.48v-11.17a3.6 3.6 0 011.54-2.89l43.15-24.92a1.34 1.34 0 011.35-.06 1.61 1.61 0 01.69 1.47v11.17a3.57 3.57 0 01-1.54 2.89l-43.15 24.92a1.61 1.61 0 01-.76.22zM96 210.66a.66.66 0 00-.27.09l-43.17 24.92a2.62 2.62 0 00-1 2v11.17c0 .34.1.55.2.61s.27 0 .34-.07l43.15-24.91a2.61 2.61 0 001-2v-11.18a.78.78 0 00-.19-.61z"
          style={{
            transformOrigin: "73.8858px 230.078px",
          }}
          id="prefix__ela0bnrs3t6mb"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M57.73 241a.53.53 0 01.06-.19.34.34 0 01.12-.12l.49-.28a.11.11 0 01.12 0v.13a3.55 3.55 0 01-.12.74 3.26 3.26 0 01-.33.78 3.85 3.85 0 01-.55.76 3.24 3.24 0 01-.81.63 1.65 1.65 0 01-.74.26.76.76 0 01-.54-.14 1 1 0 01-.35-.51 3.08 3.08 0 01-.15-.81v-.67-.69a5.4 5.4 0 01.15-1 4 4 0 01.35-.91 4.17 4.17 0 01.54-.78 3.49 3.49 0 01.74-.59 1.94 1.94 0 01.81-.29.79.79 0 01.88.53 1.88 1.88 0 01.12.59.39.39 0 010 .18.51.51 0 01-.12.13l-.49.28a.13.13 0 01-.12 0 .15.15 0 01-.07-.12.77.77 0 00-.08-.27.48.48 0 00-.18-.17.46.46 0 00-.29 0 1.31 1.31 0 00-.42.16 1.9 1.9 0 00-.41.34 1.8 1.8 0 00-.29.43 1.9 1.9 0 00-.18.49 2.34 2.34 0 00-.08.52V241.77a1.32 1.32 0 00.08.43.53.53 0 00.18.28.36.36 0 00.29.09.84.84 0 00.41-.14 1.9 1.9 0 00.42-.31 2.48 2.48 0 00.29-.37 2.25 2.25 0 00.19-.38 1.76 1.76 0 00.08-.37z"
          style={{
            transformOrigin: "56.7303px 240.512px",
          }}
          id="prefix__elhkq6v5p6ujk"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M59.22 238.72a1.81 1.81 0 01.11-.43 2.59 2.59 0 01.25-.5 2.31 2.31 0 01.39-.51 2.79 2.79 0 01.54-.42 1.84 1.84 0 01.56-.22.67.67 0 01.43.08.63.63 0 01.27.37 1.82 1.82 0 01.1.67v2.38a.41.41 0 010 .18.29.29 0 01-.11.13l-.46.27a.13.13 0 01-.12 0 .16.16 0 01-.05-.13v-.26a2.44 2.44 0 01-.36.61 2.4 2.4 0 01-.61.52 1.17 1.17 0 01-.47.17.51.51 0 01-.35-.06.56.56 0 01-.21-.28 1.19 1.19 0 01-.08-.46 1.93 1.93 0 01.3-1 3.47 3.47 0 01.79-.89l1-.8c0-.22 0-.34-.16-.37a.53.53 0 00-.41.1.63.63 0 00-.23.19 1.8 1.8 0 00-.17.25.56.56 0 01-.1.14.28.28 0 01-.1.09l-.56.32h-.1c-.02 0-.1-.08-.09-.14zm1 1.7a1.48 1.48 0 00.36-.29 1.78 1.78 0 00.27-.36 1.65 1.65 0 00.17-.39 1.63 1.63 0 000-.36v-.08l-.82.67a1.37 1.37 0 00-.36.37.66.66 0 00-.11.36c0 .11.05.17.13.17a.59.59 0 00.37-.09z"
          style={{
            transformOrigin: "60.4648px 239.136px",
          }}
          id="prefix__elncvw2iqvcy"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M63.71 237.77a.5.5 0 00.1.35c.07.06.19 0 .38-.07l.37-.21a.09.09 0 01.11 0 .17.17 0 010 .13v.53a.49.49 0 010 .19.36.36 0 01-.11.13l-.45.26c-.38.21-.67.26-.88.13s-.31-.44-.31-.95v-1.74l-.39.24a.13.13 0 01-.12 0 .17.17 0 010-.13v-.53a.41.41 0 010-.18.26.26 0 01.12-.13l.39-.24v-1.31a.41.41 0 010-.18.34.34 0 01.12-.14l.46-.26a.08.08 0 01.11 0s.05.06.05.12v1.32l.79-.45a.08.08 0 01.11 0 .14.14 0 010 .12v.54a.41.41 0 010 .18.36.36 0 01-.11.13l-.79.45z"
          style={{
            transformOrigin: "63.54px 236.46px",
          }}
          id="prefix__elbpfkq77uuvm"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M65.16 236.36a4.13 4.13 0 01.4-1.78 3.32 3.32 0 01.47-.74 2.28 2.28 0 01.61-.52 1.16 1.16 0 01.62-.19.71.71 0 01.47.17 1 1 0 01.3.48 2.34 2.34 0 01.1.73v.36a.42.42 0 01-.16.32l-2 1.17a.6.6 0 00.06.29.33.33 0 00.16.15.4.4 0 00.22 0 .73.73 0 00.26-.11 1.39 1.39 0 00.32-.23 2.19 2.19 0 00.2-.25.73.73 0 01.11-.15.25.25 0 01.11-.09l.49-.28a.09.09 0 01.11 0 .14.14 0 010 .13 1.48 1.48 0 01-.09.35 2.79 2.79 0 01-.27.5 4.06 4.06 0 01-.43.54 2.51 2.51 0 01-.6.46 1.25 1.25 0 01-.61.2.66.66 0 01-.47-.18 1.14 1.14 0 01-.3-.52 2.78 2.78 0 01-.08-.81zm1.48-2.07a1.22 1.22 0 00-.3.24 1.61 1.61 0 00-.21.3 1.81 1.81 0 00-.19.6l1.37-.79a1 1 0 000-.23.34.34 0 00-.11-.17.27.27 0 00-.2-.07.8.8 0 00-.36.12z"
          style={{
            transformOrigin: "66.6437px 235.5px",
          }}
          id="prefix__elit8d7ul93k"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M70.17 236.37a1.07 1.07 0 00.26-.2 1.5 1.5 0 00.24-.31 1.4 1.4 0 00.18-.39 1.31 1.31 0 00.07-.44v-.3a2 2 0 01-.13.23 2.78 2.78 0 01-.19.27 2.17 2.17 0 01-.26.27 2 2 0 01-.33.24 1 1 0 01-.55.16.62.62 0 01-.42-.18 1 1 0 01-.27-.45 2.09 2.09 0 01-.12-.65v-.56a3.51 3.51 0 01.12-.78 3.35 3.35 0 01.27-.77 2.84 2.84 0 01.42-.66 1.75 1.75 0 01.55-.47 1.18 1.18 0 01.33-.15h.26a.48.48 0 01.19.05.32.32 0 01.13.08v-.18a.49.49 0 010-.19.3.3 0 01.12-.13l.46-.26a.08.08 0 01.11 0 .14.14 0 010 .12v3.79a3.46 3.46 0 01-.41 1.71 2.91 2.91 0 01-1.13 1.15 1.84 1.84 0 01-.57.23 1 1 0 01-.46 0 .67.67 0 01-.31-.24.7.7 0 01-.13-.39.31.31 0 010-.18.28.28 0 01.12-.14l.41-.24a.12.12 0 01.14 0l.11.08a.3.3 0 00.21.1.78.78 0 00.58-.22zm-.73-2.71a3.38 3.38 0 000 .45c0 .34.11.54.24.62a.54.54 0 00.51-.06 1.43 1.43 0 00.5-.53 1.87 1.87 0 00.23-.8 3 3 0 000-.32 2.63 2.63 0 000-.3.66.66 0 00-.23-.53.49.49 0 00-.5.05 1.41 1.41 0 00-.51.52 2.23 2.23 0 00-.24.9z"
          style={{
            transformOrigin: "70.1051px 234.102px",
          }}
          id="prefix__eljcnjld4z209"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M73.93 229.11a1.43 1.43 0 01.61-.21.7.7 0 01.46.1.87.87 0 01.32.38 1.83 1.83 0 01.14.62v.81a4.26 4.26 0 01-.14.78 3.76 3.76 0 01-.32.74 3.32 3.32 0 01-.46.65 2.59 2.59 0 01-.61.48 1.35 1.35 0 01-.6.21.74.74 0 01-.47-.1.91.91 0 01-.31-.38 2.18 2.18 0 01-.14-.62 1.28 1.28 0 000-.18V232a1.48 1.48 0 000-.2 3.05 3.05 0 01.14-.77 4.09 4.09 0 01.31-.75 4.3 4.3 0 01.47-.65 2.75 2.75 0 01.6-.52zm.74 1.39a.79.79 0 00-.09-.36.35.35 0 00-.17-.17.45.45 0 00-.23 0 1.06 1.06 0 00-.25.11 1.88 1.88 0 00-.24.18 1.47 1.47 0 00-.23.26 2 2 0 00-.17.36 1.71 1.71 0 00-.09.47v.73a.79.79 0 00.09.36.35.35 0 00.17.17.45.45 0 00.23 0 .86.86 0 00.24-.11 1.44 1.44 0 00.25-.18 1.47 1.47 0 00.23-.26 1.5 1.5 0 00.17-.36 1.64 1.64 0 00.09-.47v-.73z"
          style={{
            transformOrigin: "73.935px 231.285px",
          }}
          id="prefix__elakpijqz300f"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M77.63 228a1.31 1.31 0 00-.53.51 1.83 1.83 0 00-.16.8v2.1a.41.41 0 010 .18.29.29 0 01-.11.13l-.46.27a.13.13 0 01-.12 0 .17.17 0 010-.13v-3.76a.49.49 0 010-.19.3.3 0 01.12-.13l.46-.26a.08.08 0 01.11 0 .14.14 0 010 .12v.19a3.35 3.35 0 01.34-.5 1.83 1.83 0 01.47-.37l.27-.16a.09.09 0 01.12 0v.66a.39.39 0 010 .18.51.51 0 01-.12.13z"
          style={{
            transformOrigin: "77.1938px 229.391px",
          }}
          id="prefix__elydw23o83tlp"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M79.64 229.87l-1.2-3v-.05a.49.49 0 010-.19.36.36 0 01.11-.13l.46-.26a.11.11 0 01.12 0 .18.18 0 01.08.09l.8 2 .81-3a.77.77 0 01.07-.17.36.36 0 01.13-.14l.45-.26h.12a.14.14 0 010 .12.13.13 0 010 .06l-1.59 6.3a1.08 1.08 0 01-.07.18.32.32 0 01-.13.13l-.46.27a.11.11 0 01-.11 0 .17.17 0 010-.13.13.13 0 010-.06z"
          style={{
            transformOrigin: "80.0171px 228.297px",
          }}
          id="prefix__el65wmhdf01n9"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M256.14 122.54c.07 0 .12-.05.15 0a.34.34 0 01.08.16l1.49 4.25a.39.39 0 010 .18c0 .07-.07.11-.12.13l-.44.26h-.17a.21.21 0 01-.06-.1l-.26-.75-1.92 1.11-.26 1a.47.47 0 01-.07.17.4.4 0 01-.17.17l-.43.25h-.12a.15.15 0 01-.05-.12.35.35 0 010-.06l1.49-6a1.15 1.15 0 01.08-.26.36.36 0 01.15-.15zm.34 3.35l-.67-1.92-.67 2.69z"
          style={{
            transformOrigin: "255.83px 125.944px",
          }}
          id="prefix__elmz413ynq0p"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M259.54 122a1.12 1.12 0 01.33-.14.63.63 0 01.26 0 .59.59 0 01.2 0l.12.09v-1.72a.49.49 0 01.05-.19.3.3 0 01.12-.13l.46-.26a.08.08 0 01.11 0 .14.14 0 01.05.12V125a.41.41 0 01-.05.18.33.33 0 01-.11.14l-.46.26h-.12a.14.14 0 01-.05-.12v-.19a1.71 1.71 0 01-.12.23 2.34 2.34 0 01-.2.27 2.17 2.17 0 01-.26.27 2.85 2.85 0 01-.33.25 1 1 0 01-.55.15.71.71 0 01-.42-.17 1.1 1.1 0 01-.27-.45 1.88 1.88 0 01-.11-.65 2.44 2.44 0 010-.28 2.53 2.53 0 010-.29 3.12 3.12 0 01.11-.78 3.8 3.8 0 01.27-.76 3.38 3.38 0 01.42-.66 1.92 1.92 0 01.55-.4zm-.57 2.28a3.53 3.53 0 000 .46c0 .33.11.54.25.61a.47.47 0 00.5-.06 1.39 1.39 0 00.5-.52 2 2 0 00.23-.81 2.82 2.82 0 000-.31 2.45 2.45 0 000-.3.65.65 0 00-.23-.53.47.47 0 00-.5 0 1.26 1.26 0 00-.5.52 2 2 0 00-.22.89z"
          style={{
            transformOrigin: "259.713px 123.034px",
          }}
          id="prefix__el0o0ztxdbtlm"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M263.29 119.78a1.29 1.29 0 01.34-.14.6.6 0 01.26 0 .38.38 0 01.19 0 .57.57 0 01.13.08V118a.39.39 0 010-.18c0-.06.07-.11.12-.13l.46-.27a.08.08 0 01.11 0s.05.06.05.12v5.31a.31.31 0 01-.05.18.36.36 0 01-.11.13l-.46.27a.13.13 0 01-.12 0 .17.17 0 010-.13v-.18c0 .06-.08.14-.13.23s-.12.17-.19.26a3.45 3.45 0 01-.26.28 1.72 1.72 0 01-.34.24 1 1 0 01-.55.16.67.67 0 01-.42-.18 1.23 1.23 0 01-.27-.45 2.15 2.15 0 01-.11-.65 2.35 2.35 0 010-.28 2.62 2.62 0 010-.29 3.66 3.66 0 01.11-.78 4.89 4.89 0 01.27-.76 3.7 3.7 0 01.42-.66 2.07 2.07 0 01.55-.46zm-.56 2.29a1.69 1.69 0 000 .45c0 .34.1.54.24.61a.47.47 0 00.5-.06 1.26 1.26 0 00.5-.52 1.75 1.75 0 00.24-.8v-.32-.3a.64.64 0 00-.24-.53.47.47 0 00-.5.05 1.39 1.39 0 00-.5.52 1.92 1.92 0 00-.24.9z"
          style={{
            transformOrigin: "263.443px 120.844px",
          }}
          id="prefix__ela6lbn8sxu7"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M51.8 271a1.06 1.06 0 01-.58-.16 1.62 1.62 0 01-.7-1.47v-11.14a3.6 3.6 0 011.54-2.89l43.15-24.92a1.32 1.32 0 011.35-.06 1.61 1.61 0 01.69 1.47V243a3.57 3.57 0 01-1.54 2.89l-43.15 24.92a1.61 1.61 0 01-.76.19zM96 231.2a.67.67 0 00-.26.09l-43.18 24.92a2.6 2.6 0 00-1 2v11.19c0 .34.1.55.2.61s.27 0 .34-.07L95.21 245a2.57 2.57 0 001-2v-11.17a.78.78 0 00-.19-.61z"
          style={{
            transformOrigin: "73.8855px 250.602px",
          }}
          id="prefix__elq1kcnopni0l"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M105.18 199.13a1.14 1.14 0 01-.58-.15 1.62 1.62 0 01-.7-1.48v-11.16a3.6 3.6 0 011.54-2.9l173.39-100.1a1.32 1.32 0 011.34-.07 1.63 1.63 0 01.69 1.48v11.16a3.59 3.59 0 01-1.53 2.9l-173.39 100.1a1.5 1.5 0 01-.76.22zm174.4-115a.57.57 0 00-.25.08l-173.39 100.1a2.64 2.64 0 00-1 2v11.19c0 .35.1.56.2.61s.27 0 .34-.07l173.35-100.1a2.63 2.63 0 001-2V84.75c0-.35-.09-.56-.19-.61a.13.13 0 00-.06-.02z"
          style={{
            transformOrigin: "192.38px 141.125px",
          }}
          id="prefix__elcujm1psvtd7"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M105.18 219.67a1.14 1.14 0 01-.58-.15 1.62 1.62 0 01-.7-1.48v-11.16a3.6 3.6 0 011.54-2.9l91.35-52.74a1.32 1.32 0 011.34-.07 1.65 1.65 0 01.7 1.48v11.16a3.6 3.6 0 01-1.54 2.9l-91.35 52.74a1.5 1.5 0 01-.76.22zM197.55 152a.57.57 0 00-.26.09l-91.35 52.74a2.62 2.62 0 00-1 2V218c0 .34.1.55.2.61s.27 0 .34-.07l91.35-52.74a2.62 2.62 0 001-2v-11.15c0-.34-.1-.55-.2-.61z"
          style={{
            transformOrigin: "151.364px 185.345px",
          }}
          id="prefix__el2qxjstljcfm"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M205.4 161.8a1.19 1.19 0 01-.58-.15 1.63 1.63 0 01-.69-1.48V149a3.6 3.6 0 011.54-2.9l37.16-21.45a1.32 1.32 0 011.34-.07 1.63 1.63 0 01.7 1.48v11.16a3.6 3.6 0 01-1.54 2.9l-37.16 21.45a1.53 1.53 0 01-.77.23zm38.19-36.36a.57.57 0 00-.26.09L206.17 147a2.61 2.61 0 00-1 2v11.16c0 .35.1.56.19.61s.28 0 .35-.06l37.16-21.46a2.64 2.64 0 001-2v-11.18c0-.35-.1-.56-.2-.61a.11.11 0 00-.08-.02z"
          style={{
            transformOrigin: "224.5px 143.115px",
          }}
          id="prefix__eli8mus1sb5l"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M251.44 135.22a1.13 1.13 0 01-.57-.15 1.61 1.61 0 01-.7-1.48v-11.16a3.6 3.6 0 011.54-2.9l15.1-8.72a1.32 1.32 0 011.34-.06 1.62 1.62 0 01.7 1.47v11.17a3.6 3.6 0 01-1.54 2.89l-15.1 8.72a1.51 1.51 0 01-.77.22zm16.13-23.63a.57.57 0 00-.26.09l-15.1 8.72a2.64 2.64 0 00-1 2v11.16c0 .35.1.56.2.61s.27 0 .34-.07l15.1-8.71a2.64 2.64 0 001-2v-11.17c0-.34-.1-.55-.2-.61z"
          style={{
            transformOrigin: "259.509px 122.908px",
          }}
          id="prefix__el81r2vey00z9"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M55 261.31a4 4 0 01.14-1 3.58 3.58 0 01.35-.89 3.53 3.53 0 01.56-.77 3.69 3.69 0 01.79-.61 2.08 2.08 0 01.87-.32.87.87 0 01.54.12.68.68 0 01.29.36 1.73 1.73 0 01.09.4.31.31 0 010 .19.51.51 0 01-.12.13l-.49.28a.12.12 0 01-.11 0l-.05-.06a1.15 1.15 0 01-.07-.11.43.43 0 00-.16-.13.68.68 0 00-.3 0 1.06 1.06 0 00-.45.17 1.88 1.88 0 00-.73.75 2.23 2.23 0 00-.29 1v1.32c0 .44.11.71.29.81a.8.8 0 00.73-.12 2.55 2.55 0 00.41-.3 2.13 2.13 0 00.33-.4 2 2 0 00.21-.51 2.48 2.48 0 00.07-.63v.01l-.74.42a.09.09 0 01-.11 0 .17.17 0 010-.13v-.57a.41.41 0 010-.18.33.33 0 01.11-.14l1.4-.8a.08.08 0 01.11 0v1.01a4.35 4.35 0 01-.11 1 3.91 3.91 0 01-.35.9 3.66 3.66 0 01-.57.8 3.9 3.9 0 01-.81.63 2.05 2.05 0 01-.8.3.81.81 0 01-.57-.13 1 1 0 01-.34-.5 2.76 2.76 0 01-.13-.82v-1.09c.01-.17.01-.28.01-.39z"
          style={{
            transformOrigin: "56.83px 260.982px",
          }}
          id="prefix__el4dbchdztdbq"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M59.2 260.33a4.46 4.46 0 01.4-1.77 3.46 3.46 0 01.47-.74 2.37 2.37 0 01.62-.53 1.22 1.22 0 01.61-.19.76.76 0 01.47.18 1 1 0 01.3.48 2.29 2.29 0 01.11.73v.36a.41.41 0 010 .18.29.29 0 01-.11.13l-2 1.17a.64.64 0 00.06.3.36.36 0 00.15.15.44.44 0 00.23 0 1.06 1.06 0 00.26-.1 1.31 1.31 0 00.31-.23 1.36 1.36 0 00.2-.25l.11-.16.12-.09.48-.28a.13.13 0 01.12 0v.13a1.59 1.59 0 01-.1.34 2.68 2.68 0 01-.26.5 4.06 4.06 0 01-.43.54 3 3 0 01-.6.47 1.28 1.28 0 01-.62.2.67.67 0 01-.47-.18 1.13 1.13 0 01-.29-.52 2.83 2.83 0 01-.14-.82zm1.49-2.07a1.05 1.05 0 00-.3.25 1.61 1.61 0 00-.21.3 1.37 1.37 0 00-.13.31 1.88 1.88 0 00-.06.29l1.37-.79a1.85 1.85 0 000-.23.4.4 0 00-.11-.18.32.32 0 00-.2-.06.71.71 0 00-.36.11z"
          style={{
            transformOrigin: "60.695px 259.475px",
          }}
          id="prefix__elyncw9f4f2os"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M65.8 258.41a.41.41 0 010 .18.26.26 0 01-.12.13l-.46.27h-.11a.15.15 0 010-.12v-2.06a1.07 1.07 0 00-.17-.68c-.11-.12-.29-.12-.52 0a1.36 1.36 0 00-.51.59 2.1 2.1 0 00-.18.88v2.05a.41.41 0 01-.05.18.28.28 0 01-.12.14l-.46.26a.08.08 0 01-.11 0 .14.14 0 010-.12v-3.77a.41.41 0 010-.18.29.29 0 01.01-.16l.46-.27a.13.13 0 01.12 0 .16.16 0 01.05.13v.18a3 3 0 01.37-.56 2.07 2.07 0 01.5-.43 1.2 1.2 0 01.62-.2.56.56 0 01.4.18 1 1 0 01.21.48 2.87 2.87 0 01.07.69z"
          style={{
            transformOrigin: "64.3933px 257.551px",
          }}
          id="prefix__elrz91kbzk4cq"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M68.08 254.08a1.33 1.33 0 00-.53.52 1.76 1.76 0 00-.16.79v2.1a.31.31 0 010 .18.29.29 0 01-.11.13l-.46.27a.13.13 0 01-.12 0V254.18a.39.39 0 010-.18.34.34 0 01.12-.14l.46-.26a.08.08 0 01.11 0v.31a2.79 2.79 0 01.34-.49 1.82 1.82 0 01.47-.38l.27-.16h.12a.15.15 0 010 .12v.54a.41.41 0 010 .18.26.26 0 01-.12.13z"
          style={{
            transformOrigin: "67.646px 255.482px",
          }}
          id="prefix__el29z6njr230l"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M68.93 254.72a4 4 0 01.11-.91 3.56 3.56 0 01.29-.87 3.72 3.72 0 01.47-.74 2.32 2.32 0 01.62-.52 1.13 1.13 0 01.61-.19.7.7 0 01.47.17 1 1 0 01.3.48 2.29 2.29 0 01.11.73v.36a.41.41 0 010 .18.33.33 0 01-.11.14l-2 1.17a.6.6 0 00.06.29.36.36 0 00.15.15.36.36 0 00.23 0 .77.77 0 00.26-.1 1.31 1.31 0 00.31-.23 1.46 1.46 0 00.2-.25 1.49 1.49 0 01.11-.15.27.27 0 01.12-.09l.48-.28a.11.11 0 01.12 0 .17.17 0 010 .13 1.64 1.64 0 01-.1.35 3 3 0 01-.26.5 3.48 3.48 0 01-.44.54 2.67 2.67 0 01-.59.46 1.28 1.28 0 01-.62.2.67.67 0 01-.47-.18 1 1 0 01-.29-.52 2.76 2.76 0 01-.14-.82zm1.49-2.07a1 1 0 00-.3.24 1.25 1.25 0 00-.21.3 1.27 1.27 0 00-.13.32 1.77 1.77 0 00-.06.28l1.37-.79a1.06 1.06 0 000-.23.4.4 0 00-.1-.18.32.32 0 00-.2-.06.64.64 0 00-.37.12z"
          style={{
            transformOrigin: "70.425px 253.865px",
          }}
          id="prefix__eleetrbkxcsyr"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M195.52 164.45l-5.35 3.09c-.39.22-.7 0-.7-.54v-7.13a1.68 1.68 0 01.7-1.35l5.35-3.09c.39-.23.71 0 .71.53v7.14a1.7 1.7 0 01-.71 1.35z"
          style={{
            transformOrigin: "192.85px 161.483px",
          }}
          id="prefix__elmfu3tim90w"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M105.18 260.75a1.06 1.06 0 01-.58-.16 1.6 1.6 0 01-.7-1.47V248a3.6 3.6 0 011.54-2.89l174-100.48a1.32 1.32 0 011.34-.07 1.65 1.65 0 01.7 1.48v11.17a3.6 3.6 0 01-1.54 2.89l-174 100.48a1.61 1.61 0 01-.76.17zm175.05-115.39a.57.57 0 00-.26.09l-174 100.47a2.64 2.64 0 00-1 2v11.17c0 .34.1.55.2.61s.27 0 .34-.07l174-100.48a2.62 2.62 0 001-2V146c0-.34-.1-.55-.2-.61z"
          style={{
            transformOrigin: "192.689px 202.58px",
          }}
          id="prefix__elalgbiqx23ue"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M192.85 163.6a.55.55 0 01-.35-.12l-1.68-1.27a.58.58 0 11.7-.92l1.13.86 1.37-2.61a.57.57 0 01.77-.24.58.58 0 01.25.78l-1.68 3.21a.55.55 0 01-.39.29z"
          style={{
            transformOrigin: "192.828px 161.417px",
          }}
          id="prefix__elcymw79rwc6i"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M105.18 240.21a1.14 1.14 0 01-.58-.15 1.62 1.62 0 01-.7-1.48v-11.17a3.6 3.6 0 011.54-2.89l67.72-39.1a1.32 1.32 0 011.34-.07 1.62 1.62 0 01.7 1.48V198a3.6 3.6 0 01-1.54 2.9L105.94 240a1.61 1.61 0 01-.76.21zm68.74-54a.61.61 0 00-.26.09l-67.72 39.1a2.62 2.62 0 00-1 2v11.17c0 .34.1.55.2.61s.27 0 .34-.07L173.16 200a2.62 2.62 0 001-2v-11.17c0-.34-.1-.55-.2-.61z"
          style={{
            transformOrigin: "139.55px 212.705px",
          }}
          id="prefix__elfak1nsxcf8h"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M51.8 291.57a1.15 1.15 0 01-.58-.16 1.62 1.62 0 01-.7-1.47v-11.17a3.6 3.6 0 011.54-2.89L95.21 251a1.34 1.34 0 011.35-.07 1.64 1.64 0 01.69 1.48v11.17a3.57 3.57 0 01-1.54 2.89l-43.15 24.88a1.61 1.61 0 01-.76.22zM96 251.74a.66.66 0 00-.27.09l-43.17 24.91a2.64 2.64 0 00-1 2v11.17c0 .34.1.55.2.61s.27 0 .34-.07l43.15-24.92a2.59 2.59 0 001-2v-11.16a.78.78 0 00-.19-.61z"
          style={{
            transformOrigin: "73.8852px 271.175px",
          }}
          id="prefix__ely3ufxfkskm"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M58 278a.11.11 0 01.11 0v.7a.31.31 0 010 .18.29.29 0 01-.11.13l-1.09.63v4.43a.41.41 0 010 .18.26.26 0 01-.12.13l-.49.29a.11.11 0 01-.11 0 .16.16 0 01-.05-.13v-4.43l-1.09.63a.11.11 0 01-.12 0 .17.17 0 010-.13v-.57a.49.49 0 010-.19.3.3 0 01.12-.13z"
          style={{
            transformOrigin: "56.5202px 281.335px",
          }}
          id="prefix__elgplukfo1g2o"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M61.51 281.42a.31.31 0 010 .18.33.33 0 01-.11.14l-.46.26a.09.09 0 01-.12 0v-2.18a1 1 0 00-.17-.67c-.12-.13-.29-.13-.53 0a1.25 1.25 0 00-.5.58 2 2 0 00-.19.88v2.06a.31.31 0 01-.05.18.36.36 0 01-.11.13l-.46.26a.11.11 0 01-.12 0 .17.17 0 010-.13v-5.3a.39.39 0 010-.18c0-.06.07-.11.12-.13l.46-.27a.08.08 0 01.11 0s.05.06.05.12v1.73a3.72 3.72 0 01.37-.57 1.74 1.74 0 01.51-.42 1.2 1.2 0 01.62-.21.55.55 0 01.39.18 1 1 0 01.22.48 3.69 3.69 0 01.06.69z"
          style={{
            transformOrigin: "60.1386px 280.233px",
          }}
          id="prefix__elcqb3anpegjd"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M63.79 277.09a1.3 1.3 0 00-.52.52 1.66 1.66 0 00-.16.79v2.1a.41.41 0 010 .18.28.28 0 01-.12.14l-.46.26a.08.08 0 01-.11 0 .14.14 0 010-.12v-3.77a.41.41 0 010-.18.29.29 0 01.11-.13l.46-.27a.13.13 0 01.12 0 .16.16 0 010 .13v.18a2.62 2.62 0 01.33-.49 1.82 1.82 0 01.47-.38l.28-.15a.09.09 0 01.11 0 .17.17 0 010 .13v.53a.41.41 0 010 .18.25.25 0 01-.11.13z"
          style={{
            transformOrigin: "63.3597px 278.492px",
          }}
          id="prefix__elk421aux1hf"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M64.65 277.73a4.13 4.13 0 01.4-1.78 3.26 3.26 0 01.47-.73 2.33 2.33 0 01.61-.53 1.26 1.26 0 01.62-.19.77.77 0 01.47.17 1.14 1.14 0 01.3.49 2.28 2.28 0 01.1.72v.37a.39.39 0 010 .18.51.51 0 01-.12.13l-2 1.17a.76.76 0 000 .29.33.33 0 00.16.15.4.4 0 00.22 0 .93.93 0 00.26-.1 1.77 1.77 0 00.32-.24 1.16 1.16 0 00.2-.25.73.73 0 01.11-.15.53.53 0 01.11-.09l.49-.28a.09.09 0 01.12 0 .11.11 0 010 .12 1 1 0 01-.09.35 2.79 2.79 0 01-.27.5 3.39 3.39 0 01-.43.54 2.84 2.84 0 01-.6.47 1.22 1.22 0 01-.61.19.65.65 0 01-.47-.17 1.19 1.19 0 01-.3-.52 2.9 2.9 0 01-.07-.81zm1.48-2.07a1.44 1.44 0 00-.3.24 2.73 2.73 0 00-.21.3 2.15 2.15 0 00-.13.32 1 1 0 000 .29l1.37-.79a1.55 1.55 0 000-.23.33.33 0 00-.11-.18.23.23 0 00-.2-.06.76.76 0 00-.42.11z"
          style={{
            transformOrigin: "66.1381px 276.865px",
          }}
          id="prefix__elxcun5uqodrn"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M68.29 274.56a1.64 1.64 0 01.11-.42 2.93 2.93 0 01.24-.51 2.72 2.72 0 01.4-.51 2.52 2.52 0 01.54-.42 1.5 1.5 0 01.56-.21.62.62 0 01.43.07.63.63 0 01.27.37 1.82 1.82 0 01.1.67v2.4a.41.41 0 010 .18.29.29 0 01-.11.13l-.46.27h-.12a.14.14 0 010-.12v-.27a2.78 2.78 0 01-.36.61 2.26 2.26 0 01-.62.52 1.28 1.28 0 01-.46.18.57.57 0 01-.35-.07.58.58 0 01-.21-.27 1.28 1.28 0 01-.08-.47 1.93 1.93 0 01.3-1 3.64 3.64 0 01.79-.89l1-.79c0-.22-.05-.35-.16-.38a.58.58 0 00-.41.1.75.75 0 00-.23.19 1.21 1.21 0 00-.17.25l-.1.15a.39.39 0 01-.1.08l-.56.32a.12.12 0 01-.11 0 .14.14 0 01-.13-.16zm1 1.7a1.7 1.7 0 00.36-.29 1.54 1.54 0 00.27-.36 1.65 1.65 0 00.17-.39 1.63 1.63 0 00.05-.36v-.08l-.82.67a1.53 1.53 0 00-.36.37.69.69 0 00-.11.36c0 .11 0 .17.13.17a.51.51 0 00.32-.09z"
          style={{
            transformOrigin: "69.5599px 274.991px",
          }}
          id="prefix__el1lyw7u0s70c"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M73 270.75a1.81 1.81 0 01.33-.15h.27l.19.05.12.09V269a.41.41 0 010-.18.3.3 0 01.12-.13l.46-.26a.09.09 0 01.11 0 .14.14 0 010 .13v5.3a.31.31 0 010 .18.25.25 0 01-.11.13l-.46.27h-.12a.14.14 0 010-.12v-.19a1.71 1.71 0 01-.12.23l-.19.27-.27.27a1.65 1.65 0 01-.33.24 1 1 0 01-.55.16.67.67 0 01-.42-.18 1.1 1.1 0 01-.27-.44 1.88 1.88 0 01-.11-.65 2.44 2.44 0 010-.28 2.53 2.53 0 010-.29 3.12 3.12 0 01.11-.78 4.55 4.55 0 01.27-.76 3.46 3.46 0 01.42-.67 2 2 0 01.55-.5zm-.61 2.25a3.38 3.38 0 000 .45c0 .34.11.54.25.62a.52.52 0 00.5-.06 1.39 1.39 0 00.5-.52 1.82 1.82 0 00.23-.81 2.54 2.54 0 000-.31 2.11 2.11 0 000-.3c0-.27-.09-.45-.23-.53a.46.46 0 00-.5 0 1.35 1.35 0 00-.5.53 2 2 0 00-.25.93z"
          style={{
            transformOrigin: "73.1309px 271.856px",
          }}
          id="prefix__el0ed8zb1g1frf"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M77.21 271.37v-.12a.22.22 0 00-.15 0 1.6 1.6 0 00-.28.07l-.45.13a1.23 1.23 0 01-.44.05.43.43 0 01-.28-.12.58.58 0 01-.15-.28 1.8 1.8 0 010-.43 2.06 2.06 0 01.08-.52 2.53 2.53 0 01.25-.56 2.72 2.72 0 01.39-.52 2.45 2.45 0 01.53-.42 2.06 2.06 0 01.53-.22.84.84 0 01.39 0 .46.46 0 01.26.19.67.67 0 01.1.32.39.39 0 010 .18.43.43 0 01-.12.14l-.47.26a.18.18 0 01-.14 0h-.1a.2.2 0 00-.14 0 .65.65 0 00-.27.11 1.4 1.4 0 00-.33.26.51.51 0 00-.14.34.22.22 0 000 .13h.13l.26-.05.43-.13c.36-.1.61-.09.76 0a.89.89 0 01.22.69 1.72 1.72 0 01-.09.52 2.88 2.88 0 01-.26.57 3.45 3.45 0 01-.43.53 2.42 2.42 0 01-.56.44 2.05 2.05 0 01-.57.23.82.82 0 01-.42 0 .49.49 0 01-.26-.21.64.64 0 01-.09-.34.3.3 0 010-.18.38.38 0 01.12-.13l.47-.27c.06 0 .1-.05.13 0l.11.06a.25.25 0 00.16 0 .72.72 0 00.31-.12 1 1 0 00.18-.13.9.9 0 00.18-.15 1.1 1.1 0 00.14-.18.31.31 0 00.01-.14z"
          style={{
            transformOrigin: "76.7358px 270.797px",
          }}
          id="prefix__elf4q1bb5uun"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M171.9 198.63l-5.35 3.09c-.39.22-.71 0-.71-.54v-7.13a1.69 1.69 0 01.71-1.35l5.35-3.09c.39-.23.7 0 .7.53v7.13a1.7 1.7 0 01-.7 1.36z"
          style={{
            transformOrigin: "169.22px 195.663px",
          }}
          id="prefix__el86lmhovp7vb"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M169.22 197.78a.59.59 0 01-.35-.12l-1.67-1.27a.58.58 0 01-.12-.81.58.58 0 01.81-.11l1.14.86 1.36-2.6a.57.57 0 01.78-.25.58.58 0 01.24.78l-1.68 3.21a.56.56 0 01-.38.29z"
          style={{
            transformOrigin: "169.221px 195.596px",
          }}
          id="prefix__el4jiij7vw2xc"
          className="prefix__animable"
          fill="#fafafa"
        />
        <g id="prefix__el0n1d2nqsou5h">
          <ellipse
            cx={111.16}
            cy={249.63}
            rx={2.61}
            ry={1.47}
            style={{
              transformOrigin: "111.16px 249.63px",
            }}
            className="prefix__animable"
            id="prefix__el9li9aq7q3v"
            fill="#e0e0e0"
            transform="rotate(-67.027)"
          />
        </g>
        <path
          d="M118.66 245.3a4.07 4.07 0 01-1.7 3.25c-.93.54-1.7 0-1.7-1.29A4.08 4.08 0 01117 244c.9-.52 1.66.05 1.66 1.3z"
          style={{
            transformOrigin: "116.96px 246.283px",
          }}
          id="prefix__elemlbztxg2fo"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M124.46 242a4.05 4.05 0 01-1.7 3.24c-.94.54-1.7 0-1.7-1.28a4.07 4.07 0 011.7-3.25c.94-.58 1.7 0 1.7 1.29z"
          style={{
            transformOrigin: "122.76px 242.967px",
          }}
          id="prefix__el2a7sobqogn1"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M52.44 359.8a1.17 1.17 0 01-.58-.15 1.61 1.61 0 01-.69-1.47v-55.9a3.59 3.59 0 011.53-2.89l226.13-130.55a1.3 1.3 0 011.34-.07 1.61 1.61 0 01.69 1.47v55.9a3.59 3.59 0 01-1.53 2.89L53.2 359.58a1.47 1.47 0 01-.76.22zm227.14-190.18a.57.57 0 00-.25.08L53.2 300.25a2.63 2.63 0 00-1 2v55.9c0 .34.09.55.19.6s.28 0 .34-.06l226.1-130.53a2.59 2.59 0 001-2v-55.9c0-.34-.09-.55-.19-.6a.13.13 0 00-.06-.04z"
          style={{
            transformOrigin: "166.015px 264.208px",
          }}
          id="prefix__elzry3qfeuq8r"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M60.64 308.58l-5.35 3.09c-.39.23-.71 0-.71-.53V304a1.71 1.71 0 01.71-1.36l5.35-3.08c.39-.23.71 0 .71.53v7.13a1.69 1.69 0 01-.71 1.36z"
          style={{
            transformOrigin: "57.965px 305.615px",
          }}
          id="prefix__elf8jvjaee3pc"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M70 303.16l-5.35 3.09c-.39.22-.71 0-.71-.54v-7.13a1.69 1.69 0 01.71-1.35l5.35-3.09c.39-.22.7 0 .7.54v7.13a1.69 1.69 0 01-.7 1.35z"
          style={{
            transformOrigin: "67.32px 300.195px",
          }}
          id="prefix__el01ue0d0bs2s7"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M79.43 297.74l-5.35 3.08c-.39.23-.71 0-.71-.53v-7.13a1.69 1.69 0 01.71-1.35l5.35-3.09c.39-.23.71 0 .71.53v7.13a1.72 1.72 0 01-.71 1.36z"
          style={{
            transformOrigin: "76.755px 294.77px",
          }}
          id="prefix__elyhf5jfsgbpa"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M88.83 292.31l-5.35 3.09c-.39.23-.71 0-.71-.53v-7.14a1.7 1.7 0 01.71-1.35l5.35-3.09c.39-.22.7 0 .7.54V291a1.68 1.68 0 01-.7 1.31z"
          style={{
            transformOrigin: "86.15px 289.347px",
          }}
          id="prefix__eluxdrhylkk0b"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M98.22 286.89L92.87 290c-.39.22-.71 0-.71-.54v-7.13a1.69 1.69 0 01.71-1.35l5.35-3.09c.39-.23.71 0 .71.53v7.14a1.7 1.7 0 01-.71 1.33z"
          style={{
            transformOrigin: "95.545px 283.943px",
          }}
          id="prefix__el8o59os7i1zs"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M107.62 281.46l-5.35 3.09c-.39.23-.71 0-.71-.53v-7.14a1.7 1.7 0 01.71-1.35l5.35-3.09c.39-.22.7 0 .7.54v7.13a1.68 1.68 0 01-.7 1.35z"
          style={{
            transformOrigin: "104.94px 278.497px",
          }}
          id="prefix__elk4umtfk3n0p"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M117 276l-5.35 3.09c-.39.22-.71 0-.71-.54v-7.13a1.69 1.69 0 01.71-1.35L117 267c.39-.23.71 0 .71.53v7.14A1.7 1.7 0 01117 276z"
          style={{
            transformOrigin: "114.325px 273.043px",
          }}
          id="prefix__el6iotz3z2cx3"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M126.41 270.61l-5.35 3.09c-.39.23-.71 0-.71-.53V266a1.7 1.7 0 01.71-1.35l5.35-3.09c.39-.22.7 0 .7.54v7.13a1.68 1.68 0 01-.7 1.38z"
          style={{
            transformOrigin: "123.73px 267.632px",
          }}
          id="prefix__eljz2h4by696"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M135.8 265.19l-5.35 3.09c-.39.22-.7 0-.7-.54v-7.13a1.68 1.68 0 01.7-1.35l5.35-3.09c.39-.23.71 0 .71.53v7.14a1.7 1.7 0 01-.71 1.35z"
          style={{
            transformOrigin: "133.13px 262.223px",
          }}
          id="prefix__elq6ur0migd"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M145.2 259.76l-5.35 3.09c-.39.23-.71 0-.71-.53v-7.13a1.72 1.72 0 01.71-1.36l5.35-3.08c.39-.23.7 0 .7.53v7.13a1.68 1.68 0 01-.7 1.35z"
          style={{
            transformOrigin: "142.52px 256.8px",
          }}
          id="prefix__elcyqqqddjtbk"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M154.59 254.34l-5.35 3.09c-.39.22-.7 0-.7-.54v-7.13a1.69 1.69 0 01.7-1.35l5.35-3.09c.39-.22.71 0 .71.54V253a1.7 1.7 0 01-.71 1.34z"
          style={{
            transformOrigin: "151.92px 251.375px",
          }}
          id="prefix__el13j8yr40zxt"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M164 248.92l-5.36 3.08c-.39.23-.71 0-.71-.53v-7.13a1.69 1.69 0 01.71-1.35l5.36-3.09c.39-.23.71 0 .71.53v7.13a1.71 1.71 0 01-.71 1.36z"
          style={{
            transformOrigin: "161.32px 245.95px",
          }}
          id="prefix__el2h2qgo1vb3d"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M173.38 243.49l-5.38 3.09c-.39.23-.7 0-.7-.53v-7.14a1.69 1.69 0 01.7-1.35l5.35-3.09c.39-.22.71 0 .71.54v7.13a1.69 1.69 0 01-.68 1.35z"
          style={{
            transformOrigin: "170.68px 240.527px",
          }}
          id="prefix__el7i6657e0g7f"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M182.78 238.07l-5.35 3.09c-.39.22-.71 0-.71-.54v-7.13a1.69 1.69 0 01.71-1.35l5.35-3.09c.39-.23.71 0 .71.53v7.14a1.7 1.7 0 01-.71 1.35z"
          style={{
            transformOrigin: "180.105px 235.103px",
          }}
          id="prefix__elslgi6bxzgq9"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M186.54 236.32a.82.82 0 01-.43-.12 1.11 1.11 0 01-.49-1v-7.14a2.19 2.19 0 01.95-1.78L216.45 209a.92.92 0 011 0 1.09 1.09 0 01.5 1v7.13a2.2 2.2 0 01-1 1.79l-29.88 17.24a1 1 0 01-.53.16zm30.36-26.39l-29.83 17.22a1.21 1.21 0 00-.45.91v7.21l29.83-17.22a1.22 1.22 0 00.46-.92V210s-.01 0-.01-.07z"
          style={{
            transformOrigin: "201.785px 222.586px",
          }}
          id="prefix__elujlur9pr9vr"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M58 321.44a1 1 0 01-.5-1.86l214.41-123.81a1 1 0 011.37.36 1 1 0 01-.37 1.37L58.47 321.31a1 1 0 01-.47.13z"
          style={{
            transformOrigin: "165.212px 258.536px",
          }}
          id="prefix__eljlgyxdqoqd"
          className="prefix__animable"
          fill="#e6e6e6"
        />
        <path
          d="M58 328.26a1 1 0 01-.5-1.87l214.41-123.81a1 1 0 111 1.74L58.47 328.13a1 1 0 01-.47.13z"
          style={{
            transformOrigin: "165.203px 265.353px",
          }}
          id="prefix__elmk3c1q4pbvj"
          className="prefix__animable"
          fill="#e6e6e6"
        />
        <path
          d="M58 335.08a1 1 0 01-.5-1.87L271.91 209.4a1 1 0 111 1.74L58.47 335a1 1 0 01-.47.08z"
          style={{
            transformOrigin: "165.203px 272.175px",
          }}
          id="prefix__eldqzvepzeqxd"
          className="prefix__animable"
          fill="#e6e6e6"
        />
        <path
          d="M58 341.9a1 1 0 01-.5-1.87l74.33-42.91a1 1 0 011 1.73l-74.36 42.92a1 1 0 01-.47.13z"
          style={{
            transformOrigin: "95.1433px 319.453px",
          }}
          id="prefix__el25ingzrudz1"
          className="prefix__animable"
          fill="#e6e6e6"
        />
        <path
          d="M94.73 362.77L53.45 386.6c-1 .57-1.78 0-1.78-1.35v-13.7a4.25 4.25 0 011.78-3.41l41.28-23.83c1-.57 1.78 0 1.78 1.35v13.7a4.29 4.29 0 01-1.78 3.41z"
          style={{
            transformOrigin: "74.09px 365.455px",
          }}
          id="prefix__elkvq57rhpb1"
          className="prefix__animable"
          fill="#e6e6e6"
        />
        <path
          d="M65.24 372.38a.42.42 0 01.17-.32l.49-.28a.11.11 0 01.12 0v.13a4.27 4.27 0 01-.13.74 3.67 3.67 0 01-.32.78 4 4 0 01-.55.76 3.65 3.65 0 01-.81.63 1.73 1.73 0 01-.74.26.75.75 0 01-.54-.14 1 1 0 01-.35-.51 2.34 2.34 0 01-.15-.81v-.67-.69a4.08 4.08 0 01.15-1 3.72 3.72 0 01.35-.91 3.44 3.44 0 01.54-.77 2.87 2.87 0 01.74-.6 1.85 1.85 0 01.81-.29.82.82 0 01.55.12.84.84 0 01.32.41 2.21 2.21 0 01.13.59.31.31 0 010 .18.26.26 0 01-.12.13l-.49.28a.12.12 0 01-.11 0 .15.15 0 01-.07-.12.77.77 0 00-.08-.27.52.52 0 00-.19-.17.63.63 0 00-.29 0 1.27 1.27 0 00-.41.16 1.73 1.73 0 00-.41.34 1.84 1.84 0 00-.3.43 2.6 2.6 0 00-.18.49 2.4 2.4 0 00-.07.52V373.14a1.45 1.45 0 00.07.44.71.71 0 00.18.28.43.43 0 00.3.08.9.9 0 00.41-.14 1.84 1.84 0 00.41-.31 2 2 0 00.3-.37 1.64 1.64 0 00.18-.38 1.89 1.89 0 00.09-.36z"
          style={{
            transformOrigin: "64.2317px 371.884px",
          }}
          id="prefix__elavg4rarkwhh"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M68.73 366.5c.06 0 .11-.05.14 0a.34.34 0 01.09.16l1.48 4.25a.07.07 0 010 .05.41.41 0 010 .18.29.29 0 01-.11.13l-.44.26c-.08 0-.14.05-.17 0a.23.23 0 01-.07-.1l-.26-.75-1.91 1.11-.26 1.05-.07.17a.46.46 0 01-.17.17l-.44.25a.11.11 0 01-.11 0v-.13a.13.13 0 010-.06l1.48-6a.79.79 0 01.09-.26.4.4 0 01.14-.15zm.33 3.35l-.67-1.92-.66 2.69z"
          style={{
            transformOrigin: "68.4382px 369.961px",
          }}
          id="prefix__elqmcjx9ffiw"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M73.75 369.25c-.07 0-.12.05-.15 0a.3.3 0 01-.08-.07l-1.7-2.38v3.33a.41.41 0 010 .18.29.29 0 01-.11.13l-.5.29a.11.11 0 01-.11 0 .17.17 0 010-.13v-5.2a.41.41 0 010-.18.29.29 0 01.11-.13l.43-.25h.16l.08.06 1.69 2.39V364a.49.49 0 010-.19.3.3 0 01.12-.13l.49-.28a.08.08 0 01.11 0v5.34a.42.42 0 01-.16.32z"
          style={{
            transformOrigin: "72.6885px 367.061px",
          }}
          id="prefix__el2xjeujkd6v"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M77.89 365.07a.43.43 0 01.07-.2.43.43 0 01.11-.12l.49-.28a.13.13 0 01.12 0 .14.14 0 010 .14 3.46 3.46 0 01-.12.73 4 4 0 01-.32.79 3.85 3.85 0 01-.56.75 3.69 3.69 0 01-.8.64 1.88 1.88 0 01-.74.26.83.83 0 01-.55-.15 1.1 1.1 0 01-.35-.51 2.62 2.62 0 01-.14-.81v-.67-.68a4.37 4.37 0 01.49-1.9 3.49 3.49 0 01.55-.77 2.83 2.83 0 01.74-.59 1.77 1.77 0 01.8-.3.9.9 0 01.56.12.84.84 0 01.32.41 1.94 1.94 0 01.12.59.3.3 0 010 .18.38.38 0 01-.12.13l-.49.29a.17.17 0 01-.12 0s0-.05-.06-.12a.62.62 0 00-.09-.27.42.42 0 00-.18-.17.54.54 0 00-.29 0 .93.93 0 00-.41.16 1.49 1.49 0 00-.41.33 2.08 2.08 0 00-.3.43 2.05 2.05 0 00-.21.52 3.28 3.28 0 00-.08.52V365.88a1.82 1.82 0 00.08.44.57.57 0 00.18.28.49.49 0 00.3.09 1 1 0 00.41-.14 2.24 2.24 0 00.41-.32 1.62 1.62 0 00.29-.37 1.93 1.93 0 00.19-.38 1.82 1.82 0 00.11-.41z"
          style={{
            transformOrigin: "76.8994px 364.589px",
          }}
          id="prefix__eli0wjjxxprn"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M82.26 363.33a.09.09 0 01.11 0 .12.12 0 010 .12v.55a.31.31 0 010 .18.29.29 0 01-.11.13l-2.66 1.54a.13.13 0 01-.12 0 .16.16 0 010-.13v-5.22a.41.41 0 010-.18.38.38 0 01.12-.13l2.61-1.51h.11c.03 0 .05.07.05.13v.57a.31.31 0 01-.05.18.24.24 0 01-.11.13l-2 1.13v1.29l1.83-1.06a.11.11 0 01.11 0 .17.17 0 010 .13v.57a.41.41 0 010 .18.29.29 0 01-.11.13l-1.83 1.06v1.34z"
          style={{
            transformOrigin: "80.9261px 362.272px",
          }}
          id="prefix__ell6vzxrpteeo"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M86 361.17a.13.13 0 01.12 0 .17.17 0 010 .13v.57a.41.41 0 010 .18.34.34 0 01-.12.14l-2.65 1.53a.13.13 0 01-.12 0 .15.15 0 010-.12v-5.23a.41.41 0 010-.18.3.3 0 01.12-.13l.49-.28a.09.09 0 01.11 0 .14.14 0 010 .13v4.43z"
          style={{
            transformOrigin: "84.6752px 360.748px",
          }}
          id="prefix__el6hec0bhvorq"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M144.13 334.24l-41.28 23.84c-1 .57-1.78 0-1.78-1.35V343a4.27 4.27 0 011.78-3.4l41.28-23.83c1-.57 1.78 0 1.78 1.34v13.71a4.23 4.23 0 01-1.78 3.42z"
          style={{
            transformOrigin: "123.49px 336.925px",
          }}
          id="prefix__eluamga6nnjui"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M117.67 338.16a1.81 1.81 0 01.71-.27.94.94 0 01.52.07.6.6 0 01.31.3 1 1 0 01.12.43.39.39 0 010 .18.51.51 0 01-.12.13l-.43.24c-.07 0-.12.06-.15 0a.17.17 0 01-.1-.09.41.41 0 00-.27-.19.84.84 0 00-.55.17 1.29 1.29 0 00-.3.22 1.27 1.27 0 00-.25.27 1.52 1.52 0 00-.17.3.89.89 0 00-.06.31.49.49 0 00.06.27.22.22 0 00.2.09 1.06 1.06 0 00.36-.05l.55-.15a3.09 3.09 0 01.63-.12.89.89 0 01.43.09.62.62 0 01.25.32 1.4 1.4 0 01.08.54 2.43 2.43 0 01-.12.74 2.78 2.78 0 01-.35.74 3.75 3.75 0 01-1.32 1.3 2.5 2.5 0 01-.65.27 1.27 1.27 0 01-.55 0 .67.67 0 01-.38-.28 1.08 1.08 0 01-.17-.55.41.41 0 010-.18.26.26 0 01.12-.13l.42-.25a.22.22 0 01.16 0 .13.13 0 01.09.09.56.56 0 00.1.15.32.32 0 00.17.1.76.76 0 00.25 0 1.54 1.54 0 00.39-.17 2.71 2.71 0 00.35-.24 2.76 2.76 0 00.3-.29 1.94 1.94 0 00.2-.33.76.76 0 00.08-.36.3.3 0 00-.08-.24.39.39 0 00-.26-.05 4.11 4.11 0 00-.43.1l-.58.15a2.35 2.35 0 01-.54.08.62.62 0 01-.37-.11.71.71 0 01-.22-.33 1.86 1.86 0 01-.08-.59 2.45 2.45 0 01.13-.74 3.34 3.34 0 01.33-.72 3.71 3.71 0 01.51-.63 2.68 2.68 0 01.68-.59z"
          style={{
            transformOrigin: "117.716px 341.09px",
          }}
          id="prefix__eluund3dki08"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M122.08 335.69h.14a.45.45 0 01.09.16l1.48 4.25a.07.07 0 010 .05.41.41 0 010 .18.29.29 0 01-.11.13l-.44.26c-.08 0-.14.05-.17 0a.16.16 0 01-.07-.09l-.26-.75-1.95 1.12-.27 1.05a.88.88 0 01-.06.17.38.38 0 01-.17.16l-.44.26a.11.11 0 01-.11 0 .14.14 0 010-.13v-.06l1.49-6a1.15 1.15 0 01.08-.26.43.43 0 01.15-.15zm.33 3.36l-.67-1.92-.66 2.69z"
          style={{
            transformOrigin: "121.762px 339.172px",
          }}
          id="prefix__eldoat3eijzll"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M125.58 337.73l1-4.44a.7.7 0 01.06-.17.29.29 0 01.14-.15l.46-.27a.13.13 0 01.12 0v.13a.18.18 0 010 .06l-1.36 5.87a1.15 1.15 0 01-.08.26.36.36 0 01-.15.15l-.48.28h-.15a.3.3 0 01-.08-.15l-1.36-4.3a.31.31 0 01.05-.18.36.36 0 01.11-.13l.46-.27h.14a.18.18 0 01.06.09z"
          style={{
            transformOrigin: "125.531px 336.068px",
          }}
          id="prefix__el36btuomgmzx"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M130.89 335.25a.13.13 0 01.12 0 .17.17 0 010 .13v.62a.39.39 0 010 .18c0 .06-.07.11-.12.13l-2.66 1.54a.09.09 0 01-.12 0v-5.34a.46.46 0 010-.19.51.51 0 01.12-.13l2.61-1.51a.13.13 0 01.12 0 .17.17 0 010 .13v.57a.41.41 0 010 .18.26.26 0 01-.12.13l-2 1.13v1.29l1.83-1.05a.09.09 0 01.11 0 .14.14 0 01.05.13v.57a.31.31 0 01-.05.18.33.33 0 01-.11.14l-1.83 1.05v1.34z"
          style={{
            transformOrigin: "129.562px 334.269px",
          }}
          id="prefix__elvaz3v3k185r"
          className="prefix__animable"
          fill="#fff"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Plant--inject-40"
      className="prefix__animable"
      style={{
        transformOrigin: "387.098px 225.186px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedLeft",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--plant--inject-40"
        className="prefix__animable"
        style={{
          transformOrigin: "387.098px 225.186px",
        }}
      >
        <g
          id="prefix__freepik--Pot--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "384.461px 268.381px",
          }}
        >
          <path
            d="M367.6 296.39c-9-9.3-14.32-47.18-5.52-54.56h44.76c8.79 7.38 3.5 45.24-5.51 54.55l-.25.26-.31.31c-.26.25-.53.49-.82.73l-.21.17c-.22.18-.44.35-.68.52a12.75 12.75 0 01-1.17.75c-7.42 4.34-19.45 4.34-26.87 0a12.9 12.9 0 01-1.17-.76c-.23-.15-.43-.32-.64-.48l-.26-.21c-.28-.23-.54-.47-.79-.71l-.36-.35c-.06-.07-.14-.14-.2-.22z"
            style={{
              transformOrigin: "384.461px 272.103px",
            }}
            id="prefix__elfejuj6fodm8"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__ell0iyo00zcjh">
            <g
              style={{
                transformOrigin: "384.461px 272.103px",
              }}
              className="prefix__animable"
              id="prefix__elns0mxlcf4vg"
              opacity={0.6}
            >
              <path
                d="M367.6 296.39c-9-9.3-14.32-47.18-5.52-54.56h44.76c8.79 7.38 3.5 45.24-5.51 54.55l-.25.26-.31.31c-.26.25-.53.49-.82.73l-.21.17c-.22.18-.44.35-.68.52a12.75 12.75 0 01-1.17.75c-7.42 4.34-19.45 4.34-26.87 0a12.9 12.9 0 01-1.17-.76c-.23-.15-.43-.32-.64-.48l-.26-.21c-.28-.23-.54-.47-.79-.71l-.36-.35c-.06-.07-.14-.14-.2-.22z"
                style={{
                  transformOrigin: "384.461px 272.103px",
                }}
                id="prefix__elirquusgyh4g"
                className="prefix__animable"
                fill="#fff"
              />
            </g>
          </g>
          <path
            d="M403 238.86c10.21 6 10.21 15.63 0 21.59s-26.77 6-37 0-10.21-15.63 0-21.59 26.74-5.97 37 0z"
            style={{
              transformOrigin: "384.496px 249.661px",
            }}
            id="prefix__el3urqnje85po"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__eluyjjlzjj0u">
            <g
              style={{
                transformOrigin: "384.496px 249.661px",
              }}
              className="prefix__animable"
              id="prefix__elspyz0emmre"
              opacity={0.8}
            >
              <path
                d="M403 238.86c10.21 6 10.21 15.63 0 21.59s-26.77 6-37 0-10.21-15.63 0-21.59 26.74-5.97 37 0z"
                style={{
                  transformOrigin: "384.496px 249.661px",
                }}
                id="prefix__ellmmr0sx4vs"
                className="prefix__animable"
                fill="#fff"
              />
            </g>
          </g>
          <path
            d="M398 241.72c7.5 4.38 7.5 11.48 0 15.86s-19.66 4.38-27.16 0-7.5-11.48 0-15.86 19.7-4.37 27.16 0z"
            style={{
              transformOrigin: "384.42px 249.652px",
            }}
            id="prefix__elf1v8asj6o87"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__el32n2wokh8u3">
            <path
              d="M398 241.72c7.5 4.38 7.5 11.48 0 15.86s-19.66 4.38-27.16 0-7.5-11.48 0-15.86 19.7-4.37 27.16 0z"
              style={{
                transformOrigin: "384.42px 249.652px",
              }}
              className="prefix__animable"
              id="prefix__ely9oi0ukb9yg"
              fill="#fff"
              opacity={0.6}
            />
          </g>
          <path
            d="M370.88 249.25c7.5-4.38 19.66-4.38 27.16 0a12.6 12.6 0 014.49 4.17 12.58 12.58 0 01-4.49 4.16c-7.5 4.38-19.66 4.38-27.16 0a12.54 12.54 0 01-4.5-4.16 12.55 12.55 0 014.5-4.17z"
            style={{
              transformOrigin: "384.455px 253.415px",
            }}
            id="prefix__elmliqipiy0tc"
            className="prefix__animable"
            fill="#fafafa"
          />
        </g>
        <path
          d="M371.67 170a4.33 4.33 0 010-.66c0-.23 0-.46-.06-.69-.05-.45-.12-.91-.21-1.36a25.6 25.6 0 00-.67-2.68 1.57 1.57 0 00-.15-.51c-.06-.17-.11-.35-.17-.52-.11-.35-.23-.7-.35-1l-.52-1.5a11.19 11.19 0 01-.48-1.45 2.79 2.79 0 00-.14-.57.92.92 0 01-.09-.25c-.06-.24-.1-.49-.15-.73-.11-.49-.22-1-.35-1.46-.26-1-.56-1.92-.91-2.86-.28-.74-.58-1.47-.91-2.19a7.59 7.59 0 00-2.48-3.33 1 1 0 00-1-.18c-.34.17-.4.62-.43 1q-.22 3.19-.43 6.41a19.41 19.41 0 000 4 9.59 9.59 0 002.2 4.83 18.7 18.7 0 002.6 2.34c.69.56 1.41 1.1 2.08 1.68a8.94 8.94 0 002.62 1.68z"
          style={{
            transformOrigin: "366.868px 158.999px",
          }}
          id="prefix__elrdnfnbc4wpl"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M384.28 156.47c0-.3-.12-.61-.2-.91a6.06 6.06 0 00-.78-1.85c-.18-.29-.27-.61-.44-.9a3.13 3.13 0 00-.65-.8 1.19 1.19 0 00-.55-.3.55.55 0 00-.57.17.83.83 0 00-.15.51 18.51 18.51 0 01-.68 3.39 13.14 13.14 0 01-.58 1.63 2.24 2.24 0 01-.31.43 2 2 0 00-.18.32 10.26 10.26 0 01-.89 1.54 8.26 8.26 0 01-.85 1 19.1 19.1 0 00-3 3c-1.14 1.79-.95 4.07-1 6.09v1.05c0 2.77-.46 5.17.26 7.9.05.19.25.66.55.48l.31-.2a10.35 10.35 0 003.1-4.6c.19-.45.36-.91.54-1.37a3.66 3.66 0 01.65-.87c.68-.87 1.25-1.85 1.84-2.78a28.07 28.07 0 002.94-6 15.16 15.16 0 00.81-4.77 12.1 12.1 0 00-.17-2.16z"
          style={{
            transformOrigin: "378.878px 165.474px",
          }}
          id="prefix__el92ybqsjcbdt"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M365.06 178.33h6.99a4.07 4.07 0 00.78 0 .37.37 0 00.15 0 .28.28 0 00.08-.24 4.69 4.69 0 00-.52-2.14 4.32 4.32 0 00-.61-.92 8.59 8.59 0 00-2.79-2.18 14.5 14.5 0 00-3.25-1l-8.81-1.85a1.26 1.26 0 00-1.17.16 1.09 1.09 0 00-.21.64 6.49 6.49 0 003 5.68 12.44 12.44 0 006.36 1.85z"
          style={{
            transformOrigin: "364.38px 174.136px",
          }}
          id="prefix__elrfw7ondhjt"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M374.72 189.14a5.17 5.17 0 00-1-1.29 6.71 6.71 0 00-2.06-1.38 23.52 23.52 0 00-4-1.17 46.51 46.51 0 01-9-3.22 1.25 1.25 0 00-.62-.16c-.51 0-.72.68-.74 1.2a7.47 7.47 0 003.94 6.89c2.43 1.26 5.32 1.06 8 1h.12a22.35 22.35 0 012.95.06 9.94 9.94 0 011.45.22c.4.1 1.14.53 1.39 0a1.09 1.09 0 000-.62 4.78 4.78 0 00-.49-1.45z"
          style={{
            transformOrigin: "366.244px 186.735px",
          }}
          id="prefix__elangg9l2cc0d"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M377.7 189.91a2.1 2.1 0 01-.41.31.83.83 0 01-.35.1.52.52 0 01-.45-.23l-.15-.26a4 4 0 01-.25-.56 6.08 6.08 0 01-.29-1.19v-.29c-.06-.45-.09-.91-.14-1.37 0-.23-.05-.45-.09-.68a2.22 2.22 0 010-.51 3.93 3.93 0 000-.84 7 7 0 010-1c.26-3 2.47-5.47 4.28-7.9a37.88 37.88 0 004.18-7.11c.25-.55.66-1.22 1.26-1.13s.73.6.89 1.06a16.06 16.06 0 01-.26 10.09 22.33 22.33 0 01-2.77 5.44 29.4 29.4 0 01-1.87 2.42c-.2.24-.38.47-.58.69-.63.68-1.27 1.34-1.92 2l-.81.8z"
          style={{
            transformOrigin: "381.21px 178.781px",
          }}
          id="prefix__ely3dveegijl"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M372.13 198.29a25.66 25.66 0 00-6.24-1.23 14.58 14.58 0 01-6.06-1.81 1.06 1.06 0 00-.62-.25c-.44 0-.67.53-.72 1a6 6 0 001 3.73 11.19 11.19 0 0011.16 5.09c1.37-.24 2.7-.73 4.1-.87a8.69 8.69 0 011 0c.22 0 .58.15.75 0 .37-.39-.07-.93-.17-1.33a4.27 4.27 0 00-.61-1.34 6.79 6.79 0 00-2.12-2.08 9.21 9.21 0 00-1.47-.91z"
          style={{
            transformOrigin: "367.561px 199.975px",
          }}
          id="prefix__els4t0jatd2ks"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M372.27 210.74c-2.1-.53-4.31-.64-6.35-1.36-.91-.33-1.78-.78-2.67-1.14-.26-.1-.58-.19-.77 0a.72.72 0 00-.14.46 7.11 7.11 0 003.21 5.82 11.77 11.77 0 006.58 1.86c1.38 0 2.77-.12 4.15 0a3.17 3.17 0 011 .15c.16.07.26.24.42.3.61.21.69-.67.63-1a5.21 5.21 0 00-.82-2 4 4 0 00-.71-.83 1.19 1.19 0 00-.35-.19c-.59-.29-1.09-.79-1.68-1.11a11 11 0 00-2.5-.96z"
          style={{
            transformOrigin: "370.343px 212.495px",
          }}
          id="prefix__el2qmy7ofsqrj"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M374 203a8.86 8.86 0 011.6.8 15.45 15.45 0 011.45 1.23c.25 3.46.41 6.93.55 10.41a5.41 5.41 0 00-.74-.66 6.61 6.61 0 00-2.28-1.06c-2-.52-4.17-.22-6.15-.89-.09 0-.14.18-.05.22 1.81.74 3.75.79 5.63 1.24a8 8 0 012.18.85 4.2 4.2 0 01.89.68 5.71 5.71 0 01.57.75c.23 5.63.48 11.25 1.1 16.85a93 93 0 001.51 9.55c.33 1.57.73 3.11 1.19 4.65.27.9.56 1.8.89 2.69a13.12 13.12 0 00.86 1.86h1a10.64 10.64 0 00-.29-1.27c-.22-.76-.46-1.52-.68-2.28-.4-1.4-.76-2.8-1.08-4.22-.65-2.89-1.17-5.8-1.54-8.74-.75-5.9-1-11.85-1.27-17.79s-.49-11.87-1.12-17.87c-.38-3.59-.9-7.17-1.53-10.72a19.08 19.08 0 012.28-5.09 43 43 0 003.5-6.39c0-.09-.06-.25-.12-.12-1.14 2.2-2.93 4-4.32 6a14.73 14.73 0 00-1.73 3.43c-.34-1.76-.7-3.52-1.11-5.27-.25-1.1-.53-2.19-.81-3.29.09-.61.19-1.21.24-1.83a21.79 21.79 0 01.33-2.25 23 23 0 011.37-4.29c1.15-2.73 3.11-5.07 4-7.89.05-.15-.12-.36-.2-.16a17.51 17.51 0 01-2.56 4.17 19.94 19.94 0 00-2.47 4 18.7 18.7 0 00-1.27 4.39c-.07.4-.13.8-.18 1.21a103.77 103.77 0 00-5.22-14.25c-.07-.16-.2.07-.17.17 1.55 5.11 3 10.25 4.28 15.43l-.28-.19A10.29 10.29 0 00370 176c-2-.7-4.08-1.17-6.1-1.79-.12 0-.17.27-.06.31 1.88.65 3.75 1.34 5.62 2a16.16 16.16 0 012.18.95 5.94 5.94 0 011 .67c.06.06.11.12.17.17 1 4 1.82 8.09 2.51 12.18a9 9 0 00-5.09-2.79c-1.39-.27-2.8-.33-4.2-.52a12.8 12.8 0 01-3.91-1.22c-.07 0-.1.13-.06.17 1.92 1.75 5 1.82 7.45 2.23a9.87 9.87 0 013.77 1.28 7.94 7.94 0 012.29 2.33c.33 2.05.63 4.1.87 6.17.22 1.9.39 3.81.53 5.72a6.48 6.48 0 00-2.14-1.5 13.79 13.79 0 00-3.72-1.07c-2.59-.42-5.33-.51-7.56-2.08 0 0-.06 0 0 .06 1.86 1.78 4.44 2.26 6.87 2.74a20.46 20.46 0 013.58.99z"
          style={{
            transformOrigin: "373.121px 206.882px",
          }}
          id="prefix__elynicyf0ud"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <g id="prefix__ele0ox87tf3a">
          <path
            d="M374 203a8.86 8.86 0 011.6.8 15.45 15.45 0 011.45 1.23c.25 3.46.41 6.93.55 10.41a5.41 5.41 0 00-.74-.66 6.61 6.61 0 00-2.28-1.06c-2-.52-4.17-.22-6.15-.89-.09 0-.14.18-.05.22 1.81.74 3.75.79 5.63 1.24a8 8 0 012.18.85 4.2 4.2 0 01.89.68 5.71 5.71 0 01.57.75c.23 5.63.48 11.25 1.1 16.85a93 93 0 001.51 9.55c.33 1.57.73 3.11 1.19 4.65.27.9.56 1.8.89 2.69a13.12 13.12 0 00.86 1.86h1a10.64 10.64 0 00-.29-1.27c-.22-.76-.46-1.52-.68-2.28-.4-1.4-.76-2.8-1.08-4.22-.65-2.89-1.17-5.8-1.54-8.74-.75-5.9-1-11.85-1.27-17.79s-.49-11.87-1.12-17.87c-.38-3.59-.9-7.17-1.53-10.72a19.08 19.08 0 012.28-5.09 43 43 0 003.5-6.39c0-.09-.06-.25-.12-.12-1.14 2.2-2.93 4-4.32 6a14.73 14.73 0 00-1.73 3.43c-.34-1.76-.7-3.52-1.11-5.27-.25-1.1-.53-2.19-.81-3.29.09-.61.19-1.21.24-1.83a21.79 21.79 0 01.33-2.25 23 23 0 011.37-4.29c1.15-2.73 3.11-5.07 4-7.89.05-.15-.12-.36-.2-.16a17.51 17.51 0 01-2.56 4.17 19.94 19.94 0 00-2.47 4 18.7 18.7 0 00-1.27 4.39c-.07.4-.13.8-.18 1.21a103.77 103.77 0 00-5.22-14.25c-.07-.16-.2.07-.17.17 1.55 5.11 3 10.25 4.28 15.43l-.28-.19A10.29 10.29 0 00370 176c-2-.7-4.08-1.17-6.1-1.79-.12 0-.17.27-.06.31 1.88.65 3.75 1.34 5.62 2a16.16 16.16 0 012.18.95 5.94 5.94 0 011 .67c.06.06.11.12.17.17 1 4 1.82 8.09 2.51 12.18a9 9 0 00-5.09-2.79c-1.39-.27-2.8-.33-4.2-.52a12.8 12.8 0 01-3.91-1.22c-.07 0-.1.13-.06.17 1.92 1.75 5 1.82 7.45 2.23a9.87 9.87 0 013.77 1.28 7.94 7.94 0 012.29 2.33c.33 2.05.63 4.1.87 6.17.22 1.9.39 3.81.53 5.72a6.48 6.48 0 00-2.14-1.5 13.79 13.79 0 00-3.72-1.07c-2.59-.42-5.33-.51-7.56-2.08 0 0-.06 0 0 .06 1.86 1.78 4.44 2.26 6.87 2.74a20.46 20.46 0 013.58.99z"
            style={{
              transformOrigin: "373.121px 206.882px",
            }}
            className="prefix__animable"
            id="prefix__el84px2yd4759"
            opacity={0.5}
          />
        </g>
        <path
          d="M363.82 220.27a21 21 0 00-3.11-1.47l-7.08-2.92a1.11 1.11 0 00-1-.06 1 1 0 00-.33.74 7.53 7.53 0 00.42 3 12 12 0 009.14 8.23c1.78.27 3.63.07 5.38.48.7.17 1.85.39 1.86-.67a1.46 1.46 0 00-.29-.76c-.17-.34-.25-.74-.39-1.1a11.33 11.33 0 00-2.5-3.85 11.2 11.2 0 00-2.1-1.62z"
          style={{
            transformOrigin: "360.692px 222.071px",
          }}
          id="prefix__elv2bic4lqte"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M367.44 232.27a17.39 17.39 0 00-4.45-1.11l-4.08-.64-1.58-.24a.9.9 0 01-.22-.06 1.17 1.17 0 00-.66-.15c-.31.05-.35.25-.38.52a4.62 4.62 0 00.15 1.61A6 6 0 00358 235a10.29 10.29 0 004.92 2.25 18.51 18.51 0 004.4.35c1.23-.05 2.47-.31 3.08-1.51s-.4-2-1.14-2.68a7 7 0 00-1.82-1.14z"
          style={{
            transformOrigin: "363.321px 233.841px",
          }}
          id="prefix__eltdeh4dv8d9"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M372.09 223.67a1.78 1.78 0 01.08-.86 1 1 0 011-.5 1.93 1.93 0 011.06.54c1.26 1.12 1.58 2.94 1.73 4.61a15.62 15.62 0 01-.18 5.15c-.3 1.23-.87 2.82-2.27 3.11a2.4 2.4 0 01-2.54-1.21c-.79-1.43-.1-3.32.26-4.77a22.68 22.68 0 00.85-5.42c.02-.22.02-.43.01-.65z"
          style={{
            transformOrigin: "373.35px 229.031px",
          }}
          id="prefix__elu5fpdt32lbi"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M369.11 241.8a19.41 19.41 0 00-5.39-1.19l-2-.25a1 1 0 00-.43 0c-.45.14-.48.77-.34 1.21.61 1.93 2.72 3 4.71 3.34s4.08.34 5.94 1.13c.43.18 1.12.48 1.41-.08s-.19-.78-.38-1.14a6.36 6.36 0 00-2-2.2 8.65 8.65 0 00-1.52-.82z"
          style={{
            transformOrigin: "366.988px 243.31px",
          }}
          id="prefix__ell8eo9oo9l9e"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M373.16 239.38c.64-1.58 2-2.86 2.29-4.54a.88.88 0 01.89.39 2.54 2.54 0 01.36 1 18.81 18.81 0 01.62 3.93 6.38 6.38 0 01-1 3.79 2.26 2.26 0 01-1.64 1.05 1.9 1.9 0 01-1.54-.61c-.6-.67-.42-1.65-.38-2.48a7.28 7.28 0 01.4-2.53z"
          style={{
            transformOrigin: "375.016px 239.916px",
          }}
          id="prefix__elrcaz36x3uu"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M368.75 236c.55.12 1.09.29 1.63.45q.74 3.87 1.52 7.74c.05.28.11.57.16.85-.14-.11-.28-.22-.43-.32a5.37 5.37 0 00-1.27-.63 2.68 2.68 0 00-.69-.17h-.66c-.16 0-.17.32 0 .35a8.37 8.37 0 011.28.43 7.32 7.32 0 011.12.56 6 6 0 01.84.66c.36 1.93.73 3.86 1.2 5.76a19 19 0 001.19 3.53 9.35 9.35 0 00.55 1h1.26a22.63 22.63 0 01-1.57-4.42c-.49-1.95-.86-3.93-1.23-5.91a6.11 6.11 0 01.31-1.26c.17-.45.36-.9.57-1.34l.34-.64a3.16 3.16 0 00.27-1s0-.11-.07-.09c-.55.18-.82.74-1.11 1.21a7.75 7.75 0 00-.66 1.28q-.66-3.37-1.34-6.74a10.34 10.34 0 01.26-1.1c.23-.72.59-1.37.87-2.06a9.7 9.7 0 00.7-2.28 6.65 6.65 0 00.16-2.22c0-.2-.21 0-.19.13.13.82-.54 1.58-.9 2.26s-.66 1.25-1 1.88c-.15.3-.29.59-.42.9a21.8 21.8 0 00-1.79-6.2 10.14 10.14 0 00-2.33-2.95 10.92 10.92 0 00-1.85-1.25 16.27 16.27 0 00-2.22-.88c-.08 0-.12.15-.07.19.57.37 1.09.8 1.65 1.16a15.76 15.76 0 011.77 1.26 7 7 0 012 2.74 35.47 35.47 0 011.63 6.59 16.85 16.85 0 00-3.21-.55 9.94 9.94 0 01-3.34-1c-.14-.07-.21.25-.11.32a8 8 0 003.39 1.34c.58.15 1.18.27 1.79.42z"
          style={{
            transformOrigin: "369.804px 239.87px",
          }}
          id="prefix__el4cln5zyegeq"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <g id="prefix__ellnh0ty4u84d">
          <path
            d="M368.75 236c.55.12 1.09.29 1.63.45q.74 3.87 1.52 7.74c.05.28.11.57.16.85-.14-.11-.28-.22-.43-.32a5.37 5.37 0 00-1.27-.63 2.68 2.68 0 00-.69-.17h-.66c-.16 0-.17.32 0 .35a8.37 8.37 0 011.28.43 7.32 7.32 0 011.12.56 6 6 0 01.84.66c.36 1.93.73 3.86 1.2 5.76a19 19 0 001.19 3.53 9.35 9.35 0 00.55 1h1.26a22.63 22.63 0 01-1.57-4.42c-.49-1.95-.86-3.93-1.23-5.91a6.11 6.11 0 01.31-1.26c.17-.45.36-.9.57-1.34l.34-.64a3.16 3.16 0 00.27-1s0-.11-.07-.09c-.55.18-.82.74-1.11 1.21a7.75 7.75 0 00-.66 1.28q-.66-3.37-1.34-6.74a10.34 10.34 0 01.26-1.1c.23-.72.59-1.37.87-2.06a9.7 9.7 0 00.7-2.28 6.65 6.65 0 00.16-2.22c0-.2-.21 0-.19.13.13.82-.54 1.58-.9 2.26s-.66 1.25-1 1.88c-.15.3-.29.59-.42.9a21.8 21.8 0 00-1.79-6.2 10.14 10.14 0 00-2.33-2.95 10.92 10.92 0 00-1.85-1.25 16.27 16.27 0 00-2.22-.88c-.08 0-.12.15-.07.19.57.37 1.09.8 1.65 1.16a15.76 15.76 0 011.77 1.26 7 7 0 012 2.74 35.47 35.47 0 011.63 6.59 16.85 16.85 0 00-3.21-.55 9.94 9.94 0 01-3.34-1c-.14-.07-.21.25-.11.32a8 8 0 003.39 1.34c.58.15 1.18.27 1.79.42z"
            style={{
              transformOrigin: "369.804px 239.87px",
            }}
            className="prefix__animable"
            id="prefix__el63uaxai532u"
            opacity={0.5}
          />
        </g>
        <path
          d="M408.51 161c1.65-3.48 4.65-6.26 5.87-9.92a1 1 0 01.27-.5.7.7 0 01.92.1 2 2 0 01.45.91 15.29 15.29 0 01.35 8.34 30.28 30.28 0 01-1.5 3.64 65.19 65.19 0 01-2.82 6.33 12.32 12.32 0 01-2.36 3c-.69.64-1.92 1.74-2.67.56a3.19 3.19 0 01-.29-1.75v-2.11a27.9 27.9 0 01.4-4.18 17.73 17.73 0 011.16-4z"
          style={{
            transformOrigin: "411.748px 162.217px",
          }}
          id="prefix__el46sfqgfkntn"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M402.91 174.1a18 18 0 00-2.29-5.28l-3.74-6.54c-.09-.17-.22-.36-.42-.37s-.36.18-.47.36c-1.76 2.87-1.69 6.59-.52 9.75a26.4 26.4 0 005.62 8.33 1.06 1.06 0 001.13.42 1.49 1.49 0 00.74-1.16 1.61 1.61 0 000-.44 5.89 5.89 0 01.08-1.26c0-.52.09-1 .1-1.56a11.33 11.33 0 00-.23-2.25z"
          style={{
            transformOrigin: "398.882px 171.356px",
          }}
          id="prefix__elqvxeozd1ec"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M417.6 171.79l3.6-1.79a.46.46 0 01.32-.07c.17 0 .26.24.3.41a5.6 5.6 0 01-.64 3.77 12.18 12.18 0 01-2.43 3 30.13 30.13 0 01-3.05 2.58 28.62 28.62 0 01-3.4 2.15 26 26 0 01-3.67 1.61 23.32 23.32 0 01-3.87 1c-.7.11-1.62.23-1.76-.68a4 4 0 01.72-2.39 10.05 10.05 0 012.25-2.53 30.43 30.43 0 013.34-2.52c1.17-.77 2.38-1.47 3.61-2.14s2.49-1.31 3.75-1.94z"
          style={{
            transformOrigin: "412.455px 177.225px",
          }}
          id="prefix__eld6lsccyf2vt"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M396.09 185.44a21.92 21.92 0 00-1.22-3 52.33 52.33 0 01-2.62-7.29c-.4 0-.73.3-1 .63a12.38 12.38 0 00-2.64 6.85 9.13 9.13 0 002.48 6.8c1.27 1.29 3 2.16 3.91 3.73.17.29.34.64.66.74a.46.46 0 00.52-.24c.1-.19-.05-.37 0-.57.07-.63.16-1.25.23-1.88a20 20 0 00.07-3.71 11.65 11.65 0 00-.39-2.06z"
          style={{
            transformOrigin: "392.565px 184.532px",
          }}
          id="prefix__elc9lde6dsorh"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M400.19 190.42c1.87-1.54 4.38-2 6.78-2.28s4.89-.53 7-1.77a1.53 1.53 0 01.75-.3c.7 0 1 .92.87 1.61a6.37 6.37 0 01-1.35 2.65 12.22 12.22 0 01-2 2.19c-2.65 2.18-6.37 2.37-9.8 2.45l-2.47.06h-1.24a9.62 9.62 0 01-1.2 0c-.63-.06-.13-.81 0-1.1a20.14 20.14 0 011.07-1.79 8.7 8.7 0 011.59-1.72z"
          style={{
            transformOrigin: "406.419px 190.559px",
          }}
          id="prefix__el3ugjnk5how4"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M390.91 199.42a15 15 0 00-1.49-2.94q-1.49-2.47-3-4.95c-.31-.52-.72-1.1-1.33-1.12-1.42 3.81-2.2 8.21-.37 11.85a18.22 18.22 0 002.31 3.29l2.52 3.08c.34.43 1 .87 1.56.57.27-.14.31-.47.36-.73a9.16 9.16 0 00.15-1.27 4.22 4.22 0 000-.94 13.88 13.88 0 01-.21-2.74 12.9 12.9 0 00-.5-4.1z"
          style={{
            transformOrigin: "387.648px 199.854px",
          }}
          id="prefix__el4w7uo3n9but"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M399.83 201.17a10.74 10.74 0 012.68-1c1.08-.23 2.21-.24 3.31-.37 1.81-.23 3.57-.79 5.37-1.06a.93.93 0 01.55 0 .89.89 0 01.36.73 6.26 6.26 0 01-.94 3.5 12.63 12.63 0 01-8.4 6.16 31.68 31.68 0 01-4.87.4c-.81 0-1.63.09-2.43.21a12.29 12.29 0 00-1.21.23 1.18 1.18 0 01-.74.05c-.4-.18-.42-.73-.39-1.1a4.43 4.43 0 01.6-1.65 14.75 14.75 0 012.43-3.33 14.39 14.39 0 013.23-2.53z"
          style={{
            transformOrigin: "402.607px 204.378px",
          }}
          id="prefix__elnbe939wgoo"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M382.59 210.45a34 34 0 00-.5 5 16.53 16.53 0 00.9 6.29 22 22 0 003.8 5.82.64.64 0 00.33.26c.29.07.51-.26.62-.53a14.71 14.71 0 00.82-7.93 14.93 14.93 0 00-1.21-3.93c-.26-.57-.65-1.09-.88-1.67-.05-.14-.08-.29-.13-.42a9.23 9.23 0 00-.69-1.23 17.26 17.26 0 01-1.21-2.75 1.61 1.61 0 00-.51-.86.57.57 0 00-.59 0c-.21.12-.18.31-.27.5a7.08 7.08 0 00-.32.68c-.07.32-.11.52-.16.77z"
          style={{
            transformOrigin: "385.422px 218.124px",
          }}
          id="prefix__elk61ohmjg87"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M391.85 216.77a9 9 0 012.6-3 11.54 11.54 0 012.82-1.21l7.38-2.38a9.1 9.1 0 01-2.67 7.49 26.72 26.72 0 01-6.32 4.63c-1.63.94-3.3 1.65-4.21 2.26l-1.19.86c-.26.2-.87.72-1.19.37-.16-.16-.06-.46 0-.65s.12-.57.19-.85.2-.71.3-1.07.19-.69.27-1c0-.17.06-.35.1-.52a14.24 14.24 0 012-4.92z"
          style={{
            transformOrigin: "396.844px 218.044px",
          }}
          id="prefix__elbrejso6p0x9"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M411.14 179.27a60.42 60.42 0 00-6.47 3.16c-.41.22-.85.45-1.29.72l.1-.18a64.29 64.29 0 005.1-10.07 45.26 45.26 0 002.84-11.18c0-.23-.21-.39-.27-.11-.41 1.75-1 3.45-1.6 5.16s-1.16 3.32-1.85 4.94a74.35 74.35 0 01-4.63 9.12c-.23.39-.47.78-.71 1.17v-.77a16.54 16.54 0 00-.3-3.21 18.65 18.65 0 00-.79-2.93 6.63 6.63 0 00-1.37-2.71c-.11-.1-.2.08-.18.18a19 19 0 001 2.67 17.77 17.77 0 01.65 2.89 19.25 19.25 0 01.15 2.94 18.74 18.74 0 00-.14 2.59c-1.26 2.09-2.51 4.18-3.64 6.34-.52 1-1 2-1.47 3v-.13a18.89 18.89 0 00-1.22-3.32c-1.11-2.46-2.4-4.87-2.82-7.57 0-.14-.15 0-.15.06a21.32 21.32 0 001.69 6.77c.43 1.17.82 2.35 1.14 3.56a12 12 0 01.34 1.79c0 .31.06.6.11.89l-.15.36a3 3 0 00-.46 1.08c-.33.76-.64 1.53-.94 2.31-1.09 2.81-2 5.67-2.87 8.57a18.14 18.14 0 00-.85-3.16 17.72 17.72 0 00-1.43-3.06 10.27 10.27 0 00-2-2.86c-.11-.09-.15.17-.12.23.43 1 1.1 1.86 1.53 2.86s.8 2 1.11 2.94a45.44 45.44 0 011.19 5.29 111.22 111.22 0 00-2.41 11.86c-.62-1.54-1.42-3-2.19-4.46-.1-.2-.25.1-.2.23a30.63 30.63 0 011.82 5.61c.07.39.15.78.21 1.17-.55 4.26-.89 8.55-1 12.84 0 .64.07 4.55.15 7a39.24 39.24 0 00.56 6 17.14 17.14 0 00.82 2.9h1.14a12.2 12.2 0 00-.2-1.33 53.69 53.69 0 01-1-10c0-1.08 0-2.16.05-3.24.07-3.34.28-6.68.6-10a11.82 11.82 0 011.35-2.62c1.53-2.22 3.88-3.66 5.47-5.81.09-.12.06-.59-.18-.46a26.43 26.43 0 00-3.6 2.73 13.94 13.94 0 00-2.65 2.72c.25-1.95.53-3.89.87-5.82.38-2.15.83-4.29 1.33-6.41a8.85 8.85 0 00.8-1c.35-.46.69-.93 1.07-1.37a10.88 10.88 0 012.52-2.11 10.37 10.37 0 012.72-1.21q.67-.19 1.38-.33a4.56 4.56 0 001.45-.33c.06 0 .09-.19 0-.23a5.55 5.55 0 00-3.49 0 11.52 11.52 0 00-3.24 1.3 11.1 11.1 0 00-2.42 2.06c.81-3 1.75-5.95 2.84-8.85.64-1.73 1.35-3.42 2.1-5.09a8 8 0 011.92-1.12 25.59 25.59 0 012.93-.94 16.23 16.23 0 002.73-1.1c.12 0 .14-.36 0-.32-1.14.31-2.36.4-3.51.62a15 15 0 00-3.14.88c1.12-2.36 2.34-4.68 3.62-7a11.78 11.78 0 011.41-1.66 17.36 17.36 0 012.68-1.62c1.92-1.09 3.82-2.15 5.62-3.42.05-.1.02-.47-.16-.4z"
          style={{
            transformOrigin: "398.49px 207.106px",
          }}
          id="prefix__el4ro0xfs6nsj"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <g id="prefix__elm2t36h6opbh">
          <path
            d="M411.14 179.27a60.42 60.42 0 00-6.47 3.16c-.41.22-.85.45-1.29.72l.1-.18a64.29 64.29 0 005.1-10.07 45.26 45.26 0 002.84-11.18c0-.23-.21-.39-.27-.11-.41 1.75-1 3.45-1.6 5.16s-1.16 3.32-1.85 4.94a74.35 74.35 0 01-4.63 9.12c-.23.39-.47.78-.71 1.17v-.77a16.54 16.54 0 00-.3-3.21 18.65 18.65 0 00-.79-2.93 6.63 6.63 0 00-1.37-2.71c-.11-.1-.2.08-.18.18a19 19 0 001 2.67 17.77 17.77 0 01.65 2.89 19.25 19.25 0 01.15 2.94 18.74 18.74 0 00-.14 2.59c-1.26 2.09-2.51 4.18-3.64 6.34-.52 1-1 2-1.47 3v-.13a18.89 18.89 0 00-1.22-3.32c-1.11-2.46-2.4-4.87-2.82-7.57 0-.14-.15 0-.15.06a21.32 21.32 0 001.69 6.77c.43 1.17.82 2.35 1.14 3.56a12 12 0 01.34 1.79c0 .31.06.6.11.89l-.15.36a3 3 0 00-.46 1.08c-.33.76-.64 1.53-.94 2.31-1.09 2.81-2 5.67-2.87 8.57a18.14 18.14 0 00-.85-3.16 17.72 17.72 0 00-1.43-3.06 10.27 10.27 0 00-2-2.86c-.11-.09-.15.17-.12.23.43 1 1.1 1.86 1.53 2.86s.8 2 1.11 2.94a45.44 45.44 0 011.19 5.29 111.22 111.22 0 00-2.41 11.86c-.62-1.54-1.42-3-2.19-4.46-.1-.2-.25.1-.2.23a30.63 30.63 0 011.82 5.61c.07.39.15.78.21 1.17-.55 4.26-.89 8.55-1 12.84 0 .64.07 4.55.15 7a39.24 39.24 0 00.56 6 17.14 17.14 0 00.82 2.9h1.14a12.2 12.2 0 00-.2-1.33 53.69 53.69 0 01-1-10c0-1.08 0-2.16.05-3.24.07-3.34.28-6.68.6-10a11.82 11.82 0 011.35-2.62c1.53-2.22 3.88-3.66 5.47-5.81.09-.12.06-.59-.18-.46a26.43 26.43 0 00-3.6 2.73 13.94 13.94 0 00-2.65 2.72c.25-1.95.53-3.89.87-5.82.38-2.15.83-4.29 1.33-6.41a8.85 8.85 0 00.8-1c.35-.46.69-.93 1.07-1.37a10.88 10.88 0 012.52-2.11 10.37 10.37 0 012.72-1.21q.67-.19 1.38-.33a4.56 4.56 0 001.45-.33c.06 0 .09-.19 0-.23a5.55 5.55 0 00-3.49 0 11.52 11.52 0 00-3.24 1.3 11.1 11.1 0 00-2.42 2.06c.81-3 1.75-5.95 2.84-8.85.64-1.73 1.35-3.42 2.1-5.09a8 8 0 011.92-1.12 25.59 25.59 0 012.93-.94 16.23 16.23 0 002.73-1.1c.12 0 .14-.36 0-.32-1.14.31-2.36.4-3.51.62a15 15 0 00-3.14.88c1.12-2.36 2.34-4.68 3.62-7a11.78 11.78 0 011.41-1.66 17.36 17.36 0 012.68-1.62c1.92-1.09 3.82-2.15 5.62-3.42.05-.1.02-.47-.16-.4z"
            style={{
              transformOrigin: "398.49px 207.106px",
            }}
            className="prefix__animable"
            id="prefix__eldyar42eejog"
            opacity={0.5}
          />
        </g>
        <path
          d="M394.88 245.11a14.15 14.15 0 00-.5-3.37 7.59 7.59 0 00-2.27-4.06 2.94 2.94 0 00-2.27-.63c.23 1.6.46 3.21.7 4.81 0 .17 0 .34.08.51a8.5 8.5 0 001.11 3.51 4.75 4.75 0 00.63.64 7.34 7.34 0 001.41 1.14l.24.14a.73.73 0 00.38.11c.45 0 .39-.71.42-1a12.24 12.24 0 00.07-1.6z"
          style={{
            transformOrigin: "392.361px 242.465px",
          }}
          id="prefix__ellwf1a6d2j5f"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M402.55 239.06a13.9 13.9 0 002.57-1.47c.17-.13.4-.27.59-.16a.54.54 0 01.2.31 4.07 4.07 0 01-1.05 3.37 12.9 12.9 0 01-3.1 3 9.3 9.3 0 01-3.91 1.55c-.83.11-2.66.26-2.3-1.09a4.57 4.57 0 01.8-1.47 14.7 14.7 0 011.3-1.54c1.2-1.19 2.84-1.65 4.37-2.26z"
          style={{
            transformOrigin: "400.729px 241.559px",
          }}
          id="prefix__elhczegb2nefs"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M402.77 230.25a13.87 13.87 0 019 .31 3.88 3.88 0 011.93 1.19 1.55 1.55 0 01-.11 2.07 2.39 2.39 0 01-.89.36l-13.93 3.42a3.5 3.5 0 01-1.12.11c-.18 0-.34-.12-.51-.15s-.29.06-.39-.11a.65.65 0 01-.06-.34 4.11 4.11 0 01.07-.86 1.34 1.34 0 01.14-.38c.16-.3.28-.63.43-.94a9.17 9.17 0 013.08-3.49 10.26 10.26 0 012.36-1.19z"
          style={{
            transformOrigin: "405.366px 233.682px",
          }}
          id="prefix__elx91byazh5ib"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M405.26 221.91c2.38-1.25 5.18-1.37 7.88-1.46a.61.61 0 01.44.11.47.47 0 01.12.3 4.12 4.12 0 01-1.28 3.24 10.51 10.51 0 01-3.44 2.54 20.58 20.58 0 01-3.93 1.22l-3.61.87c-.24.06-.78.35-1 .18s0-.91.05-1.14a8.32 8.32 0 01.68-1.37 11.49 11.49 0 011.53-2.44 9 9 0 012.56-2.05z"
          style={{
            transformOrigin: "407.026px 224.704px",
          }}
          id="prefix__elh2g2xus260u"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M392.2 229.61c-.07-.05-.16-.1-.23-.06a.22.22 0 00-.1.17 3 3 0 00-.12.58v.16a2.05 2.05 0 01-.1.48 5 5 0 00-.1 1.09 5.67 5.67 0 00.15 1.16 8.3 8.3 0 001.12 2.57 4.19 4.19 0 00.4.54c.16.18.35.35.52.52a7.39 7.39 0 011 1.31c.08.13.19.28.34.26a.39.39 0 00.22-.18 1.58 1.58 0 00.34-.55 5.13 5.13 0 00.13-.66v-.11a8.22 8.22 0 00-.42-3.37 8.13 8.13 0 00-.71-1.56 8.45 8.45 0 00-2.44-2.35z"
          style={{
            transformOrigin: "393.674px 233.964px",
          }}
          id="prefix__elveub1i1ady"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <path
          d="M406.41 233.2a6.63 6.63 0 00-3.48.07 17.21 17.21 0 00-3.67 1.08 9.23 9.23 0 00-2 1.25 21.86 21.86 0 013.21-5.08 25.51 25.51 0 015.14-4.87c.08-.05.09-.32 0-.27a19.25 19.25 0 00-5.25 3.38 19.63 19.63 0 00-3.86 5.15 21.26 21.26 0 00-1.21 2.72c-.06-.18-.11-.36-.17-.54a9.67 9.67 0 00-.76-1.63 4.72 4.72 0 00-.51-.75c-.12-.15-.27-.42-.5-.39 0 0-.06.07-.06.11a2.2 2.2 0 00.33.81c.12.22.24.44.35.67a13.12 13.12 0 01.55 1.4c.16.5.25 1 .37 1.52a20.53 20.53 0 00-.5 2 27.86 27.86 0 00-.43 4c-.11-.28-.22-.56-.35-.84a11.24 11.24 0 00-1.36-2.12c-.11-.13-.2.17-.13.27a11.14 11.14 0 011.66 4.43c.05.28.09.55.14.82v6.26c0 1.15-.13 2.3-.21 3.44h1.08a23.2 23.2 0 00.55-5.86v-4.55h.07a3.31 3.31 0 01.81-.37 11.4 11.4 0 001.72-.76 11.19 11.19 0 002.92-2.24c.06-.07 0-.28-.06-.18a6.73 6.73 0 01-3.25 1.76c-.63.17-1.26.36-1.89.55l-.29.1c0-.71.06-1.41.13-2.11a20.86 20.86 0 01.66-3.64c.5-.52.88-1.19 1.39-1.7a9.35 9.35 0 012.36-1.67 16.19 16.19 0 013-1.12l1.63-.44a4.68 4.68 0 011.87-.36c.07-.05.1-.27 0-.3z"
          style={{
            transformOrigin: "399.285px 240.732px",
          }}
          id="prefix__elz9f9mj5vr4"
          className="prefix__animable"
          fill="#22c4d6"
        />
        <g id="prefix__elfyl2jxxnuj">
          <path
            d="M406.41 233.2a6.63 6.63 0 00-3.48.07 17.21 17.21 0 00-3.67 1.08 9.23 9.23 0 00-2 1.25 21.86 21.86 0 013.21-5.08 25.51 25.51 0 015.14-4.87c.08-.05.09-.32 0-.27a19.25 19.25 0 00-5.25 3.38 19.63 19.63 0 00-3.86 5.15 21.26 21.26 0 00-1.21 2.72c-.06-.18-.11-.36-.17-.54a9.67 9.67 0 00-.76-1.63 4.72 4.72 0 00-.51-.75c-.12-.15-.27-.42-.5-.39 0 0-.06.07-.06.11a2.2 2.2 0 00.33.81c.12.22.24.44.35.67a13.12 13.12 0 01.55 1.4c.16.5.25 1 .37 1.52a20.53 20.53 0 00-.5 2 27.86 27.86 0 00-.43 4c-.11-.28-.22-.56-.35-.84a11.24 11.24 0 00-1.36-2.12c-.11-.13-.2.17-.13.27a11.14 11.14 0 011.66 4.43c.05.28.09.55.14.82v6.26c0 1.15-.13 2.3-.21 3.44h1.08a23.2 23.2 0 00.55-5.86v-4.55h.07a3.31 3.31 0 01.81-.37 11.4 11.4 0 001.72-.76 11.19 11.19 0 002.92-2.24c.06-.07 0-.28-.06-.18a6.73 6.73 0 01-3.25 1.76c-.63.17-1.26.36-1.89.55l-.29.1c0-.71.06-1.41.13-2.11a20.86 20.86 0 01.66-3.64c.5-.52.88-1.19 1.39-1.7a9.35 9.35 0 012.36-1.67 16.19 16.19 0 013-1.12l1.63-.44a4.68 4.68 0 011.87-.36c.07-.05.1-.27 0-.3z"
            style={{
              transformOrigin: "399.285px 240.732px",
            }}
            className="prefix__animable"
            id="prefix__elev7yz3fla0h"
            opacity={0.5}
          />
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--Character--inject-40"
      className="prefix__animable"
      style={{
        transformOrigin: "335.336px 316.873px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--character--inject-40"
        className="prefix__animable"
        style={{
          transformOrigin: "335.336px 316.873px",
        }}
      >
        <g
          id="prefix__freepik--Sofa--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "336.434px 335.311px",
          }}
        >
          <path
            d="M324.33 465.22a2.12 2.12 0 01-2.11-2l-3.1-44.16c-.17-2.29-1.38-4.47-2.41-5.06l-77-45.39a3 3 0 00-.25 1.1l-3.11 40.58a2.12 2.12 0 01-4.23-.33l3.11-40.58c.17-2.21 1.08-3.85 2.55-4.63a4.17 4.17 0 014.08.2l77 45.39c2.41 1.39 4.26 4.85 4.51 8.43l3.08 44.23a2.12 2.12 0 01-2 2.26z"
            style={{
              transformOrigin: "279.284px 414.786px",
            }}
            id="prefix__elfibd32t7t1k"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M440.37 398.17a2.12 2.12 0 01-2.11-2L435.15 352c-.16-2.3-1.37-4.47-2.4-5.07l-77-45.38a3.27 3.27 0 00-.26 1.1l-3.1 40.58a2.12 2.12 0 01-4.23-.32l3.11-40.58c.17-2.21 1.08-3.86 2.55-4.64a4.15 4.15 0 014.07.21l77 45.39c2.4 1.38 4.26 4.85 4.51 8.43l3.1 44.16a2.1 2.1 0 01-2 2.26z"
            style={{
              transformOrigin: "395.33px 347.713px",
            }}
            id="prefix__elj2wm6t8woia"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M321.47 417l-84.67-49.83c-2.33-1.34-3.67-3.34-3.67-5.48s1.34-4.13 3.67-5.47l103.67-59.92a16 16 0 0114.65 0l84.68 49.8c2.33 1.35 3.67 3.35 3.67 5.48s-1.34 4.13-3.67 5.48L336.12 417a16 16 0 01-14.65 0zm21.17-117L239 360c-.93.54-1.5 1.2-1.5 1.73s.57 1.2 1.5 1.74l84.68 49.8a11.56 11.56 0 0010.32 0l103.68-59.92c.92-.53 1.5-1.2 1.5-1.73s-.58-1.19-1.5-1.73L353 300a11.61 11.61 0 00-10.32 0zm11.36-1.83z"
            style={{
              transformOrigin: "338.3px 356.65px",
            }}
            id="prefix__elbea5v616v3f"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M394 317.05a1.72 1.72 0 001.69-1.36l7-32.16a1.73 1.73 0 10-3.38-.74l-7 32.16a1.73 1.73 0 001.29 2.05 1.61 1.61 0 00.4.05z"
            style={{
              transformOrigin: "397.5px 299.24px",
            }}
            id="prefix__el2r2ck6h8smv"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M375.89 306.62a1.73 1.73 0 001.69-1.37l7-32.16a1.73 1.73 0 10-3.38-.74l-7 32.17a1.74 1.74 0 001.32 2.06 2.46 2.46 0 00.37.04z"
            style={{
              transformOrigin: "379.391px 288.805px",
            }}
            id="prefix__elepml7cts0ch"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M354.54 264a1.75 1.75 0 011-1.45l9.06-5.23a5.57 5.57 0 015 0l50.56 29.19a1.75 1.75 0 011 1.45v2.7a1.74 1.74 0 01-1 1.44l-9.06 5.23a5.51 5.51 0 01-5 0l-50.56-29.19a1.74 1.74 0 01-1-1.44z"
            style={{
              transformOrigin: "387.85px 277.329px",
            }}
            id="prefix__elzebxfd8div"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M355.57 262.52l9.06-5.23a5.57 5.57 0 015 0l39 22.52v18.09a5.11 5.11 0 01-2.5-.6l-50.56-29.19a1.74 1.74 0 01-1-1.44V264a1.75 1.75 0 011-1.48z"
            style={{
              transformOrigin: "381.6px 277.299px",
            }}
            id="prefix__elmc0po3nwku"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M369.63 257.29l50.56 29.19a1.53 1.53 0 010 2.89l-9.06 5.23a5.51 5.51 0 01-5 0l-50.56-29.19a1.53 1.53 0 010-2.89l9.06-5.23a5.57 5.57 0 015 0z"
            style={{
              transformOrigin: "387.88px 275.949px",
            }}
            id="prefix__els9b7yvv87h"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M242.35 344.1l107.12-61.92a2.2 2.2 0 012.21.21L434 330.86a6.87 6.87 0 013.12 5.41v13.06a2.19 2.19 0 01-.91 2l-107.12 61.94a2.17 2.17 0 01-2.2-.22l-82.33-48.46a6.92 6.92 0 01-3.12-5.41v-13.06a2.19 2.19 0 01.91-2.02z"
            style={{
              transformOrigin: "339.279px 347.724px",
            }}
            id="prefix__el3fjrgf7eeif"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__elpf761tz8qyc">
            <g
              style={{
                transformOrigin: "339.279px 347.724px",
              }}
              className="prefix__animable"
              id="prefix__el9imyp840e67"
              opacity={0.8}
            >
              <path
                d="M242.35 344.1l107.12-61.92a2.2 2.2 0 012.21.21L434 330.86a6.87 6.87 0 013.12 5.41v13.06a2.19 2.19 0 01-.91 2l-107.12 61.94a2.17 2.17 0 01-2.2-.22l-82.33-48.46a6.92 6.92 0 01-3.12-5.41v-13.06a2.19 2.19 0 01.91-2.02z"
                style={{
                  transformOrigin: "339.279px 347.724px",
                }}
                id="prefix__elfkim9x2yagp"
                className="prefix__animable"
                fill="#fff"
              />
            </g>
          </g>
          <path
            d="M329.1 413.26l107.11-61.91a2.22 2.22 0 00.92-2v-13.08a6.57 6.57 0 00-1.05-3.29L329 394.9a6.53 6.53 0 011 3.28v13.07a2.17 2.17 0 01-.9 2.01z"
            style={{
              transformOrigin: "383.069px 373.12px",
            }}
            id="prefix__elck1lgv91ahc"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__elqhtgj5yho8">
            <g
              style={{
                transformOrigin: "383.069px 373.12px",
              }}
              className="prefix__animable"
              id="prefix__el4no1w6h7cq5"
              opacity={0.6}
            >
              <path
                d="M329.1 413.26l107.11-61.91a2.22 2.22 0 00.92-2v-13.08a6.57 6.57 0 00-1.05-3.29L329 394.9a6.53 6.53 0 011 3.28v13.07a2.17 2.17 0 01-.9 2.01z"
                style={{
                  transformOrigin: "383.069px 373.12px",
                }}
                id="prefix__elmqofxu2le6j"
                className="prefix__animable"
                fill="#fff"
              />
            </g>
          </g>
          <g id="prefix__elqscqcmv8bga">
            <g
              style={{
                transformOrigin: "285.702px 378.658px",
              }}
              className="prefix__animable"
              id="prefix__elczley1tth3h"
              opacity={0.4}
            >
              <path
                d="M330 411.25v-13.06a6.92 6.92 0 00-3.12-5.41l-82.33-48.46a1.9 1.9 0 00-3.12 1.8v13.06a6.92 6.92 0 003.12 5.41l82.33 48.46a2.17 2.17 0 002.2.22 2.19 2.19 0 00.92-2.02z"
                style={{
                  transformOrigin: "285.702px 378.658px",
                }}
                id="prefix__elxr2domffvk"
                className="prefix__animable"
                fill="#22c4d6"
              />
            </g>
          </g>
          <path
            d="M234.6 260.64L330 205.5a2 2 0 011.95.28l11.32 6.54a8.7 8.7 0 013.74 5.35l12.63 72.91c.18 1 0 1.73-.54 2l-95.4 55.17a2 2 0 01-2-.28l-11.32-6.54a8.7 8.7 0 01-3.74-5.35l-12.63-72.91c-.14-1.03.08-1.73.59-2.03z"
            style={{
              transformOrigin: "296.838px 276.632px",
            }}
            id="prefix__ele35icpldk15"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__elc0mjqeb46lv">
            <g
              style={{
                transformOrigin: "296.838px 276.632px",
              }}
              className="prefix__animable"
              id="prefix__el5mtb4j2key9"
              opacity={0.8}
            >
              <path
                d="M234.6 260.64L330 205.5a2 2 0 011.95.28l11.32 6.54a8.7 8.7 0 013.74 5.35l12.63 72.91c.18 1 0 1.73-.54 2l-95.4 55.17a2 2 0 01-2-.28l-11.32-6.54a8.7 8.7 0 01-3.74-5.35l-12.63-72.91c-.14-1.03.08-1.73.59-2.03z"
                style={{
                  transformOrigin: "296.838px 276.632px",
                }}
                id="prefix__ellegujpbym9a"
                className="prefix__animable"
                fill="#fff"
              />
            </g>
          </g>
          <path
            d="M264.25 345.72c.17 1 0 1.73-.55 2l95.41-55.15c.5-.29.72-1 .54-2L347 217.67a7.86 7.86 0 00-1.4-3.1l-95.4 55.14a7.85 7.85 0 011.4 3.1z"
            style={{
              transformOrigin: "304.956px 281.145px",
            }}
            id="prefix__elcsyh41j2m1b"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__elsnqdipsnv1">
            <g
              style={{
                transformOrigin: "304.956px 281.145px",
              }}
              className="prefix__animable"
              id="prefix__elaipitgusr78"
              opacity={0.6}
            >
              <path
                d="M264.25 345.72c.17 1 0 1.73-.55 2l95.41-55.15c.5-.29.72-1 .54-2L347 217.67a7.86 7.86 0 00-1.4-3.1l-95.4 55.14a7.85 7.85 0 011.4 3.1z"
                style={{
                  transformOrigin: "304.956px 281.145px",
                }}
                id="prefix__elfnkfkysgn1h"
                className="prefix__animable"
                fill="#fff"
              />
            </g>
          </g>
          <g id="prefix__elbwbg9suodfo">
            <g
              style={{
                transformOrigin: "249.172px 304.211px",
              }}
              className="prefix__animable"
              id="prefix__el8xljk8wp55o"
              opacity={0.4}
            >
              <path
                d="M261.74 347.47l-11.32-6.54a8.7 8.7 0 01-3.74-5.35l-12.63-72.91c-.18-1 0-1.73.55-2a2 2 0 012 .28l11.33 6.54a8.76 8.76 0 013.74 5.36l12.63 72.9c.18 1-.05 1.74-.55 2a2 2 0 01-2.01-.28z"
                style={{
                  transformOrigin: "249.172px 304.211px",
                }}
                id="prefix__el503av40bye6"
                className="prefix__animable"
                fill="#22c4d6"
              />
            </g>
          </g>
          <g
            id="prefix__freepik--Cushion--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "272.949px 306.602px",
            }}
          >
            <path
              d="M281.6 262.46c-4.36-.44-8 4.59-15.23 8.14-13.54 6.63-19.64 12.65-25.94 20s-8.69 6.11-10.62 10.69 3.4 6.54 5.94 13c4.28 10.95 9.6 18.3 15.14 22.87 9.78 8.05 8.28 13.66 12.73 13.61 4.74-.06 4.4-4.12 11.85-7 17.62-6.84 24.85-12.94 33-25 3.18-4.71 7.23-4.31 8-8.86.38-2.27-2.92-3.49-5.9-10.62-5-11.85-12.87-23-20.58-28.75-3.38-2.49-3.99-7.64-8.39-8.08z"
              style={{
                transformOrigin: "272.949px 306.602px",
              }}
              id="prefix__elt57d728ism"
              className="prefix__animable"
              fill="#22c4d6"
            />
            <g id="prefix__elh8lqve39eii">
              <path
                d="M281.6 262.46c-4.36-.44-8 4.59-15.23 8.14-13.54 6.63-19.64 12.65-25.94 20s-8.69 6.11-10.62 10.69 3.4 6.54 5.94 13c4.28 10.95 9.6 18.3 15.14 22.87 9.78 8.05 8.28 13.66 12.73 13.61 4.74-.06 4.4-4.12 11.85-7 17.62-6.84 24.85-12.94 33-25 3.18-4.71 7.23-4.31 8-8.86.38-2.27-2.92-3.49-5.9-10.62-5-11.85-12.87-23-20.58-28.75-3.38-2.49-3.99-7.64-8.39-8.08z"
                style={{
                  transformOrigin: "272.949px 306.602px",
                }}
                className="prefix__animable"
                id="prefix__elwwqkaf4nw3r"
                opacity={0.3}
              />
            </g>
            <g id="prefix__el1496s4oon62">
              <path
                d="M234.61 308.91c3.72 5.28 3.23 10.54 10.88 20.24 7.35 9.31 12.68 11.93 14.88 16.11 1.83 3.47 4.33 5.1 4.93 1s-2.6-15.68-10-25.62c-8.53-11.45-14-15.83-17.65-17.51-5.79-2.61-5.97 1.63-3.04 5.78z"
                style={{
                  transformOrigin: "249.059px 325.505px",
                }}
                className="prefix__animable"
                id="prefix__elyytvpax2sd"
                opacity={0.2}
              />
            </g>
            <g id="prefix__elhj1gm0ae7x4">
              <path
                d="M275.76 339.31c-4.86 1.68-5.07 6-7.51 9.32a19.25 19.25 0 017.22-4.85c8-3.11 13.89-6.08 18.67-9.52-6.22 3.28-14.85 3.83-18.38 5.05zM306.2 317c-3 2.78-2.71 7.71-6.34 12.48a68.18 68.18 0 008.6-10.65c2.9-4.3 6.53-4.35 7.72-7.79-2.67 3.35-6.35 2.59-9.98 5.96z"
                style={{
                  transformOrigin: "292.215px 329.835px",
                }}
                className="prefix__animable"
                id="prefix__elx5fy30xjisi"
                opacity={0.2}
              />
            </g>
            <g id="prefix__elnnxdunc3hz9">
              <path
                d="M275.54 273c-10.38 1.94-20.75 7.29-27.89 15.27a8.3 8.3 0 00-1.9 6 8.07 8.07 0 004.19 6.56c2.44 1.38 6 1.39 8.56 1.06 5.37-.69 8.53-2.09 15.48-2.2a15.9 15.9 0 017.32 1.85c3.42 1.9 6 4.06 9 5.66 4.13 2.22 11.47 1.21 14-1.34 2.72-2.73 3.33-6.82.89-11.95-5.41-11.42-15.5-22.52-29.65-20.91z"
                style={{
                  transformOrigin: "276.221px 290.634px",
                }}
                className="prefix__animable"
                id="prefix__el0vfqywjmpu9d"
                fill="#22c4d6"
                opacity={0.3}
              />
            </g>
          </g>
          <g
            id="prefix__freepik--cushion--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "364.557px 284.597px",
            }}
          >
            <path
              d="M336.53 248.07c3.79-2.19 9.16.89 17.24 1.13 15.07.44 26.94 3.68 35.71 7.76s10.44 2 14.08 5.35-.39 7.36 0 14.33c.63 11.74-1.18 20.63-4.34 27.08-5.58 11.37-1.9 15.86-6 17.65-4.34 1.91-5.71-1.93-13.69-1.49-18.87 1-31.81-1.8-44.2-9.4-4.84-3-8.36-.94-10.94-4.76-1.29-1.92 1.22-4.39 1-12.12-.38-12.84 2.23-26.23 6.87-34.68 2.03-3.68.42-8.61 4.27-10.85z"
              style={{
                transformOrigin: "364.557px 284.597px",
              }}
              id="prefix__el4y2u3gwa1yu"
              className="prefix__animable"
              fill="#22c4d6"
            />
            <g id="prefix__eln5yaulhcfb9">
              <path
                d="M336.53 248.07c3.79-2.19 9.16.89 17.24 1.13 15.07.44 26.94 3.68 35.71 7.76s10.44 2 14.08 5.35-.39 7.36 0 14.33c.63 11.74-1.18 20.63-4.34 27.08-5.58 11.37-1.9 15.86-6 17.65-4.34 1.91-5.71-1.93-13.69-1.49-18.87 1-31.81-1.8-44.2-9.4-4.84-3-8.36-.94-10.94-4.76-1.29-1.92 1.22-4.39 1-12.12-.38-12.84 2.23-26.23 6.87-34.68 2.03-3.68.42-8.61 4.27-10.85z"
                style={{
                  transformOrigin: "364.557px 284.597px",
                }}
                className="prefix__animable"
                id="prefix__ellhozf74z7x"
                opacity={0.3}
              />
            </g>
            <g id="prefix__eltm68x7oq25d">
              <path
                d="M402.35 271.24c-1.21 6.34 1.41 10.93-1.55 22.93-2.85 11.52-6.62 16.1-6.9 20.82-.23 3.91-1.84 6.43-4.06 3s-4.11-15.35-1.47-27.47c3-13.95 6.18-20.19 8.85-23.24 4.17-4.81 6.08-1.03 5.13 3.96z"
                style={{
                  transformOrigin: "394.836px 292.332px",
                }}
                className="prefix__animable"
                id="prefix__el8r5mec36ukr"
                opacity={0.2}
              />
            </g>
            <g id="prefix__eljt6k2okdfkm">
              <path
                d="M358.6 318.92c5.78 1.16 12.34 1.43 20.94 1a19.25 19.25 0 018.58 1.42c-3.6-2-5.57-5.86-10.7-5.38-3.71.31-11.8 3.37-18.82 2.96zm-33.5-12.35c2.5 2.64 5.82 1.19 10.24 3.91a68.24 68.24 0 0012.23 6.14c-5.27-2.84-7-7.46-10.92-8.74-4.65-1.55-7.73.67-11.55-1.31z"
                style={{
                  transformOrigin: "356.61px 313.955px",
                }}
                className="prefix__animable"
                id="prefix__el29qbt80l1vm"
                opacity={0.2}
              />
            </g>
            <g id="prefix__eluos4zs85wyi">
              <path
                d="M346.39 255.12c10.25-2.52 24-2.44 33.77 1.89 1.89.92 5.27 3.36 6 5.47a8.06 8.06 0 01-1.11 7.71c-1.65 2.26-4.9 3.74-7.35 4.5-5.18 1.59-10.44 1-17.21 3.39a21.3 21.3 0 00-7.53 5.43c-2.33 3.15-3.77 6.17-5.84 8.87-2.85 3.73-10 5.83-13.32 4.56-3.61-1.35-5.85-4.83-5.75-10.5.2-12.61 4.81-26.89 18.34-31.32z"
                style={{
                  transformOrigin: "357.364px 275.377px",
                }}
                className="prefix__animable"
                id="prefix__elyyh8iso303"
                fill="#22c4d6"
                opacity={0.3}
              />
            </g>
          </g>
        </g>
        <g
          id="prefix__freepik--character--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "344.525px 288.803px",
          }}
        >
          <g
            id="prefix__freepik--Bottom--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "351.298px 348.434px",
            }}
          >
            <path
              d="M359.63 355.81l8.81-17.35 17.72 10.37-21.85 25.79s-10.83-1-12.57-6.65 4.91-10.29 7.89-12.16z"
              style={{
                transformOrigin: "368.807px 356.54px",
              }}
              id="prefix__el7o18d1lz048"
              className="prefix__animable"
              fill="#f28f8f"
            />
            <path
              d="M359.63 355.81l-1.08 2a15.46 15.46 0 005.62 7.11c4.24 2.92 6.09 2.68 6.09 2.68l1-1.16s.6.52-1 2.28a28.4 28.4 0 00-5.1 7.19c-2 3.88-3.52 13-3.71 19.59s.77 11.3-4.34 13.19-10.31-2.82-13.18-7.17-3.88-11-3.18-15.76 4.37-7.87 3.68-13.42c-.5-4.08.16-8.11 2-10.09s5.56-2.51 8.08-3.89 4.11-3.08 5.12-2.55z"
              style={{
                transformOrigin: "355.953px 382.415px",
              }}
              id="prefix__elt3gciq8uajc"
              className="prefix__animable"
              fill="#f5f5f5"
            />
            <path
              d="M361.42 399.55c-3.34-6.38-14.68-8.18-20.34-5.42a20.85 20.85 0 002.85 7.38c2.87 4.36 8.07 9.06 13.18 7.18 3.99-1.48 4.28-4.69 4.31-9.14z"
              style={{
                transformOrigin: "351.25px 400.997px",
              }}
              id="prefix__elxe6dvfrfvbr"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <path
              d="M352.91 359.07c-2.32.92-5 1.58-6.51 3.18-1.81 2-2.47 6-2 10.09 0 .18 0 .35.05.52 5.37-1.65 10.2-9.61 8.46-13.79z"
              style={{
                transformOrigin: "348.762px 365.965px",
              }}
              id="prefix__elk291vcj1x1a"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <path
              d="M336 295.45s46.76-7.82 64.63-7.7c18.23.11 19.93 13.8 15.36 22.19-8.73 16.05-33.94 44.2-33.94 44.2s-14-1.89-17.15-10.71l5.57-12.77-21.8 7-11.13-7.47-5.54-3.66z"
              style={{
                transformOrigin: "375.067px 320.944px",
              }}
              id="prefix__elg34lxwi479h"
              className="prefix__animable"
              fill="#37474f"
            />
            <path
              d="M366.88 343.73s9.53 3.82 13.94 5a73.48 73.48 0 007.47 1.68l-2.29 15.7-23-2.48z"
              style={{
                transformOrigin: "375.645px 354.92px",
              }}
              id="prefix__elpvpudedmzs"
              className="prefix__animable"
              fill="#ffa8a7"
            />
            <path
              d="M384.27 349.63c1.68.49 3 5.73 2.37 9.13-.49 2.63-2.58 6.86-4.24 7l-1.62-.18s.19 1.06 2.8 1.16 10.59 1.12 13.6 1.33 9.45 2.48 13.36 2.92 7.7 1.47 13.86-1.5 9.88-9.85 6.92-15.08-9.45-5.85-14.74-5.75-14.21 2.17-20.09 1.78a66 66 0 01-11.57-1.68 3 3 0 00-2.77.38z"
              style={{
                transformOrigin: "406.568px 360.052px",
              }}
              id="prefix__elo7wgd2mxnq"
              className="prefix__animable"
              fill="#f5f5f5"
            />
            <path
              d="M431.32 354.38c-2.32-4.14-6.91-5.38-11.32-5.68 2.94 2 3.81 17.86-2.82 22.76a18.88 18.88 0 007.23-2c6.14-2.97 9.87-9.85 6.91-15.08z"
              style={{
                transformOrigin: "424.767px 360.08px",
              }}
              id="prefix__el6nqoa688zaq"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <path
              d="M371.66 344.09c-12-6.17-29.55-16.22-36.82-18l-.57-.13c3.28-8 5.48-15.06 1.75-30.51l-65.78 11.14s.42 22.29 6.59 32.8 13.21 14.5 24.06 18.48c9.26 3.4 26.35 2.23 26.35 2.23 3.36 1.91 8 3.17 13.61 3.63 7.11.59 20.34.63 28.06 1.07 4.71-5.73 4.45-19.8 2.75-20.71z"
              style={{
                transformOrigin: "321.511px 330.125px",
              }}
              id="prefix__elq9u478u770m"
              className="prefix__animable"
              fill="#455a64"
            />
            <path
              d="M374.14 317.13a156.62 156.62 0 00-9.21 15.3l5.57-1.78c6.28-14.95 7.57-19.31 17.6-26.32 0 0-7.2 2.67-13.96 12.8z"
              style={{
                transformOrigin: "376.515px 318.38px",
              }}
              id="prefix__el9nb1mqiwosw"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M323.46 356.41a8.09 8.09 0 001.36 3.81c1.51-.06 2.42-.12 2.42-.12h.08a20.47 20.47 0 01-3.86-3.69z"
              style={{
                transformOrigin: "325.39px 358.315px",
              }}
              id="prefix__el9l3c6dzmbbp"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M346.87 331.1c5 2.32 8.54 4.39 8.54 4.39l3.79-1.22s-9.27-4.71-16.31-8.21c-1-.49-4.36-2.18-5.24-2.68a29.24 29.24 0 00.32-13.51 37 37 0 01-2.51 13.06c-2.79-.77-5.09-.57-9.1.1-7 1.17-27.26 4.62-27.26 4.62s19.42-2 29.53-2.14a21.92 21.92 0 015.65.45c5.54 1.47 9.89 3.9 12.59 5.14z"
              style={{
                transformOrigin: "329.15px 322.68px",
              }}
              id="prefix__el1lxzwoxd2wc"
              className="prefix__animable"
              fill="#263238"
            />
          </g>
          <g
            id="prefix__freepik--Top--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "334.958px 260.358px",
            }}
          >
            <path
              id="prefix__freepik--Arm--inject-40"
              d="M316.36 227.94c7.91 0 15.84 3.74 16.67 12.76.73 8-.34 28.38-.34 28.38l16.91 12.73-9.36 11.71s-16.59-8-22.32-11c-8.76-4.54-7.72-6.37-7.25-17.35s5.69-37.23 5.69-37.23z"
              style={{
                transformOrigin: "329.984px 260.73px",
              }}
              className="prefix__animable"
              fill="#ffa8a7"
            />
            <g
              id="prefix__freepik--Chest--inject-40"
              className="prefix__animable"
              style={{
                transformOrigin: "303.917px 275.576px",
              }}
            >
              <path
                d="M269.5 268.87c1.47-21.5 2.16-27.37 6.88-34.41 8.83-4.34 25.91-6.25 40-6.52 4.61 4.43 17.15 12.07 21.09 21a18.37 18.37 0 01-5.36 21.16c.1 6.4 0 15.19 0 15.19s2.54 4.48 6.1 9.79c-1 10.57-13 21.27-31.87 26.38a50.42 50.42 0 01-36-3.71s-2.34-27.58-.84-48.88z"
                style={{
                  transformOrigin: "303.917px 275.576px",
                }}
                id="prefix__el4bmfqqthpnj"
                className="prefix__animable"
                fill="#fafafa"
              />
              <path
                d="M319.89 271.64s-5.1 6.85-15.81 6.1c-11.06-.78-13.58-9.8-13.58-9.8s0 12 13.24 12.89a15.89 15.89 0 0016.15-9.19z"
                style={{
                  transformOrigin: "305.195px 274.431px",
                }}
                id="prefix__eldmt5q0b7h7"
                className="prefix__animable"
                fill="#f0f0f0"
              />
            </g>
            <g
              id="prefix__freepik--Laptop--inject-40"
              className="prefix__animable"
              style={{
                transformOrigin: "359.985px 311.86px",
              }}
            >
              <path
                d="M306.75 329.26v1.19a3.37 3.37 0 001.67 2.91l32 18.4a3.31 3.31 0 001.68.45 3.35 3.35 0 001.67-.45l58.68-33.87a3.36 3.36 0 001.68-2.91v-.82l-62 35.82z"
                style={{
                  transformOrigin: "355.44px 333.185px",
                }}
                id="prefix__elur2q681i2mn"
                className="prefix__animable"
                fill="#ebebeb"
              />
              <path
                d="M404.12 314.16l-34.79-20.08a2 2 0 00-2 0L307 328.93a.44.44 0 000 .77l35.09 20.3z"
                style={{
                  transformOrigin: "355.447px 321.906px",
                }}
                id="prefix__elavfirhl6kpd"
                className="prefix__animable"
                fill="#fafafa"
              />
              <path
                style={{
                  transformOrigin: "359.865px 325.775px",
                }}
                id="prefix__elk4vn0fixsh"
                className="prefix__animable"
                fill="#e0e0e0"
                d="M341.77 347.03L323 336.2l54.87-31.68 18.86 10.77-54.96 31.74z"
              />
              <path
                style={{
                  transformOrigin: "345.66px 314.855px",
                }}
                id="prefix__elyypic3jypn"
                className="prefix__animable"
                fill="#e0e0e0"
                d="M332.54 316.92l.35.2 9.2 5.31 16.35-9.45.34-.19-9.54-5.51-16.7 9.64z"
              />
              <path
                style={{
                  transformOrigin: "345.665px 315.055px",
                }}
                id="prefix__elogzk4unsnuo"
                className="prefix__animable"
                fill="#e6e6e6"
                d="M332.89 317.12l9.2 5.31 16.35-9.45-9.2-5.3-16.35 9.44z"
              />
              <path
                d="M342.09 350v2.23a3.35 3.35 0 001.67-.45l58.68-33.87a3.36 3.36 0 001.68-2.91v-.82z"
                style={{
                  transformOrigin: "373.105px 333.205px",
                }}
                id="prefix__elql11i0mypz"
                className="prefix__animable"
                fill="#ebebeb"
              />
              <g id="prefix__elyxkastrzjo">
                <g
                  style={{
                    mixBlendMode: "multiply",
                    transformOrigin: "373.105px 333.205px",
                  }}
                  className="prefix__animable"
                  id="prefix__elsuda1jbi08"
                  opacity={0.5}
                >
                  <path
                    d="M342.09 350v2.23a3.35 3.35 0 001.67-.45l58.68-33.87a3.36 3.36 0 001.68-2.91v-.82z"
                    style={{
                      transformOrigin: "373.105px 333.205px",
                    }}
                    id="prefix__elqyg0blzmub"
                    className="prefix__animable"
                    fill="#e0e0e0"
                  />
                </g>
              </g>
              <path
                d="M349.6 281.81a31.51 31.51 0 0010.52 6.11c7.22 2.52 8.71 2.46 14.37 6.75a47.86 47.86 0 015.5 5.14c1.67 2.89 4 5.36 5.84 8.12 1.51 1.65-.34 2.13-1.79 1.9-4-.82-6.41-4.63-9.64-6.74a13.56 13.56 0 01-.26 4.07c-.23 1.07-.28 2.41-1.39 3a8.32 8.32 0 01-2.43.42 1.68 1.68 0 01-.67.94 2.73 2.73 0 01-2 .06 7.55 7.55 0 01-1-.4 2 2 0 01-1.54 1.27 8.76 8.76 0 01-4.58-.85c-.21-.14-1.7-1.43-2.14-1.8-.63-.53-1.22-.88-1.43-1.42s1.07-1.69 2-1.63a9.09 9.09 0 012.85.83 10.3 10.3 0 01-.3-2.68c-.5-1.44-6.48-1.42-11.34-3.42-3.67-1.5-5.19-5-6.8-6q-1.49-1-3.06-1.92"
                style={{
                  transformOrigin: "363.351px 297.146px",
                }}
                id="prefix__ellrmmtpai93s"
                className="prefix__animable"
                fill="#ffa8a7"
              />
              <path
                d="M343 350.47a4 4 0 003.43-.26l58.41-33.73a4 4 0 001.94-2.78l6.39-38.14a3.49 3.49 0 00.05-.65 4 4 0 00-1.17-2.82l-60.71 35.05a3 3 0 00-1.43 2.06z"
                style={{
                  transformOrigin: "378.11px 311.414px",
                }}
                id="prefix__el2hukz5ygk2f"
                className="prefix__animable"
                fill="#22c4d6"
              />
              <g id="prefix__elf6bo5idqkrk">
                <g
                  style={{
                    transformOrigin: "378.11px 311.414px",
                  }}
                  className="prefix__animable"
                  id="prefix__elmvlhlcm7j"
                  opacity={0.7}
                >
                  <path
                    d="M343 350.47a4 4 0 003.43-.26l58.41-33.73a4 4 0 001.94-2.78l6.39-38.14a3.49 3.49 0 00.05-.65 4 4 0 00-1.17-2.82l-60.71 35.05a3 3 0 00-1.43 2.06z"
                    style={{
                      transformOrigin: "378.11px 311.414px",
                    }}
                    id="prefix__eluc2n1te7dd"
                    className="prefix__animable"
                    fill="#fff"
                  />
                </g>
              </g>
              <path
                d="M342.09 350l.4.23a3.36 3.36 0 00.54.26l6.91-41.27a3 3 0 011.43-2.06l60.71-35.05a3.86 3.86 0 00-.81-.62l-60.83 35.12a3 3 0 00-1.43 2.06z"
                style={{
                  transformOrigin: "377.085px 310.99px",
                }}
                id="prefix__el9grvpvt1eb4"
                className="prefix__animable"
                fill="#fafafa"
              />
              <path
                d="M375.93 315.27c.43-2.56 3.07-5.95 5.89-7.58s4.77-.88 4.34 1.67-3.07 5.95-5.89 7.58-4.76.88-4.34-1.67z"
                style={{
                  transformOrigin: "381.046px 312.315px",
                }}
                id="prefix__eljxkiwuk16z"
                className="prefix__animable"
                fill="#22c4d6"
              />
            </g>
            <g
              id="prefix__freepik--arm--inject-40"
              className="prefix__animable"
              style={{
                transformOrigin: "301.002px 281.841px",
              }}
            >
              <path
                d="M257.17 288.89c1.44-15.62 3-28.53 5.7-39.89 1.59-6.69 3.91-11.87 13.83-14.69 8.8 5.25 6.78 24.07 6 28.51l-4.42 26.88s7.58 5.16 15.61 10.11c6.79 4.18 11.34 6.66 19 6.94s10.68-.22 14.77 1.18c2.17.74 7.14 2.47 8.84 3.17s4.87 3.41 7.74 5.18c2.72 1.83-.37 3.21-2.4 2.79a25.06 25.06 0 01-6.18-2.4 34.38 34.38 0 00-5.27-1.53 30 30 0 011.51 5.86c.1 1.09.44 2.39-.44 3.27a8.61 8.61 0 01-2.2 1.12 1.67 1.67 0 01-.37 1.09 2.75 2.75 0 01-1.89.66 8.55 8.55 0 01-1.12-.08 2 2 0 01-1.1 1.67 8.8 8.8 0 01-4.63.54c-.23-.08-2-.87-2.56-1.09a4.64 4.64 0 01-1.8-.94c-.42-.53.53-1.93 1.41-2.14a9.06 9.06 0 013-.05 10.31 10.31 0 01-1.07-2.47c-.91-1.23-6.61.56-11.85.08-3.95-.36-7.07-3.83-8.88-4.48-11.63-4.14-20.48-7-32.36-12.89-10.89-5.4-9.62-8.29-8.87-16.4z"
                style={{
                  transformOrigin: "301.002px 281.841px",
                }}
                id="prefix__el3kdttxabe7h"
                className="prefix__animable"
                fill="#ffa8a7"
              />
              <path
                d="M331.37 315.4c-.72-1.42-1.78-3.1-2.94-3.41a12.85 12.85 0 011.9 3.15c.35.1.67.18 1.04.26z"
                style={{
                  transformOrigin: "329.9px 313.695px",
                }}
                id="prefix__el26vtttwdz5d"
                className="prefix__animable"
                fill="#f28f8f"
              />
              <path
                d="M329.26 325.39a12.42 12.42 0 00-.16-3.22 27.85 27.85 0 00-.68-3.14 13.65 13.65 0 00-1.12-3 5.92 5.92 0 00-2.13-2.41 4.66 4.66 0 011 1.23 9.15 9.15 0 01.72 1.39 21 21 0 011 3c.28 1 .54 2.05.8 3.08a27.35 27.35 0 01.57 3.07z"
                style={{
                  transformOrigin: "327.235px 319.505px",
                }}
                id="prefix__eltrf8308e5hf"
                className="prefix__animable"
                fill="#f28f8f"
              />
              <path
                d="M325.88 327.06a15.12 15.12 0 00-.26-3.15 26.5 26.5 0 00-.72-3.08 21.24 21.24 0 00-1.11-3 6 6 0 00-1.83-2.57 3.93 3.93 0 01.82 1.3c.21.48.4 1 .57 1.45.34 1 .67 2 1 3 .55 1.99 1.11 3.99 1.53 6.05z"
                style={{
                  transformOrigin: "323.922px 321.16px",
                }}
                id="prefix__el1qgknv52nhp"
                className="prefix__animable"
                fill="#f28f8f"
              />
              <path
                d="M317.2 325.1a5.13 5.13 0 011.32.08c.43.06.74.25 1.28.38l-.24-.33a1.32 1.32 0 00.14.62 1.54 1.54 0 00.33.46 1.82 1.82 0 00.94.51 4.48 4.48 0 01-.6-.77 2.28 2.28 0 01-.17-.4 1.27 1.27 0 010-.36v-.24l-.25-.08a3.84 3.84 0 00-1.25-.16 2.65 2.65 0 00-1.5.29z"
                style={{
                  transformOrigin: "319.085px 325.808px",
                }}
                id="prefix__el7qx637obdr"
                className="prefix__animable"
                fill="#f28f8f"
              />
            </g>
            <path
              d="M320 174.35c-4.92-6.57-22-8.69-32.34-.72-4.58 3.52-9.85 10.22-7.28 22.36-1.09 2-3.58 4.84-4.46 9.26-1 5-.36 10.25 2.83 14.14s11.75 6.89 22.2 7.59c19.42 1.3 24.78-2.51 28-12.73 2.27-7.22-1.87-15.58-1.87-15.58 2.23-12.62-2.81-21.35-7.08-24.32z"
              style={{
                transformOrigin: "302.558px 197.856px",
              }}
              id="prefix__elae056jou2gd"
              className="prefix__animable"
              fill="#455a64"
            />
            <path
              d="M324.11 183.85c2 1.5 5.4 4.3 3.22 16.08-.3 1.65.22 3 0 6.81-.59 11-5.46 15.49-8.9 16.65-2 .69-4.55.7-8.84.14l-.95 4.88s14.13 13.61 3.92 16.36c-13.21 3.56-24.56-13.54-24.56-13.54l2.63-21.11c-1.72 1.26-5.51 1.31-7.66-2.84s-1.6-9.65 1.85-11.06c3.77-1.54 5.81.41 7.28 3.5 1.19 2.8 4.48 2.23 4-4.05 3.83-1.34 5.38-5.31 4.94-11.29 2-1.44 5.14 1.77 14.91 2 3.85.02 5.27-1.11 8.16-2.53z"
              style={{
                transformOrigin: "304.866px 214.554px",
              }}
              id="prefix__el2gasr9zoqcu"
              className="prefix__animable"
              fill="#ffa8a7"
            />
            <path
              d="M286.38 206.74a1.79 1.79 0 102.06-1.47 1.79 1.79 0 00-2.06 1.47z"
              style={{
                transformOrigin: "288.145px 207.036px",
              }}
              id="prefix__el5qts7o6jvar"
              className="prefix__animable"
              fill="#22c4d6"
            />
            <path
              d="M309.61 223.53c-10.47-2.5-16.27-6.89-17.25-11.17 0 0 .54 5.58 3.44 8.1 4.06 3.53 13.23 6 13.23 6z"
              style={{
                transformOrigin: "300.985px 219.41px",
              }}
              id="prefix__elefv5djfz9z"
              className="prefix__animable"
              fill="#f28f8f"
            />
            <path
              d="M314.6 213.72l-5.41-1.72a2.71 2.71 0 001.72 3.54 3 3 0 003.69-1.82z"
              style={{
                transformOrigin: "311.808px 213.836px",
              }}
              id="prefix__el6zl6uqxhr7"
              className="prefix__animable"
              fill="#b16668"
            />
            <path
              d="M312.13 215.64a2.84 2.84 0 01-1.22-.11 2.69 2.69 0 01-1.86-2.2 3.26 3.26 0 013.08 2.31z"
              style={{
                transformOrigin: "310.59px 214.497px",
              }}
              id="prefix__el65913thjixo"
              className="prefix__animable"
              fill="#f28f8f"
            />
            <path
              d="M327.2 195.09l-4.64-1.57a2.34 2.34 0 013-1.56 2.55 2.55 0 011.64 3.13z"
              style={{
                transformOrigin: "324.931px 193.463px",
              }}
              id="prefix__el6m3c2gdjjeq"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M308.47 198.66c-1.55 0-2.34 1.13-3 .9a1.24 1.24 0 001 .75 2.48 2.48 0 000 .27 2 2 0 102-1.92z"
              style={{
                transformOrigin: "307.969px 200.66px",
              }}
              id="prefix__elvpu0fh0cl4"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M323.79 199.41a1.61 1.61 0 00-.44-.06 2 2 0 10-.09 3.92 2 2 0 002-1.76 1.27 1.27 0 001.16-.48c-.65.07-1.12-1.27-2.63-1.62z"
              style={{
                transformOrigin: "323.665px 201.301px",
              }}
              id="prefix__el700hrwgzadx"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M304 194.68l4.67-1.69a2.39 2.39 0 00-3.11-1.52 2.59 2.59 0 00-1.56 3.21z"
              style={{
                transformOrigin: "306.274px 193px",
              }}
              id="prefix__elqy99qnk65p"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M323 207.9a5.48 5.48 0 01-4.14-1.81 5.62 5.62 0 01-1.34-4.43 7 7 0 016.72-6.06 5.47 5.47 0 014.11 1.77 5.6 5.6 0 011.38 4.37 7 7 0 01-6.73 6.16zm1.24-11.51a6.15 6.15 0 00-5.93 5.36 4.81 4.81 0 001.15 3.81 4.66 4.66 0 003.54 1.54 6.13 6.13 0 005.94-5.44 4.79 4.79 0 00-1.18-3.75 4.65 4.65 0 00-3.51-1.52z"
              style={{
                transformOrigin: "323.62px 201.75px",
              }}
              id="prefix__elmfhcxlzg7kr"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M314.34 199.35l.55 10.65 6.48-1.42s-3.03-8.09-7.03-9.23z"
              style={{
                transformOrigin: "317.855px 204.675px",
              }}
              id="prefix__elrgbemm6mpmf"
              className="prefix__animable"
              fill="#f28f8f"
            />
            <path
              d="M307.53 207.43a5.42 5.42 0 01-4.14-1.81 5.55 5.55 0 01-1.34-4.43 7 7 0 016.71-6.06 5.49 5.49 0 014.12 1.77 5.59 5.59 0 011.37 4.37 6.93 6.93 0 01-6.72 6.16zm1.23-11.51a6.15 6.15 0 00-5.92 5.36 4.79 4.79 0 001.14 3.81 4.63 4.63 0 003.55 1.54 6.13 6.13 0 005.93-5.44 4.76 4.76 0 00-1.17-3.75 4.69 4.69 0 00-3.53-1.52z"
              style={{
                transformOrigin: "308.144px 201.28px",
              }}
              id="prefix__elklbf5z8mci"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M314.12 202.06l-.75-.25c.52-1.58 2.73-2.09 4-1.73a1.23 1.23 0 011 1.51l-.77-.2c0-.1.1-.38-.46-.55-.96-.27-2.66.16-3.02 1.22z"
              style={{
                transformOrigin: "315.888px 201.015px",
              }}
              id="prefix__elkanzdwnvln"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M302.5 200.36l-.07.8-10.83-2.33c-.17-.29-.36-.6-.54-.87z"
              style={{
                transformOrigin: "296.78px 199.56px",
              }}
              id="prefix__elylyafnm5jcj"
              className="prefix__animable"
              fill="#263238"
            />
            <path
              d="M299.5 182.69c-.68 4.29-1.16 10-1.16 10s5.81 2.6 8.2 2.25a41.48 41.48 0 001.81-9.84 29.26 29.26 0 011 10c2.15 1 8.58 2.15 11.93 1.25a79.61 79.61 0 00.73-10.86s2.53 5.4 2.33 10.22a13.17 13.17 0 006.36-1.18s1.93-11.08-6.76-18c-6.53-5.18-16.74-3.63-19.89-1.24a10.45 10.45 0 00-4.55 7.4z"
              style={{
                transformOrigin: "314.611px 184.873px",
              }}
              id="prefix__el93avggfdkt"
              className="prefix__animable"
              fill="#455a64"
            />
          </g>
        </g>
        <path
          d="M273.47 386.56a2.07 2.07 0 00.49-.07 1.73 1.73 0 001.17-2.15l-7-24a1.73 1.73 0 10-3.32 1l7 24.05a1.73 1.73 0 001.66 1.17z"
          style={{
            transformOrigin: "269.968px 372.831px",
          }}
          id="prefix__elkad1mdy0q"
          className="prefix__animable"
          fill="#37474f"
        />
        <path
          d="M255.39 376.12a2.07 2.07 0 00.49-.07 1.73 1.73 0 001.17-2.15l-7-24a1.73 1.73 0 10-3.32 1l7 24.05a1.73 1.73 0 001.66 1.17z"
          style={{
            transformOrigin: "251.888px 362.391px",
          }}
          id="prefix__eltktv3dfl3z"
          className="prefix__animable"
          fill="#37474f"
        />
        <path
          d="M227.22 337.4a1.76 1.76 0 011-1.44l9.06-5.23a5.49 5.49 0 015 0l50.56 29.19a1.76 1.76 0 011 1.44v2.71a1.76 1.76 0 01-1 1.44l-9.06 5.23a5.49 5.49 0 01-5 0l-50.56-29.19a1.76 1.76 0 01-1-1.44z"
          style={{
            transformOrigin: "260.53px 350.735px",
          }}
          id="prefix__el1twje8c5zip"
          className="prefix__animable"
          fill="#37474f"
        />
        <path
          d="M228.26 336l9.06-5.23a5.49 5.49 0 015 0l39 22.52v18.09a5.08 5.08 0 01-2.5-.6l-50.56-29.19a1.76 1.76 0 01-1-1.44v-2.75a1.76 1.76 0 011-1.4z"
          style={{
            transformOrigin: "254.29px 350.774px",
          }}
          id="prefix__eldd1g1t8bqqf"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M242.31 330.73l50.56 29.19a1.52 1.52 0 010 2.89l-9.06 5.19a5.55 5.55 0 01-5 0l-50.56-29.19a1.52 1.52 0 010-2.89l9.06-5.23a5.49 5.49 0 015 .04z"
          style={{
            transformOrigin: "260.56px 349.351px",
          }}
          id="prefix__eluvxe8rwpgo8"
          className="prefix__animable"
          fill="#455a64"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Table--inject-40"
      className="prefix__animable"
      style={{
        transformOrigin: "204.69px 390.778px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--table--inject-40"
        className="prefix__animable"
        style={{
          transformOrigin: "204.69px 390.778px",
        }}
      >
        <g
          id="prefix__freepik--table--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "204.69px 396.88px",
          }}
        >
          <path
            d="M206.21 392.63a3.47 3.47 0 00-3.11 0 1.11 1.11 0 00-.65.9l.65 55.65a.8.8 0 00.45.62 2.46 2.46 0 002.21 0 .78.78 0 00.45-.62l.65-55.65a1.09 1.09 0 00-.65-.9zm-32-3.93a3.43 3.43 0 00-3.12 0 .91.91 0 00-.52.9l-4.31 46.86a.93.93 0 00.54.62 2.45 2.45 0 002.21 0 .64.64 0 00.36-.62L175 389.6a1.33 1.33 0 00-.8-.9zm63.88.9a.91.91 0 00-.52-.9 3.43 3.43 0 00-3.12 0 1.33 1.33 0 00-.77.9l5.6 46.86a.64.64 0 00.36.62 2.45 2.45 0 002.21 0 .93.93 0 00.54-.62z"
            style={{
              transformOrigin: "204.325px 419.193px",
            }}
            id="prefix__el70qcrmeb155"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M254 372.21c0-7.3-4.77-14.59-14.42-20.16-19.27-11.13-50.53-11.13-69.81 0-9.64 5.57-14.43 12.86-14.42 20.16v3.92c.11 7.19 4.94 14.37 14.46 19.87 19.28 11.13 50.54 11.13 69.81 0 9.52-5.5 14.35-12.67 14.47-19.87z"
            style={{
              transformOrigin: "204.72px 374.025px",
            }}
            id="prefix__elcuboqbx8maq"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__elwr6fxvs9wyo">
            <path
              d="M254 372.21c0-7.3-4.77-14.59-14.42-20.16-19.27-11.13-50.53-11.13-69.81 0-9.64 5.57-14.43 12.86-14.42 20.16v3.92c.11 7.19 4.94 14.37 14.46 19.87 19.28 11.13 50.54 11.13 69.81 0 9.52-5.5 14.35-12.67 14.47-19.87z"
              style={{
                transformOrigin: "204.72px 374.025px",
              }}
              className="prefix__animable"
              id="prefix__elth0xa2rtj99"
              fill="#fff"
              opacity={0.6}
            />
          </g>
          <path
            d="M169.75 352.05c-19.28 11.13-19.28 29.18 0 40.31s50.54 11.13 69.82 0 19.28-29.17 0-40.31-50.57-11.13-69.82 0z"
            style={{
              transformOrigin: "204.66px 372.203px",
            }}
            id="prefix__eljss1c6ty4s9"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__elw412p9v72e">
            <path
              d="M169.75 352.05c-19.28 11.13-19.28 29.18 0 40.31s50.54 11.13 69.82 0 19.28-29.17 0-40.31-50.57-11.13-69.82 0z"
              style={{
                transformOrigin: "204.66px 372.203px",
              }}
              className="prefix__animable"
              id="prefix__elh43eyz7ttn"
              fill="#fff"
              opacity={0.8}
            />
          </g>
        </g>
        <g
          id="prefix__freepik--pot--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "181.869px 353.982px",
          }}
        >
          <g id="prefix__elv1yevzublvm">
            <g
              style={{
                transformOrigin: "181.678px 368.48px",
              }}
              className="prefix__animable"
              id="prefix__eljp8w5koacq"
              opacity={0.2}
            >
              <path
                d="M191.47 362.83c5.4 3.12 5.4 8.18 0 11.3s-14.17 3.12-19.58 0-5.4-8.18 0-11.3 14.17-3.12 19.58 0z"
                style={{
                  transformOrigin: "181.678px 368.48px",
                }}
                id="prefix__elu940dei4d1"
                className="prefix__animable"
                fill="#22c4d6"
              />
            </g>
          </g>
          <path
            d="M173.07 369.18c-4.71-4.81-7.47-16.8-2.88-20.61h23.36c4.59 3.81 1.83 15.79-2.87 20.6l-.13.13-.17.16a5.14 5.14 0 01-.42.38l-.11.09-.36.27c-.2.14-.4.27-.61.39a15.53 15.53 0 01-14 0 7.2 7.2 0 01-.62-.4l-.33-.25-.13-.11a5 5 0 01-.42-.36l-.18-.18z"
            style={{
              transformOrigin: "181.87px 360.414px",
            }}
            id="prefix__elg2eccu0b9bm"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M191.52 347c5.33 3.08 5.33 8.07 0 11.15s-14 3.08-19.3 0-5.33-8.07 0-11.15 13.97-3 19.3 0z"
            style={{
              transformOrigin: "181.876px 352.59px",
            }}
            id="prefix__el8am1tccrpmo"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M187.74 349.21c3.25 1.88 3.25 4.91 0 6.79a13 13 0 01-11.74 0c-3.25-1.88-3.25-4.91 0-6.79a13 13 0 0111.74 0z"
            style={{
              transformOrigin: "181.87px 352.605px",
            }}
            id="prefix__elu3cohmhn0d"
            className="prefix__animable"
            fill="#e0e0e0"
          />
          <path
            d="M176 352.43a13 13 0 0111.74 0 5.41 5.41 0 011.95 1.78 5.43 5.43 0 01-1.95 1.79 13 13 0 01-11.74 0 5.39 5.39 0 01-1.94-1.79 5.37 5.37 0 011.94-1.78z"
            style={{
              transformOrigin: "181.875px 354.215px",
            }}
            id="prefix__ellkgn2hxw6q"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M187 354.21a26.72 26.72 0 004.25-5.64c2-3.47 3.63-7.88 2.62-8.46s-6.46 3.83-6.46 3.83a25.14 25.14 0 00.44-5.92c-.18-3.09-.93-5.9-1.81-6.47s-2.87 3.34-3.72 6.16-1.19 4.58-1.19 4.58-.74-3.25-1.69-5.93c-1-2.94-2-3.6-2.68-3.31s-1.21 1.66-1.42 5.56a38 38 0 00.18 5.59s-1.46-1.6-3.07-3.15c-1.78-1.7-3-1.7-3.54-1.38s-.15 2.74 2.6 7.72a27.69 27.69 0 005.18 6.82s3.84 2.46 10.31 0z"
            style={{
              transformOrigin: "181.44px 343.399px",
            }}
            id="prefix__eljwtqr7sjih"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__elc4gaml4o4b">
            <g
              style={{
                transformOrigin: "181.44px 343.399px",
              }}
              className="prefix__animable"
              id="prefix__ella8nb8txppf"
              opacity={0.2}
            >
              <path
                d="M187 354.21a26.72 26.72 0 004.25-5.64c2-3.47 3.63-7.88 2.62-8.46s-6.46 3.83-6.46 3.83a25.14 25.14 0 00.44-5.92c-.18-3.09-.93-5.9-1.81-6.47s-2.87 3.34-3.72 6.16-1.19 4.58-1.19 4.58-.74-3.25-1.69-5.93c-1-2.94-2-3.6-2.68-3.31s-1.21 1.66-1.42 5.56a38 38 0 00.18 5.59s-1.46-1.6-3.07-3.15c-1.78-1.7-3-1.7-3.54-1.38s-.15 2.74 2.6 7.72a27.69 27.69 0 005.18 6.82s3.84 2.46 10.31 0z"
                id="prefix__el6wzd4llo9sj"
                className="prefix__animable"
                style={{
                  transformOrigin: "181.44px 343.399px",
                }}
              />
            </g>
          </g>
          <g id="prefix__elgm1fl2fxtsj">
            <path
              d="M182.35 337.71c-.85 2.82-1.19 4.58-1.19 4.58l.52 2.43s.53-5.32 1.28-8.74c-.23.59-.44 1.18-.61 1.73z"
              style={{
                transformOrigin: "182.06px 340.35px",
              }}
              className="prefix__animable"
              id="prefix__ellxga2ckqjj"
              opacity={0.2}
            />
          </g>
          <g id="prefix__elt1067xswkrs">
            <path
              d="M176.48 342a35.33 35.33 0 01-.75-6.77 26.23 26.23 0 00-.36 3.41 38 38 0 00.18 5.59l3.75 3.94a33.64 33.64 0 01-2.82-6.17z"
              style={{
                transformOrigin: "177.319px 341.7px",
              }}
              className="prefix__animable"
              id="prefix__el0xtr940z8a2d"
              opacity={0.2}
            />
          </g>
          <g id="prefix__el4hhd6a0mfti">
            <path
              d="M185.08 346.25l2.36-2.31a25.14 25.14 0 00.44-5.92 20.83 20.83 0 00-.48-3.5 16.52 16.52 0 01-.28 5.68 52.08 52.08 0 01-2.04 6.05z"
              style={{
                transformOrigin: "186.492px 340.385px",
              }}
              className="prefix__animable"
              id="prefix__elb8nnnvto3bo"
              opacity={0.2}
            />
          </g>
        </g>
        <g id="prefix__freepik--shadow--inject-40">
          <ellipse
            cx={225.51}
            cy={378.08}
            rx={20.56}
            ry={11.87}
            style={{
              transformOrigin: "225.51px 378.08px",
            }}
            className="prefix__animable"
            id="prefix__elvbjtahbagh"
            fill="#22c4d6"
            opacity={0.2}
          />
        </g>
        <g
          id="prefix__freepik--Mug--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "225.184px 371.362px",
          }}
        >
          <g
            id="prefix__freepik--Plate--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "225.488px 376.586px",
            }}
          >
            <path
              d="M239.49 368.11c-7.72-4.46-20.23-4.46-28 0-3.86 2.22-5.79 5.14-5.79 8.06v.83c0 2.92 1.93 5.84 5.79 8.07 7.72 4.45 20.23 4.45 28 0 3.85-2.23 5.78-5.15 5.78-8.07v-.82c.01-2.92-1.92-5.84-5.78-8.07z"
              style={{
                transformOrigin: "225.485px 376.586px",
              }}
              id="prefix__eljy2h3dc05ki"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <g id="prefix__elr028jzdc4zm">
              <path
                d="M219 386.94v-21.53a24.65 24.65 0 00-7.41 2.7c-3.86 2.22-5.79 5.14-5.79 8.06v.83c0 2.92 1.93 5.84 5.79 8.07a25.8 25.8 0 009.06 3c-1.65-.29-1.65-1.13-1.65-1.13z"
                style={{
                  transformOrigin: "213.225px 376.74px",
                }}
                className="prefix__animable"
                id="prefix__elw849vavdnr"
                opacity={0.1}
              />
            </g>
            <path
              d="M239.49 368.11c-7.72-4.46-20.23-4.46-28 0s-7.72 11.68 0 16.13 20.23 4.46 28 0 7.71-11.68 0-16.13z"
              style={{
                transformOrigin: "225.488px 376.173px",
              }}
              id="prefix__ellv0ard1hwk"
              className="prefix__animable"
              fill="#fff"
            />
            <path
              d="M235.75 370.68c-5.66-3.26-14.82-3.26-20.47 0s-5.66 8.55 0 11.82 14.81 3.26 20.47 0 5.65-8.56 0-11.82z"
              style={{
                transformOrigin: "225.515px 376.592px",
              }}
              id="prefix__eloswv6h45zm"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <path
              d="M234.48 372c-4.95-2.86-13-2.86-17.94 0s-4.95 7.5 0 10.36 13 2.86 17.94 0 4.95-7.53 0-10.36z"
              style={{
                transformOrigin: "225.51px 377.18px",
              }}
              id="prefix__elv6b63sp3m2f"
              className="prefix__animable"
              fill="#fff"
            />
            <path
              d="M211.42 383.58a23.31 23.31 0 005.19 2 31.5 31.5 0 005.47.88 36.46 36.46 0 005.53 0 32.43 32.43 0 005.45-.89 24.2 24.2 0 005.16-1.9 13.93 13.93 0 004.33-3.3 8 8 0 001.39-2.33 6.21 6.21 0 00.41-2.67 6.73 6.73 0 00-.74-2.62 8 8 0 00-.73-1.18 10 10 0 00-.88-1.07 11.47 11.47 0 01.95 1 9 9 0 01.78 1.16 7 7 0 01.88 2.67 6.72 6.72 0 01-.34 2.81 8.39 8.39 0 01-1.4 2.47 11.47 11.47 0 01-2 2 16.54 16.54 0 01-2.38 1.52 23.82 23.82 0 01-5.26 2 33.23 33.23 0 01-11.15.81 30.32 30.32 0 01-5.5-1 27.43 27.43 0 01-2.63-.94 19.44 19.44 0 01-2.53-1.42z"
              style={{
                transformOrigin: "228.029px 378.797px",
              }}
              id="prefix__eluzdipqdfeqp"
              className="prefix__animable"
              fill="#fff"
            />
            <path
              d="M232.63 372.2a15.72 15.72 0 00-14.23 0c-3.93 2.27-3.93 5.95 0 8.22a15.72 15.72 0 0014.23 0c3.93-2.27 3.93-5.95 0-8.22z"
              style={{
                transformOrigin: "225.515px 376.31px",
              }}
              id="prefix__elsxd6jy52u0k"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <g id="prefix__el49yag5r8d0s">
              <path
                d="M232.6 379l-12.95-7.18-13.9 4.38c0 2.91 1.94 5.82 5.79 8a24.65 24.65 0 007.41 2.7z"
                style={{
                  transformOrigin: "219.175px 379.36px",
                }}
                className="prefix__animable"
                id="prefix__elvd8xms0mlld"
                opacity={0.1}
              />
            </g>
          </g>
          <g
            id="prefix__freepik--mug--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "222.743px 367.498px",
            }}
          >
            <path
              d="M205.09 367.78c0 3 2.91 4.6 5.16 5.54 1.68.71 3 .95 3.84 1.67l-2-10.7a4.76 4.76 0 00-2.7-.71 3.53 3.53 0 00-1.65.46l-1 .6a3.35 3.35 0 00-1.65 3.14zm3-.6a1.84 1.84 0 01.44-1.18 2 2 0 01.35 0 3.06 3.06 0 012.2.86 29.26 29.26 0 011.21 4.36l-.29-.12c-2.83-1.21-3.93-2.41-3.93-3.92z"
              style={{
                transformOrigin: "209.585px 369.283px",
              }}
              id="prefix__el589qqmmparo"
              className="prefix__animable"
              fill="#fafafa"
            />
            <path
              d="M205.09 367.78c0 3 2.91 4.6 5.16 5.54 1.68.71 3 .95 3.84 1.67a61.65 61.65 0 00-3.05-10.1 4.82 4.82 0 00-2.71-.71 3.27 3.27 0 00-3.24 3.6zm1.94 0a1.82 1.82 0 011.83-1.81 3.06 3.06 0 012.2.86 25.8 25.8 0 011.35 5.4c-.48-.17-.94-.33-1.47-.56-2.81-1.18-3.94-2.38-3.94-3.89z"
              style={{
                transformOrigin: "209.582px 369.583px",
              }}
              id="prefix__elntrqfzl1g6i"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <g id="prefix__elzveoksk6hf">
              <path
                d="M210.77 371.6a15.09 15.09 0 001.3 2.41 6.67 6.67 0 012 1 61.65 61.65 0 00-3.05-10.1 4.76 4.76 0 00-1.44-.59V366a3.11 3.11 0 011.46.79 25.8 25.8 0 011.35 5.4c-.48-.17-.94-.33-1.47-.56z"
                style={{
                  transformOrigin: "211.825px 369.665px",
                }}
                className="prefix__animable"
                id="prefix__elbkra9nz5gr8"
                opacity={0.1}
              />
            </g>
            <path
              d="M240.4 362.84c0-2.17-1.43-4.34-4.3-6-5.73-3.32-15-3.32-20.76 0-2.87 1.65-4.3 3.82-4.3 6V366a14.68 14.68 0 0014.68 14.68A14.68 14.68 0 00240.4 366v-3.19z"
              style={{
                transformOrigin: "225.72px 367.515px",
              }}
              id="prefix__elf263codj34k"
              className="prefix__animable"
              fill="#fafafa"
            />
            <path
              d="M225.72 354.49A21 21 0 01236 357c2.73 1.57 4.24 3.66 4.24 5.88V366a14.56 14.56 0 01-29.12 0v-3.19c0-2.22 1.51-4.31 4.24-5.88a21 21 0 0110.32-2.47m0-.13a21.14 21.14 0 00-10.38 2.49c-2.87 1.65-4.3 3.82-4.3 6V366a14.68 14.68 0 0014.68 14.68A14.68 14.68 0 00240.4 366v-3.19c0-2.17-1.43-4.34-4.3-6a21.14 21.14 0 00-10.38-2.49z"
              style={{
                transformOrigin: "225.7px 367.498px",
              }}
              id="prefix__el6sxqrdc2kce"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <path
              d="M221.14 378.46c-6.14-2.62-5.89-7.5-3.85-7.27a31.82 31.82 0 0010.78 0l.05-13.54-14.69.53a6.25 6.25 0 00-2.39 4.64V366a14.68 14.68 0 0014.68 14.68 14.67 14.67 0 009.43-3.42 14.68 14.68 0 01-14.01 1.2z"
              style={{
                transformOrigin: "223.095px 369.165px",
              }}
              id="prefix__el14k8yfnq9yo"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <path
              d="M236.1 356.85c-5.73-3.32-15-3.32-20.76 0s-5.74 8.67 0 12 15 3.32 20.76 0 5.74-8.69 0-12zm-.44 11.21a22.11 22.11 0 01-19.88 0c-2.48-1.43-3.85-3.29-3.85-5.22s1.37-3.79 3.85-5.22a22.11 22.11 0 0119.88 0c2.48 1.43 3.85 3.29 3.85 5.22s-1.37 3.79-3.85 5.22z"
              style={{
                transformOrigin: "225.72px 362.852px",
              }}
              id="prefix__el0h850xonqtq8"
              className="prefix__animable"
              fill="#fff"
            />
            <path
              d="M235.66 357.62a22.11 22.11 0 00-19.88 0c-2.48 1.43-3.85 3.29-3.85 5.22a4.28 4.28 0 00.32 1.61 7.87 7.87 0 013.53-3.6 22.11 22.11 0 0119.88 0 7.87 7.87 0 013.53 3.6 4.28 4.28 0 00.32-1.61c0-1.93-1.37-3.79-3.85-5.22z"
              style={{
                transformOrigin: "225.72px 359.855px",
              }}
              id="prefix__eld7l5uivoita"
              className="prefix__animable"
              fill="#ebebeb"
            />
            <path
              d="M225.72 355.26a20.26 20.26 0 00-9.94 2.36c-2.48 1.43-3.85 3.29-3.85 5.22a4.28 4.28 0 00.32 1.61 7.87 7.87 0 013.53-3.6 20.26 20.26 0 019.94-2.36h.7c-.9 0-2.81-.47-2.17-1.71s2.37-1.52 3.62-1.44c-.7-.05-1.42-.08-2.15-.08z"
              style={{
                transformOrigin: "219.9px 359.853px",
              }}
              id="prefix__elwy085rtcesm"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <g id="prefix__el6qe5mr6khyf">
              <path
                d="M225.72 355.26a20.26 20.26 0 00-9.94 2.36c-2.48 1.43-3.85 3.29-3.85 5.22a4.28 4.28 0 00.32 1.61 7.87 7.87 0 013.53-3.6 20.26 20.26 0 019.94-2.36h.7c-.9 0-2.81-.47-2.17-1.71s2.37-1.52 3.62-1.44c-.7-.05-1.42-.08-2.15-.08z"
                style={{
                  transformOrigin: "219.9px 359.853px",
                }}
                className="prefix__animable"
                id="prefix__ellqw0l91l6z"
                opacity={0.1}
              />
            </g>
            <path
              d="M239.51 362.84c0-1.71-1.07-3.35-3-4.7.92 1.07.4 3-1.59 2.3.26.14.52.27.78.42a7.87 7.87 0 013.53 3.6 4.28 4.28 0 00.28-1.62z"
              style={{
                transformOrigin: "237.216px 361.3px",
              }}
              id="prefix__elhenjjohj8q"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <g id="prefix__elz6brd0nmunc">
              <path
                d="M239.51 362.84c0-1.71-1.07-3.35-3-4.7.92 1.07.4 3-1.59 2.3.26.14.52.27.78.42a7.87 7.87 0 013.53 3.6 4.28 4.28 0 00.28-1.62z"
                style={{
                  transformOrigin: "237.216px 361.3px",
                }}
                className="prefix__animable"
                id="prefix__eldflf7b0xeda"
                opacity={0.1}
              />
            </g>
            <path
              d="M235.66 360.85a22.11 22.11 0 00-19.88 0 7.87 7.87 0 00-3.53 3.6 7.89 7.89 0 003.53 3.61 22.11 22.11 0 0019.88 0 7.84 7.84 0 003.53-3.61 7.87 7.87 0 00-3.53-3.6z"
              style={{
                transformOrigin: "225.72px 364.455px",
              }}
              id="prefix__el944usmcim6k"
              className="prefix__animable"
              fill="#22c4d6"
            />
            <g id="prefix__elsaduhpysjsa">
              <path
                d="M235.66 360.85a22.11 22.11 0 00-19.88 0 7.87 7.87 0 00-3.53 3.6 7.89 7.89 0 003.53 3.61 22.11 22.11 0 0019.88 0 7.84 7.84 0 003.53-3.61 7.87 7.87 0 00-3.53-3.6z"
                style={{
                  transformOrigin: "225.72px 364.455px",
                }}
                className="prefix__animable"
                id="prefix__eluue03zplwcb"
                opacity={0.4}
              />
            </g>
            <g id="prefix__el2ssn20pw64v">
              <path
                d="M215.78 360.85a7.87 7.87 0 00-3.53 3.6 7.89 7.89 0 003.53 3.61 18.69 18.69 0 007 2.19 12.67 12.67 0 00-2.71-1.45c-.31-.07-.6-.16-.89-.24a2.28 2.28 0 01-1.28-.72 1.27 1.27 0 01-.25-1.23 1.55 1.55 0 01.55-.64c.81-.6 1.84-.82 2.69-1.37a1.13 1.13 0 00.51-.57 1 1 0 00-.2-.79c-.17-.23-.39-.42-.56-.65a1 1 0 01-.24-.79.86.86 0 01.28-.45 4 4 0 011.82-.69 1.31 1.31 0 00.87-.63c.19-.32 0-.72.17-1a1.24 1.24 0 01.44-.44 19.25 19.25 0 00-8.2 2.26zm-.15 4.32a.28.28 0 01-.22 0c-.06 0-.06-.1 0-.13a.22.22 0 01.22 0c.06.03.06.09 0 .13zm1.38 2a.74.74 0 01-.68 0c-.19-.11-.19-.29 0-.39a.74.74 0 01.68 0c.19.09.19.27-.01.38zm.3-.89a.22.22 0 01-.22 0c-.06 0-.06-.09 0-.13a.28.28 0 01.22 0c.06.03.06.09 0 .12zm.14-1.45a1.21 1.21 0 01-1.08 0 .33.33 0 010-.62 1.21 1.21 0 011.08 0 .33.33 0 010 .61zm2.28-3.53a.43.43 0 01.35 0c.09.06.09.15 0 .2a.36.36 0 01-.35 0c-.1-.06-.1-.15 0-.21zm-1.58 1.25a.33.33 0 010-.62 1.15 1.15 0 011.08 0 .33.33 0 010 .62 1.21 1.21 0 01-1.08-.01zm.71 2.35a.36.36 0 01-.35 0c-.09-.05-.09-.14 0-.2a.36.36 0 01.35 0c.14.05.14.14 0 .19zm1.56-1.54c.34.2.34.52 0 .71a1.34 1.34 0 01-1.23 0c-.34-.19-.34-.51 0-.71a1.34 1.34 0 011.23-.01zm1.13-2.92a.22.22 0 01-.22 0c-.06 0-.06-.09 0-.13a.28.28 0 01.22 0c.06.03.06.09 0 .12z"
                style={{
                  transformOrigin: "218.115px 364.42px",
                }}
                className="prefix__animable"
                id="prefix__el0izq2f16k2n"
                fill="#22c4d6"
                opacity={0.3}
              />
            </g>
            <g id="prefix__elud27da52x9">
              <path
                d="M235.66 360.85a15.08 15.08 0 00-1.94-.93 3.08 3.08 0 00-.54.16 1.05 1.05 0 00-.49.36c-.26.41.06.95.41 1.29a9.1 9.1 0 001.76 1.32 3.38 3.38 0 01.93.71 1.07 1.07 0 01.2 1.09 2.1 2.1 0 01-.58.61.85.85 0 00-.36.74 1.23 1.23 0 00.36.54.64.64 0 01.18.6.68.68 0 01-.56.3 17.61 17.61 0 00-2.41.28 1.47 1.47 0 00-.78.46c-.17.22-.24.5-.42.7-.4.47-1.12.37-1.73.4a5.8 5.8 0 00-2.24.73l-.34.17a19.44 19.44 0 008.55-2.32 7.84 7.84 0 003.53-3.61 7.87 7.87 0 00-3.53-3.6zm-1.12.46a1.21 1.21 0 01-1.08 0c-.3-.18-.3-.45 0-.63a1.21 1.21 0 011.08 0c.3.18.3.45 0 .63zm.9.88a.68.68 0 01-.59 0c-.16-.1-.16-.25 0-.34a.68.68 0 01.59 0c.16.09.16.24 0 .34zm-2.21 6.58a.72.72 0 01-.67 0 .2.2 0 010-.38.72.72 0 01.67 0 .2.2 0 010 .38zm.8-.35a.42.42 0 01-.38 0c-.11-.06-.11-.16 0-.22a.42.42 0 01.38 0c.11.06.11.16-.03.22zm2.78-3.67a.36.36 0 01.32 0c.09.05.09.13 0 .18a.36.36 0 01-.32 0 .1.1 0 010-.18zm.46 1.77a1.51 1.51 0 01-1.4 0c-.39-.22-.39-.58 0-.81a1.57 1.57 0 011.4 0c.39.23.39.59 0 .81zm.5-2.6a.81.81 0 01-.77 0 .23.23 0 010-.44.81.81 0 01.77 0c.23.12.23.32 0 .44zm.81.23a.34.34 0 01-.31 0c-.09 0-.09-.13 0-.18a.34.34 0 01.31 0c.09.03.09.13 0 .18z"
                style={{
                  transformOrigin: "233.15px 365.15px",
                }}
                className="prefix__animable"
                id="prefix__elt4cjf2uu1u"
                fill="#22c4d6"
                opacity={0.3}
              />
            </g>
            <g id="prefix__el61xkqtp142y">
              <path
                d="M223.78 358.56a19.19 19.19 0 00-8 2.29 7.87 7.87 0 00-3.53 3.6 7.89 7.89 0 003.53 3.61 14.94 14.94 0 002.13 1c-1.46-.84-2.93-2.1-2.93-3.78.02-3.28 4.02-6.19 8.8-6.72z"
                style={{
                  transformOrigin: "218.015px 363.81px",
                }}
                className="prefix__animable"
                id="prefix__elj6z0o1vj98"
                opacity={0.4}
              />
            </g>
          </g>
        </g>
        <g
          id="prefix__freepik--tea-spoon--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "213.219px 381.345px",
          }}
        >
          <g id="prefix__freepik--shadow--inject-40">
            <path
              d="M227.49 388.76h-.06l-18.19-10.06a2.49 2.49 0 00.47-1.31.49.49 0 000-.12c0-.59-.45-1.23-1.41-1.88-2-1.38-6.58-2.58-8.54-1.45a1.37 1.37 0 00-.72 1.61 5.42 5.42 0 001.51 2.55l.19.19.23.22a7 7 0 001.75 1.23 5.89 5.89 0 00.58.24 5.5 5.5 0 00.95.25 7.58 7.58 0 001.49.13 4.5 4.5 0 002.37-.66L225.4 390c.54.32 2.09-.48 2.09-.94v-.28z"
              style={{
                transformOrigin: "213.239px 381.783px",
              }}
              className="prefix__animable"
              id="prefix__el78zidrsuon"
              opacity={0.1}
            />
          </g>
          <g
            id="prefix__freepik--tea-spoon--inject-40"
            className="prefix__animable"
            style={{
              transformOrigin: "213.219px 380.998px",
            }}
          >
            <path
              d="M205.71 379.53c2.16 0 3.94-1.5 3.94-3.13L199 374.68a5.86 5.86 0 002 3 6.44 6.44 0 004.71 1.85z"
              style={{
                transformOrigin: "204.325px 377.106px",
              }}
              id="prefix__elryhmgjy1z7l"
              className="prefix__animable"
              fill="#ebebeb"
            />
            <g id="prefix__elfizwszw5fq5">
              <path
                d="M205.71 379.53c2.16 0 3.94-1.5 3.94-3.13L199 374.68a5.86 5.86 0 002 3 6.44 6.44 0 004.71 1.85z"
                style={{
                  transformOrigin: "204.325px 377.106px",
                }}
                className="prefix__animable"
                id="prefix__elevkv1ao84tc"
                opacity={0.15}
              />
            </g>
            <g id="prefix__el47s3sxp5dm7">
              <path
                d="M209.11 376.65c0 1.16-1.37 2.61-3.53 2.6a7.62 7.62 0 01-5.46-2.43 8 8 0 00.82.85 6.44 6.44 0 004.77 1.86c2.16 0 3.94-1.5 3.94-3.13l-.55-.08c0 .11.01.23.01.33z"
                style={{
                  transformOrigin: "204.885px 377.927px",
                }}
                className="prefix__animable"
                id="prefix__el4dzkznkvj6t"
                opacity={0.15}
              />
            </g>
            <path
              d="M208.24 374.52c-2-1.37-6.58-2.58-8.54-1.45s.14 3.78 2.52 4.93a6.49 6.49 0 006.15.08c1.63-.93 1.84-2.2-.13-3.56z"
              style={{
                transformOrigin: "204.29px 375.719px",
              }}
              id="prefix__elc0yxbbm588u"
              className="prefix__animable"
              fill="#e6e6e6"
            />
            <path
              d="M201.83 372.74a12.91 12.91 0 016.35 1.87c.92.64 1.38 1.27 1.36 1.87s-.45 1-1.22 1.5a5.6 5.6 0 01-2.79.72 7.45 7.45 0 01-3.26-.8c-1.77-.86-3.18-2.42-3.22-3.55a1.25 1.25 0 01.71-1.18 4.14 4.14 0 012.07-.43m0-.12a4.39 4.39 0 00-2.13.45c-1.95 1.13.14 3.78 2.52 4.93a7.62 7.62 0 003.31.81 5.63 5.63 0 002.84-.73c1.61-.93 1.84-2.2-.13-3.56a13 13 0 00-6.41-1.9z"
              style={{
                transformOrigin: "204.289px 375.713px",
              }}
              id="prefix__elzibupm714dk"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <path
              d="M207.12 374.81c-2-1.3-6-2.52-7.41-1.57s.89 3.4 3.11 4.51 4 1 5.14.25 1.04-1.91-.84-3.19z"
              style={{
                transformOrigin: "203.989px 375.738px",
              }}
              id="prefix__elfe8owjj4cps"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <path
              d="M204.93 374.34c-1.37-.92-4.26-1.79-5.25-1.12s.63 2.41 2.21 3.2 2.83.74 3.64.18.77-1.36-.6-2.26z"
              style={{
                transformOrigin: "202.721px 375px",
              }}
              id="prefix__elbxqr4dslyph"
              className="prefix__animable"
              fill="#fafafa"
            />
            <path
              d="M227.36 387.9l-18.44-10.19a5.8 5.8 0 01-1.18.68v.27l17.66 10.65c.54.31 2.09-.49 2.09-.95v-.27a.21.21 0 00-.13-.19z"
              style={{
                transformOrigin: "217.615px 383.545px",
              }}
              id="prefix__elmyi0u97zurk"
              className="prefix__animable"
              fill="#e0e0e0"
            />
            <g id="prefix__elxl8ezop5r5">
              <path
                d="M227.36 387.9l-18.44-10.19a6 6 0 01-1.18.68v.27l17.66 10.65c.54.31 2.09-.49 2.09-.95v-.27a.21.21 0 00-.13-.19z"
                style={{
                  transformOrigin: "217.615px 383.545px",
                }}
                className="prefix__animable"
                id="prefix__elq6jni7ygih"
                opacity={0.25}
              />
            </g>
            <path
              d="M225.4 389c.63.36 2.6-.77 2-1.14l-18.44-10.19a5.91 5.91 0 01-1.18.68z"
              style={{
                transformOrigin: "217.646px 383.37px",
              }}
              id="prefix__el5jmlvvk2e4v"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <path
              d="M209 378l16.55 9.1c1.25.69 2 1 1.22 1.47s-1.16.3-1.16.3a2 2 0 00.87-.3c.48-.31.07-.71-.86-1.15S209 378 209 378z"
              style={{
                transformOrigin: "218.044px 383.45px",
              }}
              id="prefix__el9alq7ie1t3a"
              className="prefix__animable"
              fill="#fafafa"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--speech-bubble-2--inject-40"
      className="prefix__animable"
      style={{
        transformOrigin: "336.175px 122.049px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedRight",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--speech-bubble--inject-40"
        className="prefix__animable"
        style={{
          transformOrigin: "336.175px 122.049px",
        }}
      >
        <g
          id="prefix__freepik--speech-bubble--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "336.175px 122.049px",
          }}
        >
          <path
            d="M327 154.48l-5.49-3.17a.51.51 0 01-.26-.22l-1-1.78 2.74-1.59h.42z"
            style={{
              transformOrigin: "323.625px 151.1px",
            }}
            id="prefix__elsdh925vc0en"
            className="prefix__animable"
            fill="#e0e0e0"
          />
          <path
            d="M327.27 154.07a.07.07 0 01-.06 0l-4-7-7.73 4.48a5.44 5.44 0 01-4.81 0l-.57-.35a5.41 5.41 0 01-2.41-4.17V122a5.4 5.4 0 012.4-4.16L357 90.65a5.36 5.36 0 014.81 0l.57.34a5.42 5.42 0 012.41 4.17v25c0 1.6 0 2.76-2.15 4l-31.19 18.08-4.12 11.76z"
            style={{
              transformOrigin: "336.24px 122.078px",
            }}
            id="prefix__elbciobc4cbuj"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M359.37 90.58a4.41 4.41 0 012.13.49l.6.36a4.91 4.91 0 012.15 3.73v25c0 1.59 0 2.47-1.91 3.55l-31 18-.32.19-.12.35-3.73 10.75-3.32-5.75-.5-.87-.87.51-7.29 4.22a4.9 4.9 0 01-4.29 0l-.6-.36a4.92 4.92 0 01-2.15-3.73V122a5 5 0 012.15-3.73l46.91-27.15a4.45 4.45 0 012.16-.5m0-1a5.4 5.4 0 00-2.66.64l-46.91 27.11a5.86 5.86 0 00-2.65 4.59v25a5.88 5.88 0 002.65 4.6l.58.35a5.44 5.44 0 002.65.63 5.5 5.5 0 002.66-.63l7.29-4.23 3.79 6.58a.56.56 0 00.49.28.56.56 0 00.54-.38l4-11.6 31-18c2.38-1.36 2.4-2.73 2.4-4.42v-25a5.86 5.86 0 00-2.65-4.59l-.58-.35a5.33 5.33 0 00-2.65-.64z"
            style={{
              transformOrigin: "336.175px 122.049px",
            }}
            id="prefix__el927n046t81r"
            className="prefix__animable"
            fill="#e0e0e0"
          />
          <path
            d="M365.16 94.41c-.31-1.13-1.33-1.49-2.56-.78l-46.91 27.15a5.29 5.29 0 00-1.87 2l-5.89-3.42a5.5 5.5 0 011.87-2l46.91-27.15a5.91 5.91 0 015.31 0l.58.35a5.86 5.86 0 012.56 3.85z"
            style={{
              transformOrigin: "336.545px 106.18px",
            }}
            id="prefix__eldlsufzfwkcb"
            className="prefix__animable"
            fill="#ebebeb"
          />
          <path
            d="M307.15 147a5.88 5.88 0 002.65 4.6l.58.35a5.93 5.93 0 004.85.22c-1.24.47-2.2-.24-2.2-1.75v-25a5.43 5.43 0 01.78-2.62l-5.88-3.41a5.43 5.43 0 00-.78 2.61z"
            style={{
              transformOrigin: "311.19px 135.988px",
            }}
            id="prefix__el68ea7tlfp3a"
            className="prefix__animable"
            fill="#e0e0e0"
          />
        </g>
        <path
          d="M321.76 132.4a7.33 7.33 0 01.25-1.89 9 9 0 01.72-1.82 8.31 8.31 0 011.06-1.57 5.24 5.24 0 011.3-1.09 2.65 2.65 0 011.31-.41 1.64 1.64 0 011.06.34 2.24 2.24 0 01.71 1 4.41 4.41 0 01.26 1.59 7.35 7.35 0 01-.26 1.89 9.16 9.16 0 01-.71 1.82 8.31 8.31 0 01-1.06 1.57 5.28 5.28 0 01-1.31 1.09 2.62 2.62 0 01-1.3.41 1.64 1.64 0 01-1.06-.34 2.25 2.25 0 01-.72-1 4.42 4.42 0 01-.25-1.59z"
          style={{
            transformOrigin: "325.095px 130.475px",
          }}
          id="prefix__eltdyn6bst9he"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M334.8 124.87a7.2 7.2 0 01.25-1.88 9 9 0 01.72-1.83 7.51 7.51 0 011.06-1.56 5.08 5.08 0 011.3-1.1 2.76 2.76 0 011.31-.41 1.72 1.72 0 011.06.34 2.24 2.24 0 01.71 1 4.41 4.41 0 01.26 1.59 7.35 7.35 0 01-.26 1.89 9 9 0 01-.71 1.83 8.73 8.73 0 01-1.06 1.56 5.07 5.07 0 01-1.31 1.09 2.62 2.62 0 01-1.3.41 1.62 1.62 0 01-1.06-.33 2.29 2.29 0 01-.72-1 4.42 4.42 0 01-.25-1.6z"
          style={{
            transformOrigin: "338.135px 122.946px",
          }}
          id="prefix__eltsyxttqm5zc"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M347.83 117.34a7.34 7.34 0 01.26-1.88 9 9 0 01.71-1.83 8.38 8.38 0 011.06-1.56 5.33 5.33 0 011.31-1.1 2.72 2.72 0 011.3-.41 1.68 1.68 0 011.06.34 2.18 2.18 0 01.72 1 4.46 4.46 0 01.25 1.59 7.33 7.33 0 01-.25 1.89 8.5 8.5 0 01-.72 1.83 7.51 7.51 0 01-1.06 1.56 5.29 5.29 0 01-1.3 1.1 2.76 2.76 0 01-1.31.41 1.72 1.72 0 01-1.06-.34 2.24 2.24 0 01-.71-1 4.43 4.43 0 01-.26-1.6z"
          style={{
            transformOrigin: "351.165px 115.42px",
          }}
          id="prefix__el528gsy3vf7r"
          className="prefix__animable"
          fill="#e0e0e0"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--speech-bubble-1--inject-40"
      className="prefix__animable"
      style={{
        transformOrigin: "101.56px 417.805px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--speech-bubble--inject-40"
        className="prefix__animable"
        style={{
          transformOrigin: "101.56px 417.805px",
        }}
      >
        <g
          id="prefix__freepik--speech-bubble--inject-40"
          className="prefix__animable"
          style={{
            transformOrigin: "101.56px 417.805px",
          }}
        >
          <path
            d="M77.06 451.3v-44.74c0-.84.58-1.86 2.29-2.84l40-23.08c-.26.15.91.16 1.64.58l3.75 2.21a2.94 2.94 0 011.31 2.29v44.73a2.92 2.92 0 01-1.31 2.28l-40 23.07a2.85 2.85 0 01-2.62 0l-3.75-2.2a3 3 0 01-1.31-2.3z"
            style={{
              transformOrigin: "101.555px 418.379px",
            }}
            id="prefix__el4t2a4w0nfsd"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__elk426hoyddh">
            <path
              d="M126.06 385.72a3 3 0 00-1.31-2.3l-3.76-2.2c-.71-.42-1.89-.43-1.63-.58l-40 23.08c-1.36.78-1.69 1.16-1.93 1.6l6.42 3.68a2.7 2.7 0 01.93-1l39-22.51c1.63-.92 2.28-.67 2.28.23z"
              style={{
                transformOrigin: "101.745px 394.82px",
              }}
              className="prefix__animable"
              id="prefix__elzdob8op3wwq"
              fill="#fff"
              opacity={0.3}
            />
          </g>
          <g id="prefix__el844ex4dalzn">
            <path
              d="M84.53 455.91c-.63.24-1.1-.11-1.1-.87v-44.73a2.77 2.77 0 01.38-1.3l-6.4-3.7a2.57 2.57 0 00-.35 1.25v44.74a2.93 2.93 0 001.31 2.29l3.75 2.2a2.9 2.9 0 002.41.12z"
              style={{
                transformOrigin: "80.795px 430.713px",
              }}
              className="prefix__animable"
              id="prefix__elh3oum653t4n"
              opacity={0.15}
            />
          </g>
          <path
            d="M105.06 383.07c-.83-.47-5.62-3.31-5.82-3.43a1.23 1.23 0 00-1.76.71L92 396.45l6.41 3.73 5-16.39a1.23 1.23 0 011.65-.72z"
            style={{
              transformOrigin: "98.53px 389.835px",
            }}
            id="prefix__elkqf53desf1"
            className="prefix__animable"
            fill="#22c4d6"
          />
          <g id="prefix__elzfx1421lwu">
            <path
              d="M105.06 383.07c-.83-.47-5.62-3.31-5.82-3.43a1.23 1.23 0 00-1.76.71L92 396.45l6.41 3.73 5-16.39a1.23 1.23 0 011.65-.72z"
              style={{
                transformOrigin: "98.53px 389.835px",
              }}
              className="prefix__animable"
              id="prefix__eldw4mfe1k12d"
              opacity={0.15}
            />
          </g>
          <path
            d="M83.43 455v-44.73a2.89 2.89 0 011.35-2.27l13.61-7.86 5-16.38a1.18 1.18 0 012.13-.35l4.78 9.88 14.44-8.29c.73-.42 1.32-.08 1.32.76v44.73a2.92 2.92 0 01-1.31 2.28l-40 23.07c-.75.38-1.32.04-1.32-.84z"
            style={{
              transformOrigin: "104.745px 419.435px",
            }}
            id="prefix__el6ha2ucmcv15"
            className="prefix__animable"
            fill="#22c4d6"
          />
        </g>
        <path
          d="M99.83 440.44a7 7 0 01-3.58-.94c-3-1.74-4.76-5.75-4.76-11 0-9.81 6-21.25 13.37-25.51 3.3-1.9 6.5-2.15 9-.69 3 1.74 4.76 5.75 4.76 11 0 9.81-6 21.25-13.37 25.51a11 11 0 01-5.42 1.63zm10.47-38.25a10.19 10.19 0 00-5 1.52c-7.14 4.12-13 15.24-13 24.79 0 4.94 1.59 8.69 4.35 10.29 2.25 1.3 5.17 1 8.2-.7 7.14-4.12 13-15.24 13-24.79 0-4.95-1.58-8.7-4.34-10.29a6.27 6.27 0 00-3.21-.82z"
          style={{
            transformOrigin: "105.055px 420.9px",
          }}
          id="prefix__el0vrtt4zdf81e"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M112.49 414.46l-5.81 3.36v-7.75c0-.79-.48-1.15-1.07-.81l-1.09.62a2.59 2.59 0 00-1.07 2.05v7.75L97.64 423a2.55 2.55 0 00-1.07 2v1.45c0 .78.48 1.15 1.07.81l5.81-3.36v7.75c0 .79.48 1.15 1.07.81l1.09-.63a2.55 2.55 0 001.07-2v-7.75l5.81-3.36a2.57 2.57 0 001.07-2v-1.45c0-.79-.48-1.15-1.07-.81z"
          style={{
            transformOrigin: "105.065px 420.86px",
          }}
          id="prefix__elbpdhtybw58q"
          className="prefix__animable"
          fill="#fafafa"
        />
      </g>
    </g>
    <defs>
      <filter id="prefix__active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="prefix__hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="red" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0" />
      </filter>
    </defs>
  </svg>

);

export default ContactIcon;
